import type { Translations } from './en';

// Validated against the English source-of-truth shape (`Translations = typeof en`).
const plural = (n: number, one: string, few: string, many: string): string => {
  const form = new Intl.PluralRules('pl').select(n);
  return form === 'one' ? one : form === 'few' ? few : many;
};

export const pl: Translations = {
  back: 'Wstecz',
  save: 'Zapisz zmiany',
  saveShort: 'Zapisz',
  createShort: 'Utwórz',
  saving: 'Zapisywanie…',
  loading: 'Ładowanie…',
  cancel: 'Anuluj',
  ok: 'OK',
  confirm: 'Potwierdź',
  close: 'Zamknij',
  edit: 'Edytuj',
  delete: 'Usuń',
  no: 'Nie',
  error: 'Coś poszło nie tak',
  saved: 'Zapisano',
  prevMonth: 'Poprzedni miesiąc',
  nextMonth: 'Następny miesiąc',
  pickDate: 'Wybierz datę',

  signOut: 'Wyloguj się',
  signOutConfirm: 'Czy na pewno chcesz się wylogować?',
  versionCopied: 'Skopiowano wersję',
  versionCopyHint: 'Dotknij, aby skopiować wersję',
  companyCredit:
    'Oprogramowanie i prawa autorskie należą do Ninety Six Digital. Aby dowiedzieć się więcej o reklamie, oprogramowaniu do zarządzania biznesem i rozwiązaniach AI, skontaktuj się z nami przez',
  companyCreditAnd: 'i',

  unsavedChangesTitle: 'Odrzucić zmiany?',
  unsavedChangesText: 'Masz niezapisane zmiany. Czy chcesz je odrzucić?',
  discardChanges: 'Odrzuć',

  payments: {
    title: 'Płatności',
    onlineTitle: 'Dostawcy płatności online',
    intro:
      'Gotowi dostawcy (PayPal, Menucat). Połącz dowolnie wielu - każdy włączony dostawca pojawia się jako osobny wybór w kasie, a płatność jest pobierana automatycznie i trafia na Twoje konto.',
    paymentWindowTitle: 'Okno płatności',
    paymentWindowFooter:
      'Jak długo nieopłacone zamówienie pozostaje otwarte, aby klient mógł przelać środki i przesłać potwierdzenie. Po tym czasie jest automatycznie anulowane i nie można już przesłać potwierdzenia. Ustawiane osobno dla każdego typu zamówienia.',
    paymentWindowDialogTitle: 'Minuty na zapłatę (1–1440)',
    paymentWindowPrompt: (label: string) =>
      `Ile minut zamówienie ${label} ma czekać na płatność, zanim zostanie anulowane?`,
    paymentWindowValue: (mins: number) => `Anulowanie ${mins} min po złożeniu`,
    paymentWindowSet: (label: string, mins: number) =>
      `${label}: nieopłacone zamówienia anulują się po ${mins} min`,
    paymentWindowInvalid: 'Podaj całkowitą liczbę minut od 1 do 1440.',
    manualTitle: 'Metody płatności dodane przez Ciebie',
    manualIntro:
      'Przelew, VietQR lub e-portfel, które konfigurujesz samodzielnie - wpisujesz dane konta i QR, klient płaci offline i wgrywa potwierdzenie. W przeciwieństwie do dostawców powyżej, te nie są pobierane automatycznie.',
    none: 'Nie połączono jeszcze żadnego dostawcy płatności.',
    connect: '+ Połącz dostawcę',
    update: 'Edytuj',
    live: 'Live',
    testMode: 'Tryb testowy',
    providerPaypal: 'PayPal Business',
    providerPaycat: 'Menucat (płatności kartą)',
    activatedToast: 'Używany teraz w kasie online',
    deactivatedToast: 'Kasa online wyłączona',
    connectTitle: 'Połącz dostawcę',
    updateTitle: 'Edytuj połączenie',
    providerLabel: 'Dostawca',
    paypalChoice: 'PayPal Business',
    paycatChoice: 'Menucat',
    paypalCredsTitle: 'Dane API PayPal',
    clientId: 'Client ID',
    clientIdPlaceholder: 'Z Twojej aplikacji PayPal Business',
    secret: 'Secret',
    secretPlaceholder: 'Wklej secret aplikacji',
    webhookId: 'Webhook ID (opcjonalnie)',
    webhookIdPlaceholder: 'Włącza natychmiastowe potwierdzenie płatności',
    paypalFooter:
      'Utwórz aplikację REST w swoim koncie PayPal Business (Developer Dashboard) i wklej tutaj jej Client ID oraz Secret. Płatności trafią bezpośrednio na Twoje konto PayPal.',
    webhookFooter:
      'Podczas łączenia webhook jest automatycznie rejestrowany w PayPal, aby od razu potwierdzać opłacone zamówienia - bez żadnej konfiguracji. Jeśli nie uda się go zarejestrować, zamówienia i tak zostaną potwierdzone, tylko nieco wolniej (sprawdzane co minutę).',
    paycatCredsTitle: 'Dane Paycat',
    serviceUrl: 'URL usługi',
    tenantId: 'Tenant ID',
    tenantSecret: 'Tenant secret',
    settingsTitle: 'Ustawienia',
    useForCheckout: 'Użyj w kasie online',
    useForCheckoutHelp:
      'Udostępnia tego dostawcę w kasie. Dostawcy działają równolegle - włączenie tego nie wyłącza pozostałych, a klient wybiera. Wykluczają się tylko klucze testowe i live TEGO dostawcy.',
    settingsFooter:
      'Włączenie „Użyj w kasie online” udostępnia tego dostawcę - w trybie wybranym powyżej - obok pozostałych, które już działają. Wpisz klucze live z włączoną opcją, aby przełączyć tego dostawcę na tryb live w jednym kroku.',
    errNoWhitespace: 'Usuń spacje — klucze API ich nie zawierają.',
    errClientIdEmail: 'To wygląda na Twój e-mail logowania PayPal, a nie Client ID aplikacji REST.',
    errInvalidUrl: 'Wpisz prawidłowy adres https://.',
    errCheck: 'Sprawdź to.',
    connectFailed: 'Nie udało się połączyć dostawcy płatności. Spróbuj ponownie.',
    connectedToast: 'Połączono dostawcę płatności',
    unsavedTitle: 'Niezapisane',
    unsavedText: (name) => `Wpisano dane dla ${name}. Zapisać czy odrzucić i przełączyć?`,
    save: 'Zapisz',
    discardSwitch: 'Odrzuć i przełącz',
    cancel: 'Anuluj',
    disconnect: 'Rozłącz',
    disconnectConfirm:
      'Rozłączyć tego dostawcę? Zapisane dane zostaną usunięte - aby połączyć ponownie, trzeba wpisać je od nowa.',
    disconnectedToast: 'Rozłączono dostawcę',
    notConnected: 'Niepołączony',
    connectShort: 'Połącz',
    overwriteNote:
      'Ten dostawca jest już połączony. Zapis nadpisze zapisane połączenie - na dostawcę przypada tylko jedno.',
    modeTest: 'Sandbox',
    modeLive: 'Live',
    stateConnected: 'Połączony',
    stateActive: 'Aktywny - klienci płacą tutaj',
    sandboxBannerTitle: 'Tryb sandbox jest aktywny',
    sandboxBannerBody:
      'Twój sklep działa w TRYBIE SANDBOX - klienci NIE są obciążani prawdziwymi pieniędzmi. Przełącz aktywnego dostawcę na Live, aby przyjmować prawdziwe płatności.',
    modeSectionTitle: 'Klucze sandbox lub live',
    modeSectionFooter:
      'Wybierz, który zestaw kluczy wpisujesz. Sandbox korzysta ze środowiska testowego dostawcy i nigdy nie pobiera prawdziwych pieniędzy; Live przyjmuje prawdziwe płatności. Możesz zapisać oba i przełączać się w dowolnej chwili.',
    modeHasCreds: 'Dla tego trybu są już zapisane klucze - zapis je nadpisze.',
    modeNoCreds: 'Brak zapisanych kluczy dla tego trybu.',
    downgradeTitle: 'Przełączyć na sandbox?',
    downgradeText:
      'Twój sklep PRZESTANIE przyjmować prawdziwe pieniądze i przełączy się w tryb SANDBOX (testowy). Kontynuować?',
    // ── Checkout badges: an owner-written pill beside ONE payment method ──
    badgesTitle: 'Etykiety przy płatnościach',
    badgesFooter:
      'Krótki dopisek obok metody płatności w koszyku, np. „Polecane”. Gość zobaczy dokładnie to, co wpiszesz.',
    badgeDialogTitle: 'Etykieta przy płatności',
    badgePrompt: (method: string) =>
      `Tekst obok ${method} w koszyku. Zostaw puste, aby usunąć etykietę.`,
    badgeNone: 'Brak etykiety',
    badgeTooLong: (max: number) => `Maksymalnie ${max} znaków.`,
    badgeSetToast: (method: string) => `Dodano etykietę do ${method}`,
    badgeClearedToast: (method: string) => `Usunięto etykietę z ${method}`,
    badgeMethodCash: 'Gotówka',
    badgeMethodCardOnHandoff: 'Karta przy odbiorze / dostawie',
  },

  nav: {
    operations: 'Operacje',
    functionality: 'Funkcje',
    reservations: 'Rezerwacje',
    orders: 'Zamówienia',
    tables: 'Stoliki',
    customers: 'Klient',
    menu: 'Menu',
    discount: 'Rabat',
    reports: 'Raporty',
    customerService: 'Obsługa klienta',
    settings: 'Ustawienia',
    actionCenter: 'Centrum akcji',
    pendingQueue: 'Kolejka oczekujących',
    aiAssistant: 'Asystent AI',
    inbox: 'Skrzynka odbiorcza',
    collapse: 'Zwiń',
    expand: 'Rozwiń',
  },

  views: {
    list: 'Lista',
    timeline: 'Oś czasu',
    week: 'Tydzień',
    plan: 'Plan',
  },

  settings: {
    title: 'Ustawienia',
    searchSettings: 'Szukaj ustawień',
    dashboard: 'Pulpit',
    account: 'Konto',
    email: 'E-mail',
    restaurant: 'Restauracja',
    reservations: 'Rezerwacje',
    capacity: 'Pojemność',
    tables: 'Stoliki',
    tablePlan: 'Plan stolików',
    menu: 'Menu',
    menus: 'Menu, kategorie i dania',
    myRestaurant: 'Moja restauracja',
    storefront: 'Sklep',
    notifications: 'Powiadomienia',
    pushNotifications: 'Powiadomienia push',
    restaurantSetup: 'Profil firmy',
    switchRestaurant: 'Zmień restaurację',
    searchRestaurants: 'Szukaj restauracji',
    noRestaurantsMatch: 'Brak pasujących restauracji',
    switchRestaurantConfirm: 'Przełączyć na inną restaurację?',
    language: 'Język',
    mail: {
      title: 'Powiadomienia',
      reservationTitle: 'Rezerwacje',
      reservationCustomer: 'Wysyłaj gościom e-maile o rezerwacji',
      reservationOwner: 'Powiadomienie w aplikacji dla Ciebie i personelu o nowych rezerwacjach',
      reservationOwnerEmail: 'E-mail do Ciebie i personelu o nowych rezerwacjach',
      reservationReminder: 'Wyślij gościom e-mailowe przypomnienie o rezerwacji',
      customerPickupTitle: 'E-mail do klienta o zamówieniach na odbiór',
      customerDeliveryTitle: 'E-mail do klienta o zamówieniach z dostawą',
      ownerPickupTitle: 'E-mail do Ciebie i personelu o zamówieniach na odbiór',
      ownerDeliveryTitle: 'E-mail do Ciebie i personelu o zamówieniach z dostawą',
      pushPickupTitle: 'Powiadomienie w aplikacji o zamówieniach na odbiór',
      pushDeliveryTitle: 'Powiadomienie w aplikacji o zamówieniach z dostawą',
      customerGroup: 'E-maile do klienta',
      ownerGroup: 'Powiadomienie w aplikacji dla Ciebie i personelu',
      byOrderType: 'wg typu zamówienia',
      byPayment: 'wg metody płatności',
      ownerEmailGroup: 'E-mail do Ciebie i personelu',
      allMaster: 'Wszystkie metody płatności',
      cash: 'Gotówka',
      manual: 'Przelew',
      online: 'Karta / PayPal',
      customerNote:
        'Wył. = gość nie otrzyma e-maila dla tej metody płatności. Status zamówienia w aplikacji nadal się aktualizuje.',
      ownerNote:
        'Wył. = brak powiadomień push/skrzynki dla Ciebie i personelu o nowych zamówieniach opłaconych w ten sposób.',
    },
  },

  notifications: {
    title: 'Powiadomienia push',
    statusTitle: 'Status powiadomień',
    deviceIphone: 'Ten iPhone lub iPad',
    deviceAndroid: 'To urządzenie z Androidem',
    deviceBrowser: 'Ta przeglądarka',
    statusOn: 'Wł.',
    statusOnDetail: 'Będziesz otrzymywać alerty na tym urządzeniu w czasie rzeczywistym.',
    statusOff: 'Wył.',
    statusOffDetail:
      'Alerty nie są jeszcze włączone. Włącz je, aby otrzymywać powiadomienia w czasie rzeczywistym.',
    statusBlocked: 'Zablokowane',
    statusBlockedNative:
      'Powiadomienia są zablokowane. Włącz je dla tej aplikacji w Ustawieniach urządzenia.',
    statusBlockedWeb:
      'Powiadomienia są zablokowane. Włącz je w ustawieniach witryny w przeglądarce, a następnie odśwież tę stronę.',
    statusBrowserBlocked: 'Zablokowane przez przeglądarkę',
    statusBrowserBlockedDetail:
      'Ta przeglądarka blokuje powiadomienia push. W Brave otwórz Ustawienia → Prywatność i bezpieczeństwo i włącz „Use Google services for push messaging”, a potem uruchom Brave ponownie. Możesz też użyć Chrome lub aplikacji na telefon.',
    statusUnsupported: 'Nieobsługiwane',
    statusUnsupportedDetail: 'Ta przeglądarka nie może odbierać powiadomień push.',
    statusUnconfigured: 'Niedostępne',
    statusUnconfiguredDetail: 'Powiadomienia push nie są skonfigurowane w tej wersji.',
    statusChecking: 'Sprawdzanie…',
    statusCheckingDetail: 'Sprawdzanie uprawnień do powiadomień…',
    enableButton: 'Włącz powiadomienia',
    reservationSection: 'Rezerwacje',
    newBooking: 'Nowa rezerwacja',
    cancellation: 'Anulowanie przez gościa',
    noShow: 'Alert o niestawieniu się',
    orderSection: 'Zamówienia online',
    prepSection: 'Czas kuchni',
    prepReminder: 'Przypomnienie o rozpoczęciu przygotowania',
    prepReminderHint:
      'Powiadamia zespół, gdy trzeba zacząć przygotowywać zamówienie z wyprzedzeniem - liczone wstecz od godziny odbioru.',
    hint: 'Wybierz zdarzenia, o których chcesz być informowany na bieżąco. Alerty docierają tylko, gdy status powyżej pokazuje „Wł.".',
    testSection: 'Powiadomienie testowe',
    testDelayTitle: 'Wyślij po',
    testDelaySeconds: (n) => `${n} sekundach`,
    testButton: 'Wyślij powiadomienie testowe',
    testHint:
      'Naciśnij przycisk i wyjdź z aplikacji - testowe powiadomienie dotrze na to urządzenie po wybranym czasie.',
    testPushTitle: 'Powiadomienie testowe',
    testPushBody: 'Powiadomienia push działają na tym urządzeniu.',
    testScheduled: (n) => `Powiadomienie testowe w drodze - dotrze za ${n} sekund.`,
    testNoDevice: 'Nie zarejestrowano jeszcze żadnego urządzenia. Najpierw włącz powiadomienia.',
  },

  reservations: {
    pause: {
      cellLabel: 'Rezerwacje',
      open: 'Otwarte',
      off: 'Wyłączone',
      pausedUntilClose: 'Wstrzymane · zamknięcie',
      pausedUntilTime: (time) => `Wstrzymane · ${time}`,
      action: {
        heading: 'Rezerwacje',
        pause30: 'Wstrzymaj na 30 minut',
        pause1hour: 'Wstrzymaj na 1 godzinę',
        pauseHours: (n) => `Wstrzymaj na ${n} godziny`,
        pauseUntilClose: 'Wstrzymaj do zamknięcia',
        resumeNow: 'Wznów teraz',
        cancel: 'Anuluj',
      },
      toast: {
        pausedFor: (minutes) => `Rezerwacje wstrzymane na ${minutes} min`,
        pausedUntilClose: 'Rezerwacje wstrzymane do zamknięcia',
        resumed: 'Rezerwacje wznowione',
      },
    },
    title: 'Rezerwacje',
    pending: 'Oczekujące',
    upcoming: 'Nadchodzące',
    today: 'Dziś',
    newReservation: 'Nowa rezerwacja',
    detailTitle: 'Rezerwacja',
    guest: 'Gość',
    guests: 'Goście',
    partyOf: 'Grupa',
    notes: 'Notatki',
    all: 'Wszystkie',
    filterAria: 'Filtr',
    status: {
      PENDING: 'Oczekująca',
      CONFIRMED: 'Potwierdzona',
      CANCELLED: 'Anulowana',
      REJECTED: 'Odrzucona',
      NO_SHOW: 'Niestawienie się',
      ARRIVED: 'Przybył',
      COMPLETED: 'Zakończona',
    },
    actions: {
      confirm: 'Potwierdź',
      reject: 'Odrzuć',
      cancel: 'Anuluj',
      noShow: 'Niestawienie się',
      arrived: 'Oznacz jako przybyłego',
    },
    count: (n) => `${n} ${n === 1 ? 'rezerwacja' : 'rezerwacji'}`,
    covers: (bookings, guests) =>
      `${bookings} ${bookings === 1 ? 'rezerwacja' : 'rezerwacji'} · ${guests} gości`,
    peak: (time, guests) => `Szczyt ${time} · ${guests} gości`,
    nextWindow: (guests) => `Najbliższe 2 godz.: ${guests} gości`,
    guestsCount: (guests) => `${guests} gości`,
    guestsByHour: 'Goście na godzinę',
    nowLabel: 'Teraz',
    slotCap: (n) => `maks. ${n}/slot`,
    advCap: (pacing, concurrent) => `${pacing}/15' · ${concurrent} równocześnie`,
    defaultShift: 'Domyślnie',
    // Badge labels keyed by DisplayStatus (see utils/status.ts). A future
    // confirmed-but-not-arrived booking is shown as `confirmed` instead of
    // `waiting`; that branch lives in getDisplayStatusLabel.
    displayStatus: {
      pending: 'Oczekująca',
      confirmed: 'Potwierdzona',
      rejected: 'Odrzucona',
      cancelled: 'Anulowana',
      rescheduled: 'Przełożona',
      waiting: 'Oczekiwanie',
      arrived: 'Przybył',
      seated: 'Przy stole',
      'in-progress': 'W trakcie',
      completed: 'Zakończona',
      'no-show': 'Niestawienie się',
    },
    occasion: {
      BIRTHDAY: '🎂 Urodziny',
      ANNIVERSARY: '💛 Rocznica',
      DATE: '🌹 Randka',
      BUSINESS: '💼 Biznesowa',
    },
    seating: {
      WINDOW: 'Przy oknie',
      OUTDOOR: 'Na zewnątrz',
      QUIET: 'Cichy kącik',
      BOOTH: 'Loża',
      BABY_CHAIR: 'Krzesełko dla niemowlęcia',
      HIGH_CHAIR: 'Wysokie krzesełko',
      WHEELCHAIR_ACCESS: 'Dostęp dla wózków',
      GROUND_FLOOR: 'Parter',
      NO_PREFERENCE: 'Bez preferencji',
    },
    swipe: { accept: 'Akceptuj', decline: 'Odrzuć' },
    toast: {
      confirmed: 'Rezerwacja potwierdzona',
      rejected: 'Rezerwacja odrzucona',
      cancelled: 'Rezerwacja anulowana',
      arrived: 'Oznaczono jako przybyłego',
      seated: 'Oznaczono jako przy stole',
      inProgress: 'Oznaczono jako w trakcie',
      completed: 'Oznaczono jako zakończoną',
      noShow: 'Oznaczono jako niestawienie się',
    },
    errors: {
      confirm: 'Nie udało się potwierdzić rezerwacji.',
      reject: 'Nie udało się odrzucić rezerwacji.',
      cancel: 'Nie udało się anulować rezerwacji.',
    },
    prompts: {
      rejectReason: 'Powód odrzucenia:',
      rejectTitle: 'Odrzuć rezerwację',
      cancelConfirm: 'Anulować tę rezerwację?',
      cancelTitle: 'Anuluj rezerwację',
    },
    empty: {
      errorTitle: 'Błąd ładowania rezerwacji',
      errorDesc: 'Spróbuj ponownie.',
      noneTitle: 'Brak rezerwacji',
      noneDesc: 'Brak rezerwacji na ten dzień.',
      timelineTitle: 'Jeszcze nic do wyświetlenia',
      timelineDesc:
        'Dodaj stoliki w konfiguracji pojemności, a rezerwacje pojawią się tutaj jako paski.',
      planTitle: 'Brak jeszcze stolików',
      planDesc: 'Dodaj stoliki w Ustawienia → Konfiguracja rezerwacji, aby zobaczyć plan sali.',
    },
    pendingQueue: {
      title: (n) => `Oczekujące (${n})`,
      emptyTitle: 'Wszystko obsłużone!',
      emptyDesc: 'Brak oczekujących rezerwacji do przejrzenia.',
      filterByDate: 'Filtruj wg daty',
      showAll: 'Pokaż wszystkie',
      emptyDateTitle: 'Brak w tym dniu',
      emptyDateDesc: 'Brak oczekujących rezerwacji dla wybranej daty.',
    },
    source: {
      ONLINE: 'Online',
      PHONE: 'Telefon',
      WALK_IN: 'Bez rezerwacji',
      THIRD_PARTY: 'Strona trzecia',
    },
    plan: {
      noZone: 'Brak strefy',
      seatCount: (seats) => `${seats} ${seats === 1 ? 'miejsce' : 'miejsc'}`,
      tableAria: (name, seats) => `Stolik ${name}, ${seats} miejsc`,
    },
    timeline: {
      unzoned: 'Bez strefy',
      unassignedCount: (n) => `Nieprzypisane · ${n}`,
    },
    week: {
      summary: (count, covers) => `${count} · ${covers} os.`,
      none: 'Brak rezerwacji',
    },
    detail: {
      labels: 'Etykiety',
      none: 'Nie wybrano rezerwacji',
      noneDesc: 'Wybierz rezerwację z listy, aby zobaczyć jej szczegóły tutaj.',
      notFound: 'Nie znaleziono rezerwacji',
      minutesShort: 'min',
      conflict: (n) =>
        `${n} ${plural(n, 'inna rezerwacja', 'inne rezerwacje', 'innych rezerwacji')} w tym przedziale czasowym`,
      call: 'Zadzwoń',
      message: 'Wiadomość',
      phoneCopied: 'Skopiowano numer telefonu',
      status: 'Status',
      specialRequests: 'Prośby specjalne',
      occasion: 'Okazja',
      seating: 'Miejsce i dostęp',
      guestInfo: 'Informacje o gościu',
      phone: 'Telefon',
      email: 'E-mail',
      source: 'Źródło',
      internalNote: 'Notatka wewnętrzna',
      cancellationReason: 'Powód anulowania',
      timeline: 'Oś czasu',
      events: {
        created: 'Utworzono',
        confirmed: 'Potwierdzono',
        arrived: 'Przybył',
        completed: 'Zakończono',
        cancelled: 'Anulowano',
        noShow: 'Niestawienie się',
      },
      aria: {
        close: 'Zamknij',
        call: 'Zadzwoń do gościa',
        message: 'Napisz do gościa',
        edit: 'Edytuj rezerwację',
      },
    },
    menu: {
      confirm: 'Potwierdź rezerwację',
      decline: 'Odrzuć rezerwację',
      cancel: 'Anuluj rezerwację',
      reactivate: 'Przywróć rezerwację',
      markArrived: 'Oznacz jako przybyłego',
      markSeated: 'Oznacz jako przy stole',
      markNoShow: 'Oznacz jako niestawienie się',
      markCompleted: 'Oznacz jako zakończoną',
      markNotStarted: 'Nie rozpoczęto',
      markInProgress: 'W trakcie',
      markRescheduled: 'Przełóż',
    },
  },

  audit: {
    orderKind: {
      CREATED: 'Złożono',
      CONFIRMED: 'Potwierdzono',
      COMPLETED: 'Zakończono',
      CANCELLED: 'Anulowano',
      PROOF_UPLOADED: 'Przesłano dowód płatności',
      PROOF_ACCEPTED: 'Zaakceptowano dowód płatności',
      PROOF_REJECTED: 'Odrzucono dowód płatności',
      PAYMENT_COLLECTED: 'Otrzymano płatność',
      PAYMENT_VOIDED: 'Unieważniono płatność',
      REFUND_ISSUED: 'Wystawiono zwrot',
      PREP_REMINDER_SENT: 'Wysłano przypomnienie o przygotowaniu',
      PREP_ADVANCED: 'Rozpoczęto przygotowanie',
      PREP_RECALLED: 'Cofnięto przygotowanie',
    },
    reservationEvent: {
      CREATED: 'Utworzono',
      CONFIRMED: 'Potwierdzono',
      REJECTED: 'Odrzucono',
      CANCELLED_BY_GUEST: 'Anulowano przez gościa',
      CANCELLED_BY_STAFF: 'Anulowano przez personel',
      MODIFIED: 'Zmodyfikowano',
      REACTIVATED: 'Ponownie aktywowano',
      AUTO_ARRIVED: 'Automatyczne przybycie',
      AUTO_COMPLETED: 'Automatyczne zakończenie',
      NO_SHOW_ALERTED: 'Zgłoszono niestawienie się',
      ARRIVAL_MARKED: 'Zaktualizowano przybycie',
      STATUS_CHANGED: 'Zmieniono status',
    },
    actor: {
      OWNER: 'Właściciel',
      STAFF: 'Personel',
      CUSTOMER: 'Klient',
      SYSTEM: 'System',
      GUEST: 'Gość',
    },
  },

  restaurantSetup: {
    title: 'Konfiguracja restauracji',
    basicInfo: 'Podstawowe informacje',
    hours: 'Godziny',
    basicInfoSection: 'Podstawowe informacje',
    venueLanguageSection: 'Język',
    venueLanguage: 'Język lokalu',
    venueLanguageFooter:
      'Język używany na drukowanych paragonach oraz jako domyślny w panelu i sklepie internetowym.',
    name: 'Nazwa restauracji',
    namePlaceholder: 'Moja restauracja',
    description: 'Opis',
    descriptionPlaceholder: 'Krótki opis widoczny dla klientów',
    address: 'Ulica i numer',
    addressPlaceholder: 'ul. Główna 123',
    postalCode: 'Kod pocztowy',
    postalCodePlaceholder: '10115',
    city: 'Miasto',
    cityPlaceholder: 'Berlin',
    country: 'Kraj',
    contactEmail: 'E-mail kontaktowy',
    contactEmailPlaceholder: 'kontakt@restauracja.pl',
    contactPhone: 'Telefon kontaktowy',
    contactPhonePlaceholder: '+48 555 000 000',
    contactPhoneInvalid: 'Podaj prawidłowy numer telefonu, np. +48 22 123 45 67.',
    socialSection: 'Media społecznościowe i strona WWW',
    facebookUrl: 'Facebook',
    facebookUrlPlaceholder: '@mojarestauracja',
    instagramUrl: 'Instagram',
    instagramUrlPlaceholder: '@mojarestauracja',
    tiktokUrl: 'TikTok',
    tiktokUrlPlaceholder: '@mojarestauracja',
    websiteUrl: 'Strona WWW',
    websiteUrlPlaceholder: 'mojarestauracja.pl',
    socialFooter:
      'Widoczne dla gości w Twoim sklepie online. Możesz wkleić pełny link albo samą nazwę profilu. Puste pole usuwa link.',
    openingHours: 'Godziny otwarcia',
    closed: 'Zamknięte',
    openingHoursNote:
      'Aby edytować godziny otwarcia, przejdź do ustawień Godzin otwarcia w panelu zaplecza lub skontaktuj się z pomocą techniczną.',
    saveFailed: 'Nie udało się zapisać',
  },

  editReservation: {
    title: 'Edytuj rezerwację',
    date: 'Data',
    time: 'Godzina',
    partySize: 'Liczba osób',
    duration: 'Czas trwania (min)',
    guestName: 'Imię i nazwisko gościa',
    guestEmail: 'E-mail gościa',
    guestPhone: 'Telefon gościa',
    internalNote: 'Notatka wewnętrzna',
    save: 'Zapisz',
    sectionWhen: 'Termin i grupa',
    sectionGuest: 'Gość',
    sectionOccasion: 'Okazja',
    sectionSeating: 'Miejsce i dostęp',
    sectionInternal: 'Wewnętrzne',
    guestNamePlaceholder: 'Imię i nazwisko gościa',
    notePlaceholder: 'Notatki personelu…',
    updated: 'Rezerwacja zaktualizowana',
    updateFailed: 'Nie udało się zaktualizować rezerwacji.',
  },

  createReservation: {
    fullName: 'Imię i nazwisko',
    namePlaceholder: 'np. Jan Kowalski',
    existingGuests: 'Istniejący goście - dotknij, aby użyć ponownie',
    searchExistingPlaceholder: 'Szukaj po nazwisku lub telefonie…',
    change: 'Zmień',
    sectionBooking: 'Rezerwacja',
    submit: 'Utwórz rezerwację',
    created: 'Rezerwacja utworzona',
    createFailed: 'Nie udało się utworzyć rezerwacji. Spróbuj ponownie.',
    nameRequired: 'Imię i nazwisko gościa jest wymagane.',
    nameInvalid: 'Imię i nazwisko gościa nie może zawierać cyfr ani znaków specjalnych.',
    emailInvalid:
      'Podaj prawidłowy e-mail, np. name@example.com - bez spacji i podwójnych kropek (..). Lub pozostaw puste.',
    phoneInvalid:
      'Podaj prawidłowy numer telefonu - od 7 do 14 cyfr, bez numeru kierunkowego kraju.',
    phoneRequired: 'Numer telefonu jest wymagany przy rezerwacjach telefonicznych.',
    timeInPast: 'Godzina rezerwacji już minęła. Wybierz późniejszą datę lub godzinę.',
    timeRequired: 'Podaj godzinę rezerwacji.',
    optional: '(opcjonalnie)',
    noRestaurant: 'Nie wybrano restauracji.',
    returningGuest: (n: number) => `Wcześniejsze wizyty: ${n}`,
    partySizeOverLimit: (max: number) => `Powyżej limitu ${max} gości`,
    partySizeOverLimitTitle: 'Duża grupa',
    partySizeOverLimitConfirm: (max: number) =>
      `Ta rezerwacja przekracza limit ${max} gości. Utworzyć mimo to?`,
    slotFullWarning: 'Ten przedział czasowy osiągnął limit pojemności.',
    slotFullTitle: 'Brak miejsc',
    slotFullConfirm:
      'Ten przedział czasowy osiągnął już limit pojemności. Utworzyć rezerwację mimo to?',
  },

  aiAssistant: {
    title: 'Asystent',
    conversations: 'Rozmowy',
    archived: 'Zarchiwizowane',
    noConversations: 'Brak rozmów.',
    untitled: 'Nowa rozmowa',
    newChat: 'Nowy czat',
    threadActions: 'Opcje rozmowy',
    loadingConversation: 'Wczytywanie rozmowy…',
    loadHistoryError: 'Nie udało się wczytać tej rozmowy.',
    loadThreadsError: 'Nie udało się wczytać rozmów.',
    retry: 'Spróbuj ponownie',
    greetingTitle: 'Dzień dobry',
    greetingBody: 'W czym mogę dziś pomóc?',
    attachImage: 'Dołącz zdjęcie',
    removeAttachment: 'Usuń załącznik',
    attachment: 'Zdjęcie',
    uploading: 'Przesyłanie…',
    uploadFailed: 'Przesyłanie nie powiodło się',
    inputPlaceholder: 'Napisz do asystenta…',
    send: 'Wyślij',
    stop: 'Zatrzymaj',
    sendFailed: 'Asystent nie mógł odpowiedzieć. Spróbuj ponownie.',
    rename: 'Zmień nazwę',
    archive: 'Archiwizuj',
    unarchive: 'Przywróć',
    delete: 'Usuń',
    cancel: 'Anuluj',
    deleteTitle: 'Usunąć tę rozmowę?',
    threadActionFailed: 'Nie udało się zaktualizować rozmowy.',
    approve: 'Zatwierdź',
    deny: 'Odrzuć',
    approvalPending: 'Czeka na Twoje zatwierdzenie',
    approvalDenied: 'Odrzucono',
    approvalRunning: 'Wprowadzanie…',
    approvalDone: 'Wprowadzono',
    approvalFailed: 'Nie udało się wprowadzić zmiany',
    toolWorking: 'Przetwarzanie…',
    toolFailed: 'Niepowodzenie',
    tools: {
      get_menu: 'Menu',
      get_item_availability: 'Dostępność dań',
      set_prices: 'Zmiana cen',
      set_item_availability: 'Zmiana dostępności',
      manage_products: 'Edycja dań',
      manage_categories: 'Edycja kategorii',
      list_reservations: 'Rezerwacje',
      get_reservation: 'Szczegóły rezerwacji',
      check_availability: 'Sprawdzenie dostępności',
      create_reservation: 'Nowa rezerwacja',
      cancel_reservation: 'Anulowanie rezerwacji',
      assign_tables: 'Przydział stolików',
      search_customers: 'Wyszukiwanie klientów',
      get_customer: 'Szczegóły klienta',
      create_customer: 'Nowy klient',
      get_opening_hours: 'Godziny otwarcia',
      get_profile: 'Profil restauracji',
      update_opening_hours: 'Zmiana godzin otwarcia',
      update_profile: 'Aktualizacja profilu',
      toggle_online_ordering: 'Zamówienia online',
      toggle_table_ordering: 'Zamówienia przy stoliku',
      get_table_state: 'Stan stolika',
      list_open_tabs: 'Otwarte rachunki',
      get_session: 'Szczegóły rachunku',
      fire_round: 'Wydanie rundy',
      void_item: 'Anulowanie pozycji',
      take_payment: 'Rejestracja płatności',
      close_tab: 'Zamknięcie rachunku',
      move_session: 'Przeniesienie rachunku',
      get_revenue: 'Sprzedaż',
      get_covers: 'Goście',
      get_top_dishes: 'Najlepsze dania',
      get_peak_hours: 'Godziny szczytu',
    },
    summary: {
      price: (name, price) => `${name}: ${price}`,
      inStock: (name) => `${name}: dostępne`,
      soldOut: (name) => `${name}: wyprzedane`,
      create: (name) => `Utwórz „${name}”`,
      update: (name) => `Edytuj „${name}”`,
      rename: (from, to) => `Zmień nazwę „${from}” na „${to}”`,
      remove: (name) => `Usuń „${name}”`,
      reservation: (name, date, time, party) => `${name} · ${date} ${time} · ${party} gości`,
      tables: (name, tables) => `${name}: ${tables}`,
      hoursDay: (day, hours) => `${day}: ${hours}`,
      closed: 'zamknięte',
      on: 'Wł.',
      off: 'Wył.',
      pickup: 'Odbiór',
      delivery: 'Dostawa',
      table: (label) => `Stolik ${label}`,
      move: (from, to) => `Stolik ${from} → stolik ${to}`,
      cash: 'Gotówka',
      bankTransfer: 'Przelew',
      tip: (amount) => `Napiwek: ${amount}`,
      profileFields: {
        name: 'Nazwa',
        address: 'Adres',
        phone: 'Telefon',
        email: 'E-mail',
        description: 'Opis',
      },
    },
    widgets: {
      reservationsTitle: (date) => `Rezerwacje · ${date}`,
      reservationsSummary: (count, guests) => `${count} rezerwacji · ${guests} gości`,
      noReservations: 'Brak rezerwacji.',
      partySize: (count) => `${count} gości`,
      status: {
        PENDING: 'Oczekująca',
        CONFIRMED: 'Potwierdzona',
        REJECTED: 'Odrzucona',
        CANCELLED: 'Anulowana',
      },
      revenueTitle: 'Sprzedaż',
      netSales: 'Sprzedaż netto',
      grossSales: 'Sprzedaż brutto',
      orders: 'Zamówienia',
      online: 'Online',
      dineIn: 'Na miejscu',
      covers: 'Goście',
      tips: 'Napiwki',
      availabilityTitle: 'Dostępność dań',
      availabilitySummary: (total, soldOut) => `${total} dań · ${soldOut} wyprzedanych`,
      soldOut: 'Wyprzedane',
      inactive: 'Ukryte',
    },
  },

  auth: {
    title: 'Panel restauracji',
    subtitle: 'Zaloguj się, aby zarządzać restauracją',
    emailLabel: 'E-mail',
    emailPlaceholder: 'ty@restauracja.pl',
    passwordLabel: 'Hasło',
    passwordPlaceholder: '••••••••',
    signInButton: 'Zaloguj się',
    validation: {
      emailPasswordRequired: 'Wprowadź swój e-mail i hasło.',
      invalidCredentials: 'Ten e-mail lub hasło nie działa. Spróbuj ponownie.',
    },
    selectRestaurant: {
      title: 'Wybierz restaurację',
      loading: 'Ładowanie Twoich restauracji...',
      empty: 'Nie znaleziono restauracji',
      noAccess: 'Twoje konto nie ma dostępu do żadnej restauracji.',
      loadError: 'Nie udało się załadować kontekstu użytkownika.',
    },
  },

  customers: {
    title: 'Klienci',
    searchPlaceholder: 'Szukaj po imieniu, e-mailu lub telefonie',
    loadingError: 'Nie udało się załadować klientów',
    loadingErrorDescription: 'Sprawdź połączenie i spróbuj ponownie.',
    noMatches: 'Brak dopasowań',
    noMatchesDescription: 'Żaden klient nie pasuje do tego wyszukiwania.',
    empty: 'Brak klientów',
    emptyDescription: 'Klienci pojawią się tutaj po dokonaniu rezerwacji lub zamówienia.',
    visitCount: (count) => `${count} ${count === 1 ? 'wizyta' : 'wizyt'}`,
    create: {
      title: 'Nowy klient',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      phone: 'Telefon',
      email: 'E-mail',
      dateOfBirth: 'Data urodzenia',
      notes: 'Notatki',
      required: 'Wymagane',
      optional: 'Opcjonalne',
      notesPlaceholder: 'Notatka o kliencie tylko dla personelu',
      submit: 'Dodaj klienta',
      submitting: 'Dodawanie…',
      fixErrors: 'Wypełnij wymagane pola.',
      requiredError: 'To pole jest wymagane.',
      invalidEmail: 'Wprowadź prawidłowy e-mail, np. name@example.com (pełny adres).',
      created: 'Klient utworzony',
      createdPhoneError: 'Klient utworzony - nie udało się zapisać telefonu',
      createFailed: 'Nie udało się utworzyć klienta. Spróbuj ponownie.',
    },
    detail: {
      title: 'Klient',
      done: 'Gotowe',
      loadingError: 'Nie udało się załadować klienta',
      profile: 'Profil',
      firstName: 'Imię',
      lastName: 'Nazwisko',
      emailLabel: 'E-mail',
      emailPlaceholder: 'Opcjonalnie',
      dateOfBirth: 'Data urodzenia',
      phoneNumbers: 'Numery telefonów',
      primary: 'Główny',
      noPhoneNumbers: 'Brak numerów telefonów',
      addPhoneButton: 'Dodaj numer telefonu',
      addPhoneDialog: 'Numer telefonu',
      phoneAdded: 'Numer telefonu dodany',
      removePhoneConfirm: (phone) => `Usunąć numer telefonu ${phone}?`,
      removePhoneDialog: 'Usuń numer telefonu',
      phoneRemoved: 'Numer telefonu usunięty',
      primarySet: 'Ustaw jako główny',
      removeAction: 'Usuń',
      notes: 'Notatki',
      notesPlaceholder: 'Notatka wewnętrzna o tym kliencie',
      activity: 'Aktywność',
      totalVisits: 'Łączna liczba wizyt',
      lastVisit: 'Ostatnia wizyta',
      status: 'Status',
      active: 'Aktywny',
      activeYes: 'Tak',
      activeNo: 'Nie',
      customerActivated: 'Klient aktywowany',
      customerDeactivated: 'Klient dezaktywowany',
      name: 'Imię i nazwisko',
      invalidValue: 'Nieprawidłowa wartość',
      deleteCustomer: 'Usuń klienta',
      deleteCustomerFallback: 'tego klienta',
      deleteCustomerConfirm: (who) => `Usunąć ${who}? Spowoduje to usunięcie go z listy klientów.`,
      deleteCustomerTitle: 'Usuń klienta',
      customerDeleted: 'Klient usunięty',
    },
  },

  emailFeature: {
    validation: {
      recipientRequired: 'Wprowadź adres e-mail odbiorcy.',
    },
  },

  giftCards: {
    title: 'Karty podarunkowe',
    issueSection: 'Wydaj kartę podarunkową',
    startingBalance: (currency) => `Saldo początkowe (${currency})`,
    recipientName: 'Imię odbiorcy (opcjonalnie)',
    recipientNamePlaceholder: 'Jan Kowalski',
    issuing: 'Wydawanie…',
    issueCard: 'Wydaj kartę',
    couldntLoadCards: 'Nie udało się załadować kart podarunkowych',
    noCardsYet: 'Brak kart podarunkowych',
    noCardsDescription:
      'Wydaj przedpłaconą kartę podarunkową, którą gość może wykorzystać na rachunek w restauracji. Dotknij +.',
    detailTitle: 'Karta podarunkowa',
    voidCardConfirm: (code) =>
      `Unieważnić ${code}? Pozostałe saldo przepada, a karta nie będzie mogła być dalej używana.`,
    voidCardTitle: 'Unieważnij kartę podarunkową',
    enterNonZeroAmount: 'Wprowadź kwotę różną od zera (poprzedź znakiem −, aby odliczyć).',
    reasonRequired: 'Powód jest wymagany.',
    balanceAdjusted: 'Saldo skorygowane',
    code: 'Kod',
    balance: 'Saldo',
    initial: 'Kwota początkowa',
    status: 'Status',
    recipient: 'Odbiorca',
    adjustBalance: 'Koryguj saldo',
    voidCard: 'Unieważnij kartę',
    adjustment: (currency) => `Korekta (${currency}, poprzedź znakiem −, aby odliczyć)`,
    adjustmentPlaceholder: '10,00 lub -5,00',
    reason: 'Powód',
    reasonPlaceholder: 'Gest dobrej woli / korekta',
    applying: 'Stosowanie…',
    apply: 'Zastosuj',
    history: 'Historia',
    enterStartingBalance: 'Wprowadź saldo początkowe.',
    cardIssued: (code) => `Karta podarunkowa ${code} wydana`,
    couldntLoadCard: 'Nie udało się załadować karty',
  },

  kitchen: {
    title: 'Kuchnia',
    sourceOnline: 'Zamówienie online',
    sourceDineIn: 'Na miejscu',
    bumpServed: 'Podane',
    bumpStart: 'Rozpocznij',
    bumpReady: 'Gotowe',
    recallAction: 'Przywróć',
    errorTitle: 'Nie udało się załadować tablicy',
    emptyTitle: 'Wszystko obsłużone',
    emptyDescription: 'Brak zamówień w kolejce.',
    laneCooking: 'W przygotowaniu',
    laneReadyToServe: 'Gotowe do podania',
  },

  loyalty: {
    title: 'Program lojalnościowy',
    pointsBalance: 'Saldo punktów',
    entryType: {
      earned: 'Zdobyte',
      redeemed: 'Wykorzystane',
      adjusted: 'Skorygowane',
    },
    validation: {
      nonZeroAmount: 'Wprowadź kwotę różną od zera.',
      reasonRequired: 'Powód jest wymagany.',
    },
    pointsAdjusted: 'Punkty skorygowane',
    adjustment: {
      label: 'Korekta (punkty, + lub −)',
      placeholder: 'np. 50 lub -20',
    },
    reason: {
      label: 'Powód',
      placeholder: 'Gest dobrej woli / korekta',
    },
    applyAdjustment: 'Zastosuj korektę',
    adjustPoints: 'Koryguj punkty',
    couldNotLoad: 'Nie udało się załadować ustawień lojalnościowych',
    program: 'Program lojalnościowy',
    earning: {
      title: 'Zdobywanie',
      label: (currency) => `Wydane ${currency} - zdobyte punkty`,
      info: (currency) => `np. 1 punkt za ${currency} wartości pozycji`,
    },
    redemption: {
      title: 'Wykorzystanie',
      label: (currency) => `Wartość 1 punktu (rabat ${currency})`,
      placeholder: '0,10',
      info: 'Goście wymieniają punkty na rabat przy płatności',
    },
    settingsSaved: 'Ustawienia lojalnościowe zapisane',
    info: {
      note: 'Punkty są zdobywane od wartości pozycji w zrealizowanym zamówieniu lub wizycie w restauracji (z wyłączeniem dostawy, podatków i napiwków). Wykorzystanie jest stosowane jako rabat na kolejne zamówienie.',
    },
  },

  menu: {
    title: 'Menu',
    noMenusYet: 'Brak menu',
    createMenuDescription: 'Utwórz menu, aby dodać sekcje i dania.',
    createMenu: 'Utwórz menu',
    menuNamePrompt: 'Nazwa menu (po angielsku)',
    newMenu: 'Nowe menu',
    menuCreated: 'Menu utworzone',
    renameMenu: 'Zmień nazwę menu',
    editMenuNameAvailability: 'Edytuj nazwę i dostępność',
    renamed: 'Nazwa zmieniona',
    cantDeleteActiveMenu: 'Aktywne menu nie może zostać usunięte',
    deleteMenuConfirm: (menuName) => `Usunąć "${menuName}" wraz ze wszystkimi sekcjami i daniami?`,
    deleteMenu: 'Usuń menu',
    setAsActiveMenu: 'Ustaw jako aktywne menu',
    isNowActive: (menuName) => `"${menuName}" jest teraz aktywne`,
    activeMenuInfo:
      'Tylko aktywne menu jest widoczne dla klientów. Dotknij menu, aby edytować jego sekcje i dania.',
    active: 'Aktywne',
    rename: 'Zmień nazwę',
    newCategory: 'Nowa kategoria',
    editCategory: 'Edytuj kategorię',
    categoryName: 'Nazwa',
    categoryDescription: 'Opis',
    channelVisibility: 'Pokaż w kanałach zamówień',
    channelVisibilityHelp:
      'Wyłącz, aby ukryć całą tę sekcję (i jej pozycje) dla tego typu zamówienia.',
    showOnPickup: 'Pokaż przy odbiorze',
    showOnDelivery: 'Pokaż przy dostawie',
    nameRequired: 'Nazwa wymagana',
    availabilitySchedule: 'Harmonogram dostępności',
    restrictToCertainTimes: 'Ogranicz do określonych godzin',
    window: (index) => `Okno ${index}`,
    from: 'Od',
    to: 'Do',
    addWindow: '+ Dodaj okno',
    scheduleNote:
      'Harmonogramy korzystają ze strefy czasowej restauracji i są niezależne od godzin otwarcia.',
    emptyMenu: 'Puste menu',
    addCategoryDescription: 'Dodaj kategorię, np. Napoje, Dania główne lub Desery.',
    addCategory: 'Dodaj kategorię',
    dragToReorder: 'Przeciągnij, aby zmienić kolejność kategorii',
    renameMenuTooltip: 'Zmień nazwę menu',
    doneReordering: 'Zakończ porządkowanie',
    reorderSections: 'Zmień kolejność kategorii',
    archivedItems: 'Zarchiwizowane pozycje',
    archivedItemsTitle: 'Zarchiwizowane pozycje',
    archivedItemsEmpty: 'Brak zarchiwizowanych pozycji',
    archivedItemsHint:
      'Usunięte pozycje są tu przechowywane. Przywróć pozycję, aby wróciła do menu.',
    restore: 'Przywróć',
    itemRestored: 'Pozycja przywrócona',
    reorderOptions: 'Zmień kolejność opcji',
    dragToReorderOptions: 'Przeciągnij, aby zmienić kolejność opcji',
    deleteMenuConfirmText: (menuName) => `Usunąć "${menuName}" wraz z całą zawartością?`,
    inactiveMenuNote:
      'To menu nie jest aktywne - klienci jeszcze go nie widzą. Użyj ⋯, aby je aktywować.',
    menuActivated: 'Menu aktywowane',
    addItem: 'Dodaj pozycję',
    searchItems: 'Szukaj pozycji',
    jumpToSection: 'Przejdź do sekcji',
    noItemsMatch: 'Brak pasujących pozycji',
    addMultiple: 'Dodaj wiele pozycji',
    newProducts: 'Nowe produkty',
    allergenLabeling: {
      title: 'Alergeny i dodatki',
      sectionTitle: 'Oznaczanie alergenów',
      sectionHelp: 'Skonfiguruj alergeny i dodatki wyświetlane przy Twoich daniach.',
      sectionSubtitle: 'Twoja tabela alergenów i lista kodów',
      modeHeading: 'Jak oznaczasz alergeny',
      modeNote: 'Wybierz, jak ta restauracja podaje alergeny. Możesz przełączyć w każdej chwili.',
      aboutMode: (title: string) => `O trybie ${title}`,
      simpleTitle: 'Wolna tabela',
      simpleFeatures: [
        'Wklej tekst lub prześlij jedno zdjęcie',
        'Goście widzą dokładnie to, co napisano',
        'Najprościej — nic do skonfigurowania',
      ],
      simpleDetails:
        'Twoja drukowana tabela alergenów/dodatków — tekst lub zdjęcie — jest pokazywana gościom jako źródło prawdy. Nic nie jest przetwarzane.',
      advancedTitle: 'Lista kodów',
      advancedFeatures: [
        'Lista Twoich kodów i znaczeń',
        'Dania odwołują się do Twoich kodów',
        'Czytelniejsze etykiety przy daniach',
      ],
      advancedDetails:
        'Prowadź uporządkowaną listę swoich kodów (np. a = Gluten). Oznacz każde danie jego kodami; goście widzą kod i jego znaczenie.',
      originTextLabel: 'Tekst lub uwagi',
      originTextPlaceholder: 'Wklej legendę jako tekst lub dodaj uwagi do zdjęcia…',
      originImageTitle: 'Zdjęcie tabeli',
      notesHint:
        'Opcjonalnie. Razem ze zdjęciem — np. „ikony S i R oznaczają wieprzowinę i wołowinę”.',
      uploadImage: 'Prześlij zdjęcie',
      replaceImage: 'Zmień zdjęcie',
      removeImage: 'Usuń',
      imageFailed: 'Przesyłanie zdjęcia nie powiodło się',
      tableTitle: 'Lista kodów',
      previewTitle: 'Podgląd kodów',
      previewHint: 'Z Twojej tabeli. Przełącz na „Lista kodów”, aby edytować.',
      previewEmptyText:
        'Kody pojawią się tutaj po dodaniu na liście kodów (lub odczytaniu z tabeli w czacie).',
      emptyTitle: 'Brak kodów',
      keyPlaceholder: 'Kod',
      descPlaceholder: 'Opis',
      addRow: 'Dodaj kod',
      removeRow: 'Usuń kod',
      saved: 'Zapisano',
      saveFailed: 'Nie udało się zapisać',
      parseFailed:
        'Zapisano, ale nie udało się odczytać kodów. Zapisz ponownie lub dodaj je na liście kodów.',
      duplicateKey: (key: string) => `Zduplikowany kod: ${key}`,
      kindLabel: (k: 'ALLERGEN' | 'ADDITIVE' | 'DIETARY'): string =>
        ({ ALLERGEN: 'Alergen', ADDITIVE: 'Dodatek', DIETARY: 'Dieta' })[k],
    },
    productForm: {
      noAllergenTable: 'Brak tabeli alergenów.',
      setUpAllergenTable: 'Skonfiguruj',
      searchAllergenCodes: 'Szukaj kodów…',
      editAllergenCodes: 'Edytuj kody',
      general: 'Ogólne',
      name: 'Nazwa',
      code: 'Kod pozycji',
      editCode: 'Edytuj kod pozycji',
      noCode: 'Brak',
      codePlaceholder: 'np. A12',
      codeTakenBy: (dish: string) => `Kod już użyty przez „${dish}”`,
      description: 'Opis',
      basePrice: 'Cena podstawowa',
      newProduct: 'Nowy produkt',
      editName: 'Edytuj nazwę',
      editDescription: 'Edytuj opis',
      options: 'Opcje',
      optionName: 'Nazwa opcji',
      optionNamePlaceholder: 'np. Rozmiar, Dodatki',
      required: 'Wymagane',
      allowMultiple: 'Zezwól na wielokrotny wybór',
      selectionLimits: 'Limity wyboru',
      minToPick: 'Minimalny wybór',
      maxToPick: 'Maksymalny wybór (puste = bez limitu)',
      choiceName: 'Nazwa wyboru',
      choiceNamePlaceholder: 'np. Duży, Dodatkowy ser',
      extraPrice: 'Dopłata',
      defaultSelection: 'Domyślny wybór',
      addChoice: 'Dodaj wybór',
      deleteChoice: 'Usuń wybór',
      noChoices: 'Brak wyborów',
      availability: 'Dostępność',
      visibleToCustomers: 'Widoczne dla klientów',
      hiddenChoicesFooter: 'Ukryte wybory nie są pokazywane klientom',
      hiddenProductsFooter: 'Ukryte produkty w ogóle nie pojawiają się w menu',
      inStock: 'Dostępne',
      outOfStockChoicesFooter: 'Niedostępne wybory są pokazywane, ale nie można ich zamówić',
      outOfStockProductsFooter: 'Niedostępne produkty są pokazywane, ale nie można ich zamówić',
      allergens: 'Alergeny',
      labels: 'Etykiety',
      pricing: 'Ceny',
      channelPrice: 'Cena kanału',
      channelPrices: 'Ceny kanałów',
      dineIn: 'Na miejscu',
      pickup: 'Odbiór',
      delivery: 'Dostawa',
      photo: 'Zdjęcie',
      addPhoto: 'Dodaj zdjęcie',
      replacePhoto: 'Zmień zdjęcie',
      removePhoto: 'Usuń zdjęcie',
      photoTooLarge: 'To zdjęcie jest za duże. Użyj pliku poniżej 10 MB.',
      photoWrongType: 'Nieobsługiwany format zdjęcia. Użyj JPEG, PNG, WebP lub HEIC.',
      photoUploadFailed: 'Nie udało się zapisać zdjęcia. Spróbuj ponownie.',
    },
    hideCategory: 'Ukryj kategorię',
    showCategory: 'Pokaż kategorię',
    deleteCategory: 'Usuń kategorię',
    deleteCategoryConfirm: (categoryName) => `Usunąć "${categoryName}" wraz z daniami?`,
    hidden: 'ukryte',
    outOfStock: 'Brak na stanie',
    plusAddItem: '+ Dodaj pozycję',
    newProduct: 'Nowy produkt',
    optionName: 'Nazwa opcji',
    optionNamePlaceholder: 'np. Rozmiar, Dodatki',
    required: 'Wymagane',
    allowMultipleSelections: 'Zezwól na wielokrotny wybór',
    minimumToPick: 'Minimalny wybór',
    maximumToPick: 'Maksymalny wybór (puste = bez limitu)',
    guestsPickRange: 'Goście wybierają w zakresie min/maks.',
    guestsPickOne: (required) =>
      `Goście wybierają dokładnie jedną${required ? '.' : ' (lub żadnej).'}`,
    selectionMode: 'Rodzaj wyboru',
    pickOneMode: 'Pojedynczy',
    pickManyMode: 'Wielokrotny',
    guestsPickAny: 'Goście wybierają dowolną liczbę (lub żadnej).',
    newChoice: 'Nowy wariant',
    editChoice: 'Edytuj wariant',
    choiceName: 'Nazwa wariantu',
    choiceNamePlaceholder: 'np. Duży, Dodatkowy ser',
    extraPrice: 'Dopłata',
    defaultSelection: 'Wybór domyślny',
    visibleToCustomers: 'Widoczne dla klientów',
    inStock: 'Na stanie',
    allergens: 'Alergeny',
    deleteChoice: 'Usuń wariant',
    deleteChoiceConfirm: (choiceName) => `Usunąć wariant "${choiceName}"?`,
    noChoicesYet: 'Brak wariantów',
    addChoice: 'Dodaj wariant',
    default: 'Domyślny',
    outOfStockChip: 'Brak na stanie',
    hiddenChip: 'Ukryte',
    editOption: 'Edytuj opcję',
    deleteOption: 'Usuń opcję',
    deleteOptionConfirm: (optionName) => `Usunąć opcję "${optionName}" wraz z jej wariantami?`,
    pricing: 'Ceny',
    basePrice: 'Cena podstawowa',
    basePriceFooter:
      'Domyślna cena katalogowa. Cenniki dla poszczególnych kanałów (dostawa/odbiór) zastępują ją tam, gdzie zostały ustawione.',
    noOverridesYet:
      'Cenniki dla poszczególnych kanałów (dostawa, odbiór...) są konfigurowane osobno; ten produkt nie ma jeszcze nadpisań.',
    noDescription: 'Brak opisu',
    general: 'Ogólne',
    options: 'Opcje',
    noOptionsYet: 'Brak opcji - ten produkt zamawia się bez zmian.',
    addOption: '+ Dodaj opcję',
    newOptions: 'Nowe opcje',
    newChoices: 'Nowe wybory',
    saveAllOptions: 'Zapisz wszystko',
    optionsSaved: 'Zapisano opcje',
    optional: 'Opcjonalne',
    optionNeedsChoice: 'Dodaj co najmniej jeden wybór przed zapisaniem tej opcji.',
    optionEditHint: 'Wybór bez ceny nie nalicza dopłaty.',
    optionLimits: {
      pickSeveral: 'Wybór wielu',
      limitHowMany: 'Ogranicz liczbę',
      minimum: 'Minimum',
      maximum: 'Maksimum',
      minPrompt: (lo: number, hi: number) =>
        `Ile co najmniej muszą wybrać goście? (${lo} do ${hi})`,
      maxPrompt: (lo: number, hi: number) => `Ile co najwyżej mogą wybrać goście? (${lo} do ${hi})`,
      notSaved: 'Nie zapisano',
      notInteger: 'Nie zapisano. Podaj liczbę całkowitą.',
      outOfRange: (field: string, lo: number, hi: number) =>
        `Nie zapisano. ${field} musi mieścić się w zakresie ${lo} do ${hi}.`,
      minAboveMax: (max: number) =>
        `Nie zapisano. Minimum nie może być większe niż maksimum (${max}).`,
      maxBelowMin: (min: number) =>
        `Nie zapisano. Maksimum nie może być mniejsze niż minimum (${min}).`,
      summary: {
        exactly: (n: number) => `Goście muszą wybrać dokładnie ${n}`,
        upTo: (n: number) => `Goście wybierają do ${n}`,
        range: (min: number, max: number) => `Goście wybierają od ${min} do ${max}`,
        atLeast: (n: number) => `Goście wybierają co najmniej ${n}`,
        any: 'Goście mogą wybrać dowolną liczbę lub nic',
      },
      phrase: {
        exactly: (n: number) => `wybierz ${n}`,
        upTo: (n: number) => `do ${n}`,
        range: (min: number, max: number) => `wybierz ${min}-${max}`,
        atLeast: (n: number) => `wybierz co najmniej ${n}`,
        any: 'wybierz dowolnie',
      },
      stockWarning: (inStock: number, total: number) =>
        `Tylko ${inStock} z ${total} na stanie - goście nie zamówią tego, dopóki nie uzupełnisz zapasów.`,
      legacy: {
        minAboveN: (min: number, n: number) =>
          `Minimum (${min}) jest większe niż liczba wyborów w grupie (${n}).`,
        maxAboveN: (max: number, n: number) =>
          `Maksimum (${max}) jest większe niż liczba wyborów w grupie (${n}).`,
        minAboveMax: (min: number, max: number) =>
          `Minimum (${min}) jest większe niż maksimum (${max}).`,
      },
      fixRule: 'Popraw regułę',
      clampTitle: 'Obniżyć limit?',
      clampBody: (option: string, choice: string, n: number, rule: string) =>
        `${option}: ${rule}. Bez ${choice} zostaje tylko ${n} wyborów, więc`,
      clampChange: {
        min: (n: number) => `minimum zmieni się na ${n}.`,
        max: (n: number) => `maksimum zmieni się na ${n}.`,
        both: (n: number) => `minimum i maksimum zmienią się na ${n}.`,
      },
      lowerAndDelete: (n: number) => `Obniż do ${n} i usuń`,
    },
    optionNameRequiredAll: 'Przed zapisaniem podaj nazwę każdej opcji.',
    optionNameDuplicate: (name: string) =>
      `Opcja „${name}” ma zduplikowaną nazwę. Każda opcja musi mieć inną nazwę.`,
    choiceNameRequiredAll: 'Przed zapisaniem podaj nazwę każdego wyboru.',
    choiceNameDuplicate: (name: string) =>
      `Wybór „${name}” ma zduplikowaną nazwę. Każdy wybór musi mieć inną nazwę.`,
    addOptionHint:
      'Każda opcja to grupa wyborów (np. Rozmiar, Dodatek). Dodaj kilka grup, a potem kliknij „Zapisz wszystko”; wartości w środku dodasz po zapisaniu.',
    availability: 'Dostępność',
    visibleToCustomersFooter: 'Ukryte produkty w ogóle nie pojawiają się w menu',
    inStockFooter: 'Niedostępne produkty są wyświetlane, ale nie można ich zamówić',
    labels: 'Etykiety',
    editName: 'Edytuj nazwę',
    editDescription: 'Edytuj opis',
    createProduct: 'Utwórz produkt',
    productCreated: 'Produkt utworzony',
    missingCategory: 'Brak sekcji - otwórz to z poziomu sekcji menu.',
    createProductNoteFooter: 'Po utworzeniu możesz dodać opis, alergeny, etykiety i opcje.',
    deleteProduct: 'Usuń produkt',
    deleteProductConfirm: (productName) => `Usunąć "${productName}" wraz z całą zawartością?`,
    product: 'Produkt',
    productNotFound: 'Nie znaleziono produktu.',
    englishNameRequired: 'Nazwa jest wymagana.',
    englishValueRequired: 'Wartość po angielsku jest wymagana',
    fieldRequired: 'To pole jest wymagane',
    newOption: 'Nowa opcja',
    channelPriceEditTitle: (channel: string) => `${channel} - cena`,
    channelPricesFooter:
      'Cena na miejscu jest ceną domyślną. Zostaw odbiór lub dostawę puste, aby jej użyć, albo wpisz kwotę, aby naliczać inną cenę dla tego kanału.',
    pricesSaved: 'Ceny zapisane',
    overridesBaseFooter: (base: string) =>
      `Nadpisuje cenę podstawową (${base}) tylko dla tego kanału. Wyczyść, aby wrócić do ceny podstawowej.`,
    useBasePrice: 'Użyj ceny podstawowej',
    basePriceSectionFooter: 'Domyślna cena oraz opcjonalne osobne ceny dla odbioru i dostawy.',
    priceFree: 'Gratis',
    failedToLoad: 'Nie udało się wczytać menu',
    notLiveAnywhereNote:
      'To menu nie jest aktywne w żadnym kanale zamówień - klienci jeszcze go nie widzą. Wybierz je dla kanału w Menu → Aktywne menu.',
    itemColumn: 'Pozycja',
    priceColumn: 'Cena',
    priceFrom: 'od',
    optionsCount: (n: number) => `${n} opcj${n === 1 ? 'a' : 'e'}`,
    allMenus: 'Wszystkie menu',
    allMenusHelp:
      'Powyższy panel wybiera, które menu pokazuje każdy kanał. Dotknij menu, aby edytować jego sekcje i dania.',
    editMenu: 'Edytuj menu',
    liveMenus: 'Aktywne menu',
    liveMenu: 'Aktywne menu',
    differentMenuPerChannel: 'Inne menu dla każdego kanału',
    assignMenuPerChannelHelp: 'Przypisz menu, które pokazuje każdy kanał zamówień.',
    liveMenuHelp: 'Menu widziane przez klientów na miejscu, przy odbiorze i dostawie.',
    menuFieldLabel: 'Menu',
    mixed: 'Mieszane',
    noneHidden: 'Brak - ukryte',
    noSelection: 'Brak',
    selectedCount: (n: number) => `Wybrano: ${n}`,
    category: 'Kategoria',
    items: 'Pozycje',
    addCategoryFirst: 'Najpierw dodaj kategorię.',
    addCategoryFirstThenItems: 'Najpierw dodaj kategorię, a potem dodaj do niej pozycje.',
    itemNameRequiredForPrice: 'Nazwa jest wymagana dla każdej pozycji z ceną.',
    enterAtLeastOneItem: 'Wprowadź przynajmniej jedną nazwę pozycji.',
    itemsAddedToast: (n: number) => `Dodano ${n} pozycj${n === 1 ? 'ę' : 'i'}`,
    itemNamePlaceholder: 'Nazwa pozycji *',
    basePriceAriaLabel: (currency: string) => `Cena podstawowa (${currency})`,
    removeItem: 'Usuń',
    addRow: 'Dodaj wiersz',
    addAnotherItem: 'Dodaj kolejną pozycję',
    simpleMode: 'Wiele pozycji',
    advancedMode: 'Jedna pozycja szczegółowo',
    groupName: 'Nazwa grupy',
    requiredGroupDefault: 'Wymagane',
    requiredChoicesHint: 'Wybierz co najmniej 1',
    optionalChoicesHint: 'Opcjonalne',
    optionalGroupDefault: 'Opcjonalne',
    dayLabelsShort: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
  },

  menuQuickEdit: {
    placeholder: 'Zapytaj AI, np. „podnieś ceny pizzy o 5%”',
    fullMenu: 'Całe menu',
    productPlaceholder: 'Zapytaj AI, np. „dodaj ser za 1,50”',
    tagNew: 'Nowe',
    tagRemoved: 'Usunięte',
    tagMoved: 'Przeniesione',
    shown: 'Widoczne',
    hidden: 'Ukryte',
    inStock: 'Dostępne',
    soldOut: 'Wyprzedane',
    isDefault: 'Domyślne',
    notDefault: 'Niedomyślne',
    basePrice: 'cena bazowa',
    hours: 'Godziny',
    always: 'Zawsze',
    allergens: 'Alergeny',
    labels: 'Etykiety',
    order: 'Kolejność',
    pickup: 'Odbiór',
    delivery: 'Dostawa',
    none: 'brak',
    rules: {
      required: 'wymagane',
      optional: 'opcjonalne',
      pickOne: 'wybierz 1',
      pickAny: 'dowolna liczba',
      pickUpTo: (n: number) => `wybierz do ${n}`,
      pickAtLeast: (n: number) => `wybierz co najmniej ${n}`,
      pickRange: (min: number, max: number) => `wybierz ${min}–${max}`,
    },
    summary: {
      items: (n: number) => `${n} ${plural(n, 'pozycja', 'pozycje', 'pozycji')}`,
      sections: (n: number) => `${n} ${plural(n, 'sekcja', 'sekcje', 'sekcji')}`,
      prices: (n: number) => `${n} ${plural(n, 'cena', 'ceny', 'cen')}`,
      added: (n: number) => `dodane: ${n}`,
      removed: (n: number) => `usunięte: ${n}`,
      renamed: (n: number) => `zmienione nazwy: ${n}`,
      descriptions: (n: number) => `opisy: ${n}`,
      moved: (n: number) => `przeniesione: ${n}`,
      stock: (n: number) => `dostępność: ${n}`,
      visibility: (n: number) => `widoczność: ${n}`,
      allergens: (n: number) => `alergeny: ${n}`,
      labels: (n: number) => `etykiety: ${n}`,
      hours: (n: number) => `godziny: ${n}`,
      rules: (n: number) => `zasady grup: ${n}`,
      defaults: (n: number) => `domyślne: ${n}`,
    },
  },

  promotionsQuickEdit: {
    placeholder: 'Zapytaj AI, np. „10% zniżki na odbiór wt–czw po 17:00”',
    restoredTag: 'Przywrócona',
    summary: {
      created: (n: number) => `${n} nowe`,
      updated: (n: number) => `${n} zmienione`,
      archived: (n: number) => `${n} zarchiwizowane`,
      restored: (n: number) => `${n} przywrócone`,
    },
    conflict: {
      replaces: (example: string, other: string) => `${example}: zastępuje „${other}”`,
      stacks: (example: string, other: string) => `${example}: sumuje się z „${other}”`,
      loses: (example: string, other: string) =>
        `${example}: „${other}” daje więcej, więc ta nie działa`,
    },
  },

  exceptionsQuickEdit: {
    placeholder: 'Zapytaj AI, np. „zamknij w Boże Narodzenie”',
    summary: {
      created: (n: number) => `${n} nowe`,
      updated: (n: number) => `${n} zmienione`,
      removed: (n: number) => `${n} usunięte`,
    },
  },

  aiChangeset: {
    propose: 'Przygotuj zmiany',
    proposing: 'Przygotowywanie zmian…',
    previousChange: 'Poprzednia zmiana',
    nextChange: 'Następna zmiana',
    changesOnly: 'Tylko zmiany',
    apply: 'Zastosuj',
    discard: 'Odrzuć',
    staleNotice: (items: string) => `W międzyczasie zmienione, sprawdź ponownie: ${items}`,
    appliedToast: (n: number) => `Zastosowano zmiany: ${n}`,
    appliedPartialToast: (applied: number, total: number) =>
      `Zastosowano tylko ${applied} z ${total} zmian, sprawdź resztę`,
    undo: 'Cofnij',
    undoneToast: 'Zmiany cofnięte',
    undoStale: 'Nic nie cofnięto: niektóre pozycje zmieniły się w międzyczasie.',
  },

  aiDock: {
    menuTitle: 'AI menu',
    exceptionsTitle: 'AI dni wolnych',
    promotionsTitle: 'AI rabatów',
    productTitle: 'AI dania',
    sharedWithTeam: 'Wspólne z twoim zespołem',
    expand: 'Pokaż rozmowę z AI',
    collapse: 'Ukryj rozmowę z AI',
    attach: 'Dołącz zdjęcie lub PDF',
    send: 'Wyślij',
    removeAttachment: 'Usuń załącznik',
    uploading: 'Przesyłanie…',
    readingStart: 'Czytanie menu…',
    readingPage: (page: number, total: number) => `Czytanie strony ${page} z ${total}…`,
    dishesSoFar: (n: number) => `Dotąd dań: ${n} · możesz wyjść`,
    importFailed: 'Nie udało się odczytać menu.',
    pagesNotRead: (pages: string) =>
      `Nie udało się odczytać: ${pages}. Załącz tę stronę i poproś AI o dodanie jej dań.`,
    lockedByOther: 'Ktoś inny edytuje z AI. Spróbuj ponownie za chwilę.',
    loadOlder: 'Pokaż wcześniejsze wiadomości',
    emptyHistory:
      'Poproś AI o zmianę cen, dodanie dań lub poprawę nazw. Twój zespół widzi tę rozmowę.',
    teammate: 'Członek zespołu',
    menuCreated: 'Menu utworzone',
    deleteMenuConfirm: 'Usunąć to menu?',
    deleteMenu: 'Usuń',
    tryAgain: 'Spróbuj ponownie',
    undoCreated: 'Cofnij (usuń menu)',
    changesApplied: (n: number) => `Zastosowano zmiany: ${n}`,
    changesPartlyApplied: (applied: number, missing: number) =>
      `Zastosowano: ${applied}, niezastosowane: ${missing}`,
    applyingChanges: (n: number) => `Stosowanie zmian: ${n}…`,
    reviewChanges: (n: number) => `Przejrzyj zmiany (${n})`,
    discarded: 'Odrzucono',
    undone: 'Cofnięto',
    changesPosition: (position: string, total: number) => `${position} / ${total} zmian`,
  },

  menuCreate: {
    title: 'Utwórz z AI',
    nameLabel: 'Nazwa menu',
    namePlaceholder: 'Zostaw puste, AI coś zaproponuje',
    sources: 'Twoje menu',
    sourcesHelp: 'Zdjęcia lub pliki PDF menu albo link do niego.',
    camera: 'Zrób zdjęcie',
    addFiles: 'Dodaj zdjęcia lub PDF',
    removeSource: 'Usuń',
    linkLabel: 'Link',
    linkPlaceholder: 'https://twoja-restauracja.pl/menu',
    invalidLink: 'Wpisz pełny link zaczynający się od https://',
    hintLabel: 'Co AI powinno wiedzieć?',
    hintPlaceholder: 'np. „Tylko menu lunchowe, pomiń stronę z napojami”',
    keepItemNumbers: 'Zachowaj numery pozycji',
    offNote: 'Menu pozostaje wyłączone, dopóki go nie opublikujesz.',
    create: 'Utwórz menu',
    unsupportedFiles: (names: string) => `Nie można użyć: ${names}. Użyj PNG, JPEG, WebP lub PDF.`,
    tooManySources: (max: number) => `Maksymalnie ${max} plików`,
  },

  menuChecklist: {
    toCheck: (n: number) => `Do sprawdzenia: ${n}`,
    noPriceCount: (n: number) => `bez ceny: ${n}`,
    unknownAllergensCount: (n: number) => `nieznane alergeny: ${n}`,
    noPrice: 'Brak ceny',
    addLegend: (n: number) => `Dodaj kody z legendy menu (${n})`,
    legendIntro: 'Te kody są wydrukowane w menu, ale brakuje ich na twojej liście alergenów.',
    addCodes: 'Dodaj do listy alergenów',
    unknownCode: (code: string) => `„${code}” nie ma na liście alergenów`,
  },

  menuImportReview: {
    title: 'Sprawdź import',
    open: 'Porównaj z oryginałem',
    openFlagged: (n: number) => `Porównaj z oryginałem · oznaczone: ${n}`,
    page: (n: number, total: number) => `Strona ${n} z ${total}`,
    previousPage: 'Poprzednia strona',
    nextPage: 'Następna strona',
    flaggedOnly: 'Tylko oznaczone',
    allDishes: 'Wszystkie dania',
    showPage: 'Oryginał',
    showDishes: 'Dania',
    flaggedCount: (n: number) => `Oznaczone: ${n}`,
    noDishes: 'Z tej strony nie odczytano żadnych dań.',
    noFlagged: 'Na tej stronie nic nie oznaczono.',
    sourceMissing: 'Oryginalny plik nie jest już dostępny.',
    openOriginal: 'Otwórz oryginał',
    unavailableTitle: 'Nie ma z czym porównać',
    unavailableText:
      'To menu nie ma zapisanych stron źródłowych. Menu zaimportowanych przed wprowadzeniem tej funkcji nie można tu sprawdzić.',
    liveNote: 'To menu jest już aktywne. Oznaczenia są tylko informacją.',
    noPrice: 'Brak ceny',
    priceOutlier: (typical: string) => `Cena mocno odbiega od reszty kategorii (zwykle ${typical})`,
    unknownCodes: (codes: string) => `Brak na twojej liście alergenów: ${codes}`,
    itemNumberDropped: (code: string) => `Numer pozycji ${code} powtarzał się i został pominięty`,
    pickLimit: (limits: string) => `Goście muszą wybrać dokładną liczbę: ${limits}`,
  },

  notificationsFeature: {
    couldntLoadNotifications: 'Nie udało się załadować powiadomień',
    allCaughtUp: 'Wszystko obsłużone',
    noNotifications: 'Brak powiadomień.',
    today: 'Dziś',
    earlier: 'Wcześniej',
    markAllRead: 'Oznacz wszystkie jako przeczytane',
    notificationsSheet: 'Powiadomienia',
  },

  openingHours: {
    editClosure: 'Edytuj zamknięcie',
    addClosure: 'Dodaj zamknięcie',
    reason: 'Powód',
    reasonPlaceholder: 'Np. Boże Narodzenie, impreza pracownicza',
    appliesToLabel: 'Dotyczy',
    allServices: 'Wszystkie usługi',
    servicesSelected: (n: number) => `${n} usług`,
    pickAtLeastOneService: 'Wybierz przynajmniej jedną usługę',
    dineIn: 'Na miejscu',
    pickup: 'Odbiór',
    delivery: 'Dostawa',
    reservation: 'Rezerwacja',
    whatHappens: 'Co się dzieje',
    whatHappensHint:
      'Święto zamyka lokal na cały dzień. Wyjątek utrzymuje go otwartym z innymi godzinami w te dni - na przykład otwarcie później lub zamknięcie wcześniej.',
    holiday: 'Święto',
    exception: 'Wyjątek',
    closedAllDay: 'Zamknięte cały dzień',
    specialHours: 'Godziny specjalne',
    dates: 'Daty',
    from: 'Od',
    to: 'Do',
    startDateAriaLabel: 'Data początkowa',
    endDateAriaLabel: 'Data końcowa',
    singleDayHint: 'Jeden dzień? Ustaw Od i Do na tę samą datę.',
    shiftLabel: (number) => `Zmiana ${number}`,
    openLabel: 'Otwarte',
    removeHoursAriaLabel: 'Usuń godziny',
    addHours: 'Dodaj godziny',
    hoursReplaceWeeklyNote:
      'Te godziny zastępują normalne tygodniowe godziny otwarcia w wybranych dniach.',
    pickStartEndDate: 'Wybierz datę początkową i końcową.',
    endDateBeforeStart: 'Data końcowa nie może być wcześniejsza niż data początkowa.',
    addSpecialHours: 'Dodaj przynajmniej jeden zestaw godzin specjalnych.',
    checkSpecialHours: 'Sprawdź godziny specjalne - otwarcie musi być przed zamknięciem.',
    closureUpdated: 'Zamknięcie zaktualizowane',
    closureAdded: 'Zamknięcie dodane',
    couldNotSave: 'Nie udało się zapisać - spróbuj ponownie.',
    holidaysClosures: 'Święta i zamknięcia',
    removeClosureConfirm: 'Usuń zamknięcie',
    removeClosureQuestion: (label) => `Usunąć zamknięcie dla ${label}?`,
    closureRemoved: 'Zamknięcie usunięte',
    couldNotRemove: 'Nie udało się usunąć - spróbuj ponownie.',
    couldNotLoadClosures: 'Nie udało się załadować zamknięć',
    noClosuresYet: 'Brak zamknięć',
    noClosuresDescription:
      'Dodaj święto lub dzień z godzinami specjalnymi, aby zastąpić tygodniowy harmonogram. Dotknij +.',
    closedBadge: 'Zamknięte',
    specialBadge: 'Specjalne',
    closuresOverrideNote:
      'Zamknięcia zastępują tygodniowe godziny otwarcia. Dzień zamknięty usuwa terminy zamówień online i rezerwacji; godziny specjalne zastępują je w wybranych dniach.',
    title: 'Godziny otwarcia',
    service: 'Usługa',
    hoursFor: 'Godziny dla',
    hoursServiceNote:
      'Każda usługa zachowuje własne tygodniowe godziny otwarcia. Godziny odbioru i dostawy sterują stroną zamówień online; godziny rezerwacji sterują kalendarzem rezerwacji.',
    oneOffClosedDays: 'Jednorazowe dni zamknięte i godziny specjalne',
    monday: 'Poniedziałek',
    tuesday: 'Wtorek',
    wednesday: 'Środa',
    thursday: 'Czwartek',
    friday: 'Piątek',
    saturday: 'Sobota',
    sunday: 'Niedziela',
    hoursLabel: 'Godziny otwarcia',
    hours: 'Godziny',
    generalHoursNote:
      'To ogólne godziny otwarcia restauracji. Rezerwacje, odbiór i dostawa stosują się do nich automatycznie - nadaj kanałowi własne godziny w jego ustawieniach, jeśli się różnią. Jednorazowe święta i dni z godzinami specjalnymi znajdują się w sekcji Święta i zamknięcia.',
    openTimeAria: (label) => `${label} otwarcie`,
    closeTimeAria: (label) => `${label} zamknięcie`,
    enabledWithoutHours: (label) =>
      `${label} jest włączone, ale nie ma godzin - dodaj godzinę lub wyłącz`,
    checkTimes: (label) => `Sprawdź godziny dla ${label}`,
    noOvernightOrders: (label) =>
      `${label}: godzina zamknięcia musi być po otwarciu - godziny zamówień nie mogą przechodzić przez północ.`,
    openAfterClose: (label) => `${label}: godzina otwarcia nie może być po godzinie zamknięcia.`,
    shiftsOverlap: (label) =>
      `${label}: zakresy godzin nakładają się - zmień je tak, aby się nie pokrywały.`,
    invalidHoursTitle: 'Nieprawidłowe godziny',
    openingSaved: 'Godziny otwarcia zapisane',
    saveFailed: 'Nie udało się zapisać',
    couldNotLoadHours: 'Nie udało się załadować godzin otwarcia',
    checkConnection: 'Sprawdź połączenie i spróbuj ponownie.',
    saveButtonLabel: (service) => `Zapisz godziny otwarcia ${service}`,
    followingTheseHours: 'Według tych godzin',
    setCustomHours: 'Ustaw godziny niestandardowe',
    nowFollowingGeneral: 'Teraz według ogólnych godzin',
    confirmFollowTitle: 'Przełączyć na godziny ogólne?',
    confirmFollowMessage:
      'Spowoduje to usunięcie niestandardowych godzin tygodniowych tego kanału. Zamiast tego będzie on stosować ogólne godziny restauracji.',
    failedSetCustom: 'Nie udało się ustawić godzin niestandardowych',
    failedUpdate: 'Nie udało się zaktualizować',
    orderHoursTitle: 'Godziny zamówień',
    pickupHoursTitle: 'Godziny odbioru',
    deliveryHoursTitle: 'Godziny dostawy',
    reservationHoursTitle: 'Godziny rezerwacji',
    pickupFollowNote:
      'Odbiór stosuje się do ogólnych godzin otwarcia restauracji. Włącz godziny niestandardowe, aby osobno ustawić, kiedy przyjmowane są zamówienia na odbiór.',
    deliveryFollowNote:
      'Dostawa stosuje się do ogólnych godzin otwarcia restauracji. Włącz godziny niestandardowe, aby osobno ustawić, kiedy realizowana jest dostawa.',
    reservationFollowNote:
      'Rezerwacje stosują się do ogólnych godzin otwarcia restauracji. Włącz godziny niestandardowe, aby osobno ustawić, kiedy można rezerwować stoliki.',
    openingTime: 'Godzina otwarcia',
    deleteThisClosure: 'Usuń to zamknięcie',
    removeThisClosureQuestion: 'Usunąć to zamknięcie?',
    statusOpenUntil: (time) => `Otwarte · do ${time}`,
    statusClosedOpensAt: (time) => `Zamknięte · otwarcie ${time}`,
    statusClosedOpensDay: (day, time) => `Zamknięte · otwarcie ${day} ${time}`,
  },

  orderSetup: {
    title: 'Ustawienia zamówień',
    orderTypes: {
      title: 'Typy zamówień',
      noConfig: 'Nie skonfigurowano typów zamówień.',
      footer:
        'Dotknij kanału, aby go włączyć/wyłączyć lub przełączyć płatności gotówką i kartą. Wyłączenie kanału całkowicie ukrywa go przed klientami - aby zamiast tego krótko go wstrzymać, użyj dostępności poniżej.',
      cashStatus: (status, cardStatus) => `Gotówka ${status} · Karta ${cardStatus}`,
      cashOnly: (status) => `Gotówka ${status}`,
      disabled: 'Klienci nie mogą zamawiać w ten sposób',
      on: 'Wł.',
      off: 'Wył.',
      actionLabel: (label) => `Ustawienia ${label}`,
      turnOff: (label) => `Wyłącz ${label}`,
      turnOn: (label) => `Włącz ${label}`,
      stopCash: 'Przestań przyjmować gotówkę',
      acceptCash: 'Przyjmuj gotówkę',
      stopCard: 'Przestań przyjmować płatności kartą',
      acceptCard: 'Przyjmuj płatności kartą online',
      turnedOff: (label) => `${label} wyłączone`,
      turnedOn: (label) => `${label} włączone`,
      cashOff: 'Płatności gotówką wyłączone',
      cashOn: 'Płatności gotówką włączone',
      onlineCardOff: 'Płatności kartą online wyłączone',
      onlineCardOn: 'Płatności kartą online włączone',
    },
    minimumOrder: {
      title: 'Minimalne zamówienie',
      noConfig: 'Nie skonfigurowano typów zamówień.',
      smallestBasket: 'Najmniejszy dozwolony koszyk',
      noMinimum: 'Bez minimum',
      footer:
        'Najmniejsza suma koszyka, z którą klient może sfinalizować zamówienie, dla każdego kanału. Ustaw 0, aby nie było minimum.',
      prompt: (orderType) => `Minimalna suma zamówienia ${orderType} (0 = bez minimum)`,
      set: (orderType, amount) => `Minimalne zamówienie ${orderType} ustawione na ${amount}`,
      removed: (orderType) => `Minimalne zamówienie ${orderType} usunięte`,
    },
    availability: {
      title: 'Dostępność',
      accepting: 'Przyjmowanie zamówień',
      pausedUntilClose: 'Wstrzymane do zamknięcia',
      pausedResumes: (time) => `Wstrzymane · wznowienie o ${time}`,
      paused: 'Wstrzymane',
      live: 'Aktywne',
      footer:
        'Bieżący stan przyjmowania nowych zamówień. Dotknij kanału, aby wstrzymać go podczas szczytu lub problemów w kuchni (czasowo / do zamknięcia) lub aby go wznowić. Jest to niezależne od włączenia typu zamówienia powyżej - istniejące zamówienia nie są naruszane.',
      orderingLabel: (label) => `Zamawianie ${label}`,
      pause30: 'Wstrzymaj na 30 minut',
      pause1Hour: 'Wstrzymaj na 1 godzinę',
      pauseUntilClose: 'Wstrzymaj do zamknięcia',
      resumeNow: 'Wznów teraz',
      pausedFor: (label, minutes) => `${label} wstrzymane na ${minutes} minut`,
      pausedUntilCloseToast: (label) => `${label} wstrzymane do zamknięcia`,
      resumed: (label) => `${label} wznowione`,
    },
    deliveryZones: {
      title: 'Strefy dostawy',
      noZones:
        'Brak stref dostawy - dostawa jest niedostępna, dopóki nie zostanie dodana przynajmniej jedna strefa.',
      mapArea: 'Obszar na mapie',
      within: (km) => `W promieniu ${km} km`,
      noRangeSet: 'Nie ustawiono zasięgu',
      addZone: '+ Dodaj strefę dostawy',
      footer:
        'Każda strefa określa swój zasięg oraz własną opłatę za dostawę i minimalne zamówienie. Klienci widzą najmniejszą pasującą strefę.',
      deleteConfirm: (label) => `Usunąć strefę "${label}"?`,
      deleteTitle: 'Usuń strefę',
      deleted: 'Strefa usunięta',
    },
    deliveryZone: {
      newZone: 'Nowa strefa dostawy',
      editZone: 'Edytuj strefę',
      nameLabel: 'Nazwa strefy',
      namePlaceholder: 'np. Centrum miasta, do 5 km',
      deliveryArea: 'Obszar dostawy',
      mapDrawn: 'Narysowana na mapie',
      mapDrawnFooter: 'Ten obszar został narysowany na mapie i nie można go tu edytować.',
      distanceLabel: 'Dostawa w promieniu (km)',
      distancePlaceholder: 'np. 5',
      feeLabel: (currency) => `Opłata za dostawę (${currency})`,
      minOrderLabel: (currency) => `Minimalne zamówienie (${currency})`,
      minOrderPlaceholder: '0 = bez minimum',
      nameRequired: 'Nadaj strefie nazwę.',
      distanceRequired: 'Wprowadź, jak daleko dostarcza ta strefa (km).',
      added: 'Strefa dodana',
      updated: 'Strefa zaktualizowana',
      saveFailed: 'Nie udało się zapisać strefy',
    },
    paymentMethods: {
      title: 'Ręczne metody płatności',
      noMethods:
        'Brak ręcznych metod płatności - przy płatności oferowane są tylko opcje domyślne.',
      active: 'Aktywna',
      inactive: 'Nieaktywna',
      addMethod: '+ Dodaj metodę płatności',
      footer:
        'Opcje płatności przy odbiorze lub przelewem bankowym są wyświetlane przy płatności. Klienci postępują zgodnie z instrukcjami, a personel ręcznie potwierdza wpływ.',
      deleteConfirm: (name) => `Usunąć metodę "${name}"?`,
      deleteTitle: 'Usuń',
      deleted: 'Metoda usunięta',
    },
    paymentMethod: {
      newMethod: 'Nowa metoda płatności',
      editMethod: 'Edytuj metodę',
      nameLabel: 'Nazwa metody',
      namePlaceholder: 'np. Przelew bankowy, PayPal',
      instructionsLabel: 'Instrukcje',
      instructionsPlaceholder: 'Co klient powinien zrobić, aby zapłacić',
      shownAtCheckout: 'Pokazywane przy płatności',
      detail: (number) => `Szczegół ${number}`,
      remove: 'Usuń',
      detailLabel: 'Etykieta',
      detailLabelPlaceholder: 'np. IBAN',
      detailValue: 'Wartość',
      detailValuePlaceholder: 'np. DE89 3704 0044 0532 0130 00',
      addDetail: '+ Dodaj dane konta',
      detailLabelInfo:
        'Nazwa pola widocznego dla klienta (np. IBAN, Właściciel konta, Nazwa banku).',
      detailValueInfo:
        'Rzeczywisty szczegół, który klient kopiuje, aby zapłacić (np. DE89 3704…, ACME Ltd).',
      detailsFooter:
        'Dane konta są wyświetlane jako oznaczone wiersze pod instrukcjami przy płatności - użyj ich do podania numeru IBAN, właściciela konta, adresu PayPal itp.',
      nameRequired: 'Nadaj metodzie nazwę.',
      instructionsRequired: 'Dodaj instrukcje, którymi klient powinien się kierować.',
      detailsInvalid: 'Każde dane konta wymagają zarówno etykiety, jak i wartości.',
      added: 'Metoda dodana',
      updated: 'Metoda zaktualizowana',
      saveFailed: 'Nie udało się zapisać metody',
    },
    shifts: {
      title: 'Godziny zamówień',
      pickup: 'Odbiór',
      delivery: 'Dostawa',
      capacityMode: 'Tryb pojemności',
      simple: 'Prosty',
      simpleDescription: 'Jedna liczba: ile zamówień możesz przyjąć na godzinę.',
      simpleConfirm: 'Przełączyć pojemność na tryb prosty?',
      simpleDetails:
        'Przedział to okno 60-minutowe - przedział o 19:00 liczy każde zamówienie zaplanowane między 19:00 a 19:59.\n\nDomyślny limit obowiązuje, gdy żadne okno godzin specjalnych nie obejmuje danego czasu. Pozostaw puste, jeśli limit nie jest potrzebny.',
      advanced: 'Zaawansowany',
      advancedDescription: 'Wybierz długość przedziału i limit zamówień na przedział.',
      advancedConfirm: 'Przełączyć pojemność na tryb zaawansowany?',
      advancedDetails:
        'Ustaw własną długość przedziału (np. 30 min) i limit zamówień na przedział - bardziej szczegółowo niż w prostym modelu godzinowym.\n\nDomyślny limit obowiązuje, gdy żadne okno godzin specjalnych nie obejmuje danego czasu. Pozostaw puste, jeśli limit nie jest potrzebny.',
      aboutMode: (mode) => `O trybie ${mode}`,
      defaultCapacity: 'Domyślna pojemność',
      ordersPerSlot: 'Zamówień na przedział',
      maxOrdersPerHour: 'Maks. zamówień na godzinę',
      noCap: 'bez limitu',
      slotLength: 'Długość przedziału (min)',
      slotLengthPlaceholder: '30',
      kitchenPrepTime: 'Czas przygotowania w kuchni (min)',
      noPrepPlaceholder: 'bez przygotowania',
      minNoticeLabel: 'Minimalne wyprzedzenie dla zamówień wcześniejszych (min)',
      nonePlaceholder: 'brak',
      defaultFooter:
        'Zamówienia online stosują się do Twoich godzin otwarcia. Dodaj poniżej godziny specjalne dla innych godzin w określone dni.',
      specialHours: 'Godziny specjalne',
      noSpecialHours: 'Brak - domyślne obowiązuje codziennie.',
      setDefaultFirst: 'Najpierw ustaw domyślną pojemność',
      capacityModeSet: (mode) => `Tryb pojemności: ${mode}`,
      switchModeFailed: 'Nie udało się przełączyć trybu pojemności',
    },
    shiftForm: {
      newSpecialHours: 'Nowe godziny specjalne',
      editSpecialHours: 'Edytuj godziny specjalne',
      name: 'Nazwa',
      namePlaceholder: 'np. Wigilia, godziny niedzielne',
      days: 'Dni',
      hours: 'Godziny',
      opens: 'Otwarcie',
      closes: 'Zamknięcie',
      capacity: 'Pojemność',
      preview: 'Podgląd',
      active: 'Aktywna',
      activeFooter: 'Wyłącz tę regułę, ale zachowaj ją na razie.',
      daysFooter: (channel) =>
        `W te dni ta reguła zastępuje normalne godziny ${channel}. Pozostałe dni pozostają bez zmian.`,
      capacityFooter:
        'Szary to Twoja wartość domyślna - pozostaw puste, aby ją zachować, lub wprowadź liczbę, aby użyć innej wartości w dni objęte tą regułą.',
      deleteRule: 'Usuń tę regułę',
      nameRequired: 'Nadaj tej regule nazwę',
      dayRequired: 'Wybierz przynajmniej jeden dzień',
      timeInvalid: 'Otwarcie musi być przed zamknięciem',
      capacityInvalid:
        'Pojemność musi być dodatnią liczbą całkowitą (lub pusta dla wartości domyślnej)',
      slotInvalid: 'Długość przedziału musi być dodatnią liczbą całkowitą',
      leadInvalid:
        'Przygotowanie / wyprzedzenie muszą być liczbami całkowitymi (lub puste, aby użyć wartości domyślnej)',
      saveFailed: 'Nie udało się zapisać',
      deleteConfirm: 'Usunąć tę regułę?',
      deleted: 'Usunięto',
      deleteFailed: 'Nie udało się usunąć',
    },
    holidayForm: {
      newTitle: 'Nowe godziny świąteczne',
      editTitle: 'Edytuj godziny świąteczne',
      namePlaceholder: 'np. Wigilia, Nowy Rok',
      dates: 'Daty',
      datesFooter: (channel) =>
        `W tych dniach to święto zastępuje ZARÓWNO godziny specjalne, JAK I normalne godziny ${channel}.`,
      starts: 'Rozpoczyna się',
      startAria: 'Data rozpoczęcia święta',
      ends: 'Kończy się',
      endAria: 'Data zakończenia święta',
      on: 'Wł.',
      activeFooter: 'Wyłącz, aby zachować to święto, ale tymczasowo przestać je nadpisywać.',
      deleteHoliday: 'Usuń to święto',
      nameRequired: 'Nadaj temu świętu nazwę',
      dateRangeInvalid: 'Data zakończenia musi przypadać w dniu rozpoczęcia lub później',
      hoursInvalid: 'Otwarcie i zamknięcie muszą być ustawione i różne',
      capacityInvalid:
        'Zamówienia na slot muszą być dodatnią liczbą całkowitą (lub puste dla braku limitu)',
      prepNoticeInvalid:
        'Przygotowanie i wyprzedzenie muszą być liczbami całkowitymi (0 lub więcej)',
      deleteConfirm: 'Usunąć to święto?',
    },
    leadTime: {
      orderNow: 'Zamów teraz (jak najszybciej)',
      orderLabel: 'Zamówienie',
      readyLabel: 'Gotowe',
      deliveredLabel: 'Dostarczone',
      deliveryDescription: (mins: number) =>
        `Dostawa dokłada ${mins} min do czasu przygotowania — wtedy gość faktycznie ma jedzenie.`,
      deliveryRangeDescription: (min: number, max: number) =>
        `Dostawa dokłada ${min}–${max} min do czasu przygotowania, zależnie od obszaru — wtedy gość faktycznie ma jedzenie.`,
      deliveryLiveDescription:
        'Czas dostawy liczony jest dla każdego adresu na podstawie bieżących danych drogowych, więc różni się przy każdym zamówieniu.',
      readyDescription:
        'Gotowe = czas zamówienia + czas przygotowania. To czas oczekiwania klienta - gdzie czas przygotowania ma największe znaczenie. Minimalne wyprzedzenie nie ma zastosowania.',
      noPrepBuffer: 'Brak bufora przygotowania - zamówienie jest gotowe natychmiast.',
      orderLater: 'Zamów później (zamówienie wcześniejsze)',
      earliestSlot: 'Najwcześniejszy przedział',
      minNoticeDescription: (time) =>
        `Minimalne wyprzedzenie - najwcześniejszy przyszły przedział, jaki może wybrać klient, to ${time}.`,
      noNotice: 'Brak wyprzedzenia - klienci mogą wybrać kolejny przedział.',
      opensLabel: 'Otwarcie',
      firstSlotLabel: 'Pierwszy przedział',
      openingBufferDescription: (open: string, first: string) =>
        `Najwcześniej po otwarciu - gdy zamówienia ruszają o ${open}, najwcześniejszy przedział do wyboru to ${first}.`,
      noOpeningBuffer: 'Brak bufora po otwarciu - klienci mogą wybrać samą godzinę otwarcia.',
      kitchenStarts: 'Kuchnia rozpoczyna',
      readySlot: 'Gotowe · przedział',
      driverLeaves: 'Kierowca wyjeżdża',
      deliveredSlot: 'Dostarczone',
      kitchenStartsDeliveryDescription: (slot: string, startTime: string) =>
        `Przy dostawie na ${slot} kuchnia zaczyna o ${startTime} — dojazd odejmowany jest od godziny, a nie doliczany, więc gość nadal dostaje zamówienie o ${slot}. Pokazano dla najdalszego obszaru.`,
      kitchenStartsDeliveryLive:
        'Przy odległości drogowej na żywo dojazd odejmowany jest dla każdego adresu, więc start kuchni zmienia się przy każdym zamówieniu.',
      kitchenStartsDescription: (time, startTime) =>
        `Dla wybranego przedziału ${time} kuchnia rozpoczyna o ${startTime} - klient i tak otrzyma zamówienie dokładnie o ${time}.`,
    },
    page: {
      pickup: 'Odbiór',
      delivery: 'Dostawa',
      noConfig: 'Nie skonfigurowano żadnych typów zamówień.',
      orderTypesTitle: 'Typy zamówień',
      canOrder: 'Klienci mogą zamawiać w ten sposób',
      cannotOrder: 'Klienci nie mogą zamawiać w ten sposób',
      readOnlyNotice:
        'Możesz przeglądać te ustawienia. Zmieniać je może tylko właściciel lub menedżer.',
      orderTypesFooter:
        'Włącz lub wyłącz kanał. Wyłączenie całkowicie ukrywa go przed klientami - aby zamiast tego krótko go wstrzymać, użyj Dostępności poniżej.',
      toggledOn: (label) => `${label} włączone`,
      toggledOff: (label) => `${label} wyłączone`,
      cardTitle: 'Płatności kartą',
      acceptingCard: 'Akceptuje kartę online',
      cardOff: 'Karta wyłączona',
      cardFooter: 'Akceptuj płatności kartą online, dla każdego kanału.',
      cardOnToast: (label) => `${label} karta włączona`,
      cardOffToast: (label) => `${label} karta wyłączona`,
      cardOnHandoffTitle: 'Karta przy odbiorze',
      acceptingCardOnHandoff: 'Karta przy odbiorze włączona',
      cardOnHandoffOff: 'Karta przy odbiorze wyłączona',
      cardOnHandoffHelp:
        'Klient płaci kartą na Twoim terminalu POS przy odbiorze lub dostawie. Bez dostawcy online - sam pobierasz i rozliczasz, jak gotówkę.',
      autoConfirmTitle: 'Auto-potwierdzanie',
      autoConfirmOn: 'Gotówka i karta przy odbiorze potwierdzane automatycznie',
      autoConfirmOff: 'Potwierdzaj ręcznie',
      autoConfirmHelp:
        'Zamówienia gotówkowe i kartą przy odbiorze są potwierdzane automatycznie, a bon kuchenny drukuje się od razu - bez klikania Akceptuj. Zamówienia online potwierdzają się przy płatności; przelew nadal wymaga Twojej weryfikacji.',
      autoConfirmOnToast: (label) => `${label} auto-potwierdzanie włączone`,
      autoConfirmOffToast: (label) => `${label} auto-potwierdzanie wyłączone`,
      autoCompleteTitle: 'Automatyczne kończenie zamówień',
      autoCompleteOn: (minutes) => `Zamyka ${minutes} min po obiecanym czasie`,
      autoCompleteOff: 'Sam(a) kończysz każde zamówienie',
      autoCompleteHelp:
        'Niezamknięte zamówienia zostaną zakończone za Ciebie jakiś czas po godzinie obiecanej klientowi. Wyłącz to, jeśli sam(a) klikasz Zakończ - wtedy zamówienia pozostają otwarte.',
      autoCompleteOnToast: (label) => `${label} kończone automatycznie`,
      autoCompleteOffToast: (label) => `${label} pozostają otwarte do zakończenia przez Ciebie`,
      autoCompleteSaveFailed: 'Nie udało się zapisać opóźnienia. Spróbuj ponownie.',
      autoCompleteDelayTitle: 'Odczekaj przed zakończeniem',
      autoCompleteDelayFooter:
        'Ile minut po obiecanym czasie zamówienie zostanie zamknięte za Ciebie.',
      cardOnHandoffOnToast: (label) => `${label} karta przy odbiorze włączona`,
      cardOnHandoffOffToast: (label) => `${label} karta przy odbiorze wyłączona`,
      availabilityTitle: 'Dostępność',
      accepting: 'Przyjmuje zamówienia',
      pausedUntilClose: 'Wstrzymane do zamknięcia',
      pausedResumes: (time) => `Wstrzymane · wznowienie ${time}`,
      paused: 'Wstrzymane',
      live: 'Aktywne',
      disabled: 'Wyłączone',
      availabilityFooter:
        'Bieżący status przyjmowania nowych zamówień. Dotknij kanału, aby wstrzymać go podczas natłoku lub problemów w kuchni (czasowo / do zamknięcia) lub wznowić. Jest to niezależne od włączenia typu zamówienia powyżej - istniejące zamówienia nie są naruszane.',
      orderingLabel: (label) => `Zamawianie ${label}`,
      pause30: 'Wstrzymaj na 30 minut',
      pause1Hour: 'Wstrzymaj na 1 godzinę',
      pauseHours: (n) => `Wstrzymaj na ${n} godziny`,
      pauseUntilClose: 'Wstrzymaj do zamknięcia',
      resumeNow: 'Wznów teraz',
      cancel: 'Anuluj',
      pausedUntilCloseToast: (label) => `${label} wstrzymane do zamknięcia`,
      pausedForToast: (label, minutes) => `${label} wstrzymane na ${minutes} min`,
      resumedToast: (label) => `${label} wznowione`,
      minimumOrderTitle: 'Minimalne zamówienie',
      smallestBasket: 'Najmniejszy dozwolony koszyk',
      noMinimum: 'Brak minimum',
      minimumOrderFooter:
        'Najmniejsza wartość koszyka, z jaką klient może sfinalizować zamówienie, dla każdego kanału. Ustaw 0, aby nie było minimum.',
      minPrompt: (label) => `Minimalna wartość zamówienia ${label} (0 = brak minimum)`,
      minDialogTitle: 'Minimalne zamówienie',
      minSet: (label, amount) => `Minimum ${label} ustawione na ${amount}`,
      minRemoved: (label) => `Minimum ${label} usunięte`,
      deliveryPricingTitle: 'Ceny dostawy',
      deliveryPricingFooter:
        'Sposób naliczania opłat za dostawę - według odległości od restauracji lub według narysowanych stref na mapie.',
      byDistance: 'Według odległości',
      byDistanceFooter: 'Naliczaj stopniowaną opłatę w zależności od odległości klienta.',
      byMapZones: 'Według stref na mapie',
      byMapZonesFooter: 'Narysuj obszary dostawy na mapie, każdy z własną opłatą.',
      straightLine: 'Odległość w linii prostej',
      straightLineFooter: 'W linii prostej. Darmowe, natychmiastowe.',
      drivingDistance: 'Odległość drogowa (MapBox)',
      drivingDistanceFooter: 'Rzeczywista odległość drogowa. Dokładniejsze; używa MapBox.',
      deliveryWarnings: {
        title: 'Dostawa nie jest gotowa dla klientów',
        subtitle: 'Goście napotkają te problemy przy zamówieniu — bez wyjaśnienia dlaczego.',
        locationNotPinned: 'Twoja restauracja nie jest oznaczona na mapie',
        locationNotPinnedEffect:
          'Odległości liczone są od restauracji, więc każdy adres jest odrzucany jako poza zasięgiem.',
        noActiveZones: 'Brak obszarów dostawy dla wybranej metody wyceny',
        noActiveZonesEffect: 'Każdy adres dostaje komunikat, że dostawa nie jest dostępna.',
        zoneMissingTime: (zone: string) => `„${zone}” nie ma czasu dostawy`,
        zoneMissingTimeEffect:
          'Goście dostają czas bez uwzględnienia dojazdu, więc zamówienia docierają z opóźnieniem.',
        noPaymentMethod: 'Nie włączono żadnej metody płatności',
        noPaymentMethodEffect: 'Goście mogą skompletować koszyk, ale nie złożą zamówienia.',
      },
      pinRequiredForRouteTitle: 'Najpierw oznacz restaurację',
      pinRequiredForRoute:
        'Odległość drogowa liczona jest od lokalizacji restauracji. Ustaw ją na mapie w ustawieniach restauracji, a następnie przełącz na odległość drogową.',
      dispatchBufferTitle: 'Zapas na dostawę',
      dispatchBufferFooter:
        'Dodatkowe minuty doliczane do czasu jazdy — na łączenie kilku dostaw, parkowanie i dojście do drzwi. Zostaw 0, jeśli czas trasy jest już realistyczny.',
      dispatchBufferLabel: 'Dodatkowe minuty',
      restaurantLocation: 'Lokalizacja restauracji',
      pinned: 'Przypięta',
      notSet: 'Nie ustawiono',
      locationFooter:
        'Punkt, od którego mierzymy odległość i czas jazdy dostawy. Wymagane do cen według odległości; w strefach na mapie zasila czas dostawy na żywo (do czasu ustawienia używany jest szacunek statyczny).',
      deliveryPricingSaveFailed: 'Nie udało się zapisać cen dostawy',
      switchModeConfirmTitle: 'Zmienić tryb cennika?',
      switchModeConfirm:
        'Po zmianie trybu cennika Twoje istniejące strefy dla drugiej metody nie będą już używane. Kontynuować?',
      deliveryZonesTitle: 'Strefy dostawy',
      distanceBandsTitle: 'Progi cenowe wg odległości',
      bandForm: {
        newTitle: 'Nowy przedział odległości',
        editTitle: 'Edytuj przedział odległości',
        back: 'Wstecz',
        nameLabel: 'Nazwa przedziału',
        namePlaceholder: 'np. Centrum, Do 5 km',
        kmLabel: 'Dostawa w promieniu (km)',
        kmPlaceholder: 'np. 5',
        feeLabel: 'Opłata za dostawę',
        feePlaceholder: '0',
        minOrderLabel: 'Minimalne zamówienie',
        minOrderPlaceholder: '0 = brak minimum',
        areaLabel: 'Obszar dostawy',
        areaAfter: 'Narysowany na mapie',
        areaFooter: 'Ten obszar został narysowany na mapie i nie można go tutaj edytować.',
        nameRequired: 'Nadaj przedziałowi nazwę.',
        kmRequired: 'Ustaw zasięg dostawy tego przedziału (km).',
        invalidInput: 'Wartości nie mogą być ujemne - nic nie zapisano.',
        invalidNumber: 'Wpisz liczbę, np. 2,5.',
        wholeMinutes: 'Tylko pełne minuty, np. 30.',
        updated: 'Zaktualizowano przedział odległości',
        added: 'Dodano przedział odległości',
        deliveryTimeLabel: 'Czas dostawy (minuty)',
        deliveryTimePlaceholder: 'np. 45',
        deliveryTimeInfo: 'Tylko czas dojazdu — czas przygotowania doliczany jest osobno.',
        deliveryTimeRequired: 'Podaj, ile minut zajmuje dostawa do tego obszaru.',
        saveFailed: 'Nie udało się zapisać przedziału',
      },
      addDistanceBand: '+ Dodaj próg odległości',
      noDistanceBands:
        'Brak progów odległości - dostawa niedostępna, dopóki nie dodasz co najmniej jednego progu.',
      distanceBandsFooter:
        'Stała opłata za każdy próg odległości w linii prostej (np. do 3 km → €2,50). Obowiązuje najbliższy próg obejmujący adres.',
      drivingBandsFooter:
        'Stała opłata za każdy próg odległości jazdy (np. do 3 km trasą → €2,50). Odległość mierzona po drogach przez MapBox; obowiązuje najbliższy próg obejmujący adres.',
      noZones:
        'Brak stref dostawy - dostawa jest niedostępna, dopóki nie zostanie dodana co najmniej jedna strefa.',
      mapArea: 'Obszar mapy',
      within: (km) => `W promieniu ${km} km`,
      noRangeSet: 'Nie ustawiono zasięgu',
      addZone: '+ Dodaj strefę dostawy',
      drawArea: '+ Narysuj obszar dostawy',
      zonesFooter:
        'Każda strefa określa swój zasięg oraz własną opłatę za dostawę i minimalne zamówienie. Klienci widzą najmniejszą pasującą strefę.',
      deleteZoneConfirm: (label) => `Usunąć strefę "${label}"?`,
      deleteZoneTitle: 'Usuń strefę',
      zoneDeleted: 'Strefa usunięta',
      methodsTitle: 'Ręczne metody płatności',
      noMethods: 'Brak ręcznych metod płatności - przy kasie oferowane są tylko opcje domyślne.',
      active: 'Aktywna',
      inactive: 'Nieaktywna',
      addMethod: '+ Dodaj metodę płatności',
      methodsFooter:
        'Opcje płatności przy odbiorze lub przelewem bankowym pokazywane przy kasie. Klienci postępują zgodnie z instrukcjami, a personel ręcznie potwierdza wpłatę.',
      deleteMethodConfirm: (name) => `Usunąć metodę "${name}"?`,
      deleteMethodTitle: 'Usuń',
      methodDeleted: 'Metoda usunięta',
      zoneMapForm: {
        newTitle: 'Nowy obszar dostawy',
        editTitle: 'Edytuj obszar',
        drawFooter:
          'Dotknij narzędzia wielokąta (lewy górny róg mapy), aby zacząć, następnie dotknij każdego rogu obszaru dostawy; podwójne dotknięcie zamyka kształt. Użyj narzędzia kosza, aby narysować od nowa. Następnie ustaw poniżej opłatę i minimum.',
        nameLabel: 'Nazwa obszaru',
        namePlaceholder: 'np. Centrum miasta',
        feeLabel: 'Opłata za dostawę',
        feePlaceholder: '0',
        minOrderLabel: 'Minimalne zamówienie',
        minOrderPlaceholder: '0 = brak minimum',
        deliveryTimeLabel: 'Czas dostawy (minuty)',
        deliveryTimePlaceholder: 'np. 45',
        deliveryTimeInfo: 'Tylko czas dojazdu — czas przygotowania doliczany jest osobno.',
        nameRequired: 'Nadaj obszarowi nazwę.',
        drawRequired: 'Najpierw narysuj obszar dostawy na mapie.',
        minOrderRequired: 'Ustaw minimalne zamówienie (wpisz 0, aby nie było minimum).',
        deliveryTimeRequired: 'Podaj, ile minut zajmuje dostawa do tego obszaru.',
        invalidNumber: 'Wpisz liczbę, np. 2,5.',
        wholeMinutes: 'Tylko pełne minuty, np. 30.',
        updated: 'Obszar zaktualizowany',
        added: 'Obszar dodany',
        saveFailed: 'Nie udało się zapisać obszaru',
      },
      locationForm: {
        tapPrompt: 'Dotknij mapy, aby ustawić lokalizację restauracji.',
        saved: 'Lokalizacja zapisana',
        saveFailed: 'Nie udało się zapisać lokalizacji',
        footer:
          'Przeciągnij pinezkę (lub dotknij mapy) do dokładnego miejsca Twojej restauracji - stąd mierzymy odległość dostawy.',
        currentCoords: (lat, lng) => ` Obecnie: ${lat}, ${lng}.`,
        clear: 'Usuń lokalizację',
        cleared: 'Lokalizacja usunięta',
        clearFailed: 'Nie udało się usunąć lokalizacji',
      },
    },
    mapPicker: {
      searchPlaceholder: 'Szukaj adresu…',
      search: 'Szukaj',
      noResults:
        'Nie znaleziono - spróbuj bardziej precyzyjnej nazwy/adresu albo ustaw pinezkę ręcznie.',
      pickHint: 'Wybierz najbliższe dopasowanie, a następnie przeciągnij pinezkę, aby dostroić:',
      unavailable:
        'Mapa niedostępna - ustaw VITE_MAPBOX_TOKEN, aby włączyć ustawianie lokalizacji.',
    },
    polygonEditor: {
      unavailable: 'Mapa niedostępna - ustaw VITE_MAPBOX_TOKEN, aby rysować obszary dostawy.',
      restaurant: 'Restauracja',
      editingArea: 'Ten obszar (edycja)',
      newArea: 'Ten obszar (nowy)',
    },
  },

  orderCapacity: {
    save: 'Zapisz',
    saving: 'Zapisywanie…',
    pickup: 'Odbiór',
    delivery: 'Dostawa',
    unsavedConfirm: 'Masz niezapisane zmiany na tym kanale. Przełączyć i odrzucić je?',
    unsavedTitle: 'Niezapisane zmiany',
    everyDay: 'Codziennie',
    dayNamesShort: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
    dayNamesLong: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    noCap: 'bez limitu',
    ordersPerHour: (n) => `${n} zamówień/godz.`,
    ordersPerSlotMin: (n, slot) => `${n} zamówień / ${slot} min`,
    holidayCapText: (max, slot) => `${max} zamówień/${slot}min`,
    ordersWithUnit: (cap, unit) => `${cap} zamówień${unit}`,
    defaultCapacity: 'Domyślna pojemność',
    defaultCapacityFooter:
      'Długość slotu, liczba zamówień na slot, czas przygotowania i minimalne wyprzedzenie dla tego kanału. Pozostaw limit pusty, aby nie ustawiać ograniczenia.',
    slotIntervalLabel: 'Interwał slotu (min)',
    slotLengthLabel: 'Długość przedziału (min)',
    ordersPerSlotLabel: 'Zamówienia na slot',
    maxOrdersPerHourLabel: 'Maks. zamówień na godzinę',
    capacityWindowLabel: 'Okno pojemności (min)',
    capacityWindowFooter:
      'Okno, w którym liczony jest limit. Zostaw puste, aby limit obowiązywał na przedział. Ustaw szersze (wielokrotność przedziału), aby rozłożyć limit na dłuższy czas — np. przedział 15 + okno 60: goście rezerwują co 15 min, ale limit liczy się na godzinę.',
    capacityWindowAlert:
      'Okno pojemności musi być całkowitą wielokrotnością przedziału (lub puste, aby limitować na przedział).',
    prepTimeLabel: 'Czas przygotowania w kuchni (min)',
    minNoticeLabel: 'Min. wyprzedzenie dla przedzamówień (min)',
    openingBufferLabel: 'Najwcześniej po otwarciu (min)',
    nonePlaceholder: 'brak',
    preview: 'Podgląd',
    defaultFooter:
      'Zamówienia online są zgodne z Twoimi godzinami otwarcia. Dodaj poniżej godziny specjalne dla innych pór w określone dni.',
    capAlert: 'Limit musi być dodatnią liczbą całkowitą (lub puste dla braku limitu)',
    slotAlert: 'Długość slotu musi być dodatnią liczbą całkowitą',
    prepNoticeAlert: 'Przygotowanie / wyprzedzenie muszą być liczbami całkowitymi (lub puste)',
    openingBufferAlert: (max: number) =>
      `Najwcześniej po otwarciu musi być liczbą całkowitą od 0 do ${max}`,
    saveErrorGeneric:
      'Nie udało się zapisać domyślnej pojemności - odśwież stronę i spróbuj ponownie.',
    saveFailedTitle: 'Zapis nie powiódł się',
    setDefaultFirst: 'Najpierw ustaw domyślną pojemność',
    specialHours: 'Godziny specjalne',
    noSpecialHours: 'Brak - domyślne obowiązują codziennie.',
    pausedSuffix: (label) => `${label} · wstrzymane`,
    holidayHours: 'Godziny świąteczne',
    holidayFooter:
      'Nadpisania w zakresie dat, które zastępują ZARÓWNO godziny specjalne, JAK I normalne (otwarcie/zamknięcie + pojemność), gdy są aktywne.',
    noHolidays: 'Brak - obowiązują godziny normalne i specjalne.',
    offSuffix: (name) => `${name} · wył.`,
  },

  orders: {
    acceptOrder: 'Przyjmij zamówienie',
    markCompleted: 'Oznacz jako zakończone',
    cancelOrder: 'Anuluj zamówienie',
    undoCompletion: 'Cofnij zakończenie',
    restoreOrder: 'Przywróć zamówienie',
    status: {
      PENDING: 'Oczekujące',
      CONFIRMED: 'Potwierdzone',
      COMPLETED: 'Zakończone',
      CANCELLED: 'Anulowane',
    },
    type: {
      PICKUP: 'Odbiór',
      DELIVERY: 'Dostawa',
    },
    itemCount: (count) => `${count} ${count !== 1 ? 'pozycji' : 'pozycja'}`,
    emptyState: {
      noSelection: {
        title: 'Nie wybrano zamówienia',
        description: 'Wybierz zamówienie z listy, aby zobaczyć jego szczegóły tutaj.',
      },
      notFound: {
        title: 'Nie znaleziono zamówienia',
      },
      loadError: {
        title: 'Nie udało się załadować zamówień',
        description: 'Spróbuj ponownie.',
      },
      noOrders: {
        title: 'Brak zamówień',
        filteredDescription: 'Żadne zamówienie nie pasuje do wybranych filtrów.',
        defaultDescription: 'Zamówienia pojawią się tutaj, gdy klienci je złożą.',
      },
    },
    action: {
      acceptOrder: {
        success: 'Zamówienie przyjęte',
      },
      completeOrder: {
        confirm: 'Oznaczyć to zamówienie jako zakończone?',
        title: 'Zakończ zamówienie',
        success: 'Zamówienie zakończone',
      },
      cancelOrder: {
        confirm: 'Anulować to zamówienie?',
        title: 'Anuluj zamówienie',
        success: 'Zamówienie anulowane',
      },
      undoCompletion: {
        confirm:
          'Cofnąć zakończenie? Zamówienie zostanie anulowane, gotówka wróci do stanu nieodebranej, a przyznane punkty zostaną cofnięte. Gość nie dostanie powiadomienia.',
        title: 'Cofnij zakończenie',
        success: 'Zakończenie cofnięte',
      },
      restoreOrder: {
        confirm:
          'Przywrócić to zamówienie jako zakończone? Gotówka znów zostanie zaksięgowana jako odebrana, a punkty naliczone ponownie. Gość nie dostanie powiadomienia.',
        title: 'Przywróć zamówienie',
        success: 'Zamówienie przywrócone',
      },
    },
    acceptSheet: {
      title: 'Przyjmij zamówienie',
      confirm: 'Potwierdź i rozpocznij',
      failed: 'Nie udało się przyjąć zamówienia.',
      prepLabel: 'Czas przygotowania',
      deliveryLabel: 'Czas dostawy',
      minutes: (m) => `${m} min`,
      readyForPickup: 'Gotowe do odbioru',
      foodReady: 'Jedzenie gotowe',
      deliveredBy: 'Dostawa do',
      scheduledFor: 'Zaplanowano na',
      startPrepBy: 'Rozpocznij przygotowanie',
      driverLeaves: 'Kierowca wyrusza',
      now: 'Teraz',
    },
    cancelSheet: {
      keep: 'Zachowaj zamówienie',
      refundToggle: 'Zwróć klientowi',
      refundLine: (amount: string, provider: string) =>
        `Anulowanie zwróci klientowi ${amount} przez ${provider}.`,
      noRefundWarning: 'Anuluj bez zwrotu — klient nie odzyska pieniędzy.',
      failed: 'Nie można anulować zamówienia.',
    },
    payment: {
      acceptProof: {
        confirm: 'Zaakceptować ten dowód płatności?',
        title: 'Zaakceptuj dowód',
        success: 'Dowód zaakceptowany',
      },
      rejectProof: {
        prompt: 'Powód odrzucenia',
        title: 'Odrzuć dowód',
        success: 'Dowód odrzucony',
      },
    },
    paymentStatus: {
      PENDING_COLLECTION: 'Oczekuje na płatność',
      AWAITING_PROOF: 'Oczekuje na dowód',
      PROOF_SUBMITTED: 'Dowód przesłany',
      PROCESSING: 'Przetwarzanie',
      PAID: 'Opłacone',
      REJECTED: 'Odrzucone',
      VOID: 'Unieważnione',
      REFUNDED: 'Zwrócone',
      PARTIALLY_REFUNDED: 'Częściowo zwrócone',
      AWAITING_CARD_PAYMENT: 'Oczekuje na płatność kartą',
    },
    paymentMethod: {
      CASH: 'Gotówka',
      MANUAL: 'Przelew bankowy',
      ONLINE: 'Karta',
    },
    refund: {
      reasons: {
        CUSTOMER_REQUEST: 'Prośba klienta',
        ITEM_UNAVAILABLE: 'Pozycja niedostępna',
        WRONG_ITEM: 'Błędna pozycja',
        LATE_DELIVERY: 'Opóźniona dostawa',
        CANCELLED_BY_OWNER: 'Anulowane przez właściciela',
        OTHER: 'Inny',
      },
      issued: 'Zwrot wykonany',
      now: 'Zwróć teraz',
      confirmNow: (amount) => `Zwrócić klientowi ${amount} teraz?`,
      failed: 'Nie można wykonać zwrotu.',
      failedReason: (reason) => `Zwrot nie powiódł się: ${reason}`,
      recordedPending: 'Zwrot zarejestrowany — wypłata oczekuje.',
      info: (amount) => `Do zwrotu maks. ${amount}.`,
      amountLabel: 'Kwota',
      reasonLabel: 'Powód',
      amountError: 'Wprowadź kwotę między 0 a pozostałą kwotą do zwrotu.',
      outOfBandNote:
        'Zwroty za tę płatność kartą są obsługiwane poza aplikacją przez Twojego dostawcę płatności.',
      button: 'Wykonaj zwrot',
      submitButton: (amount) => `Zwróć ${amount}`,
    },
    section: {
      items: 'Pozycje',
      deliveryAddress: 'Adres dostawy',
      payment: 'Płatność',
      refund: 'Zwrot',
      customerNote: 'Notatka klienta',
      timeline: 'Oś czasu',
      labels: 'Etykiety',
    },
    // Operator triage tags on an order (chip row on the detail, compact
    // pills on the list rows). Label NAMES are owner data — never translated.
    fields: {
      status: 'Status',
      kitchen: 'Kuchnia',
      subtotal: 'Suma częściowa',
      deliveryFee: 'Opłata za dostawę',
      discount: 'Rabat',
      promoCode: 'Kod promocyjny',
      total: 'Razem',
      method: 'Metoda',
      placed: 'Złożone',
      scheduledFor: 'Zaplanowane na',
      estimatedReady: 'Szacowana gotowość',
      prepStarted: 'Przygotowanie rozpoczęte',
      refunded: 'Zwrócone',
      acceptProof: 'Zaakceptuj dowód',
      rejectProof: 'Odrzuć dowód',
    },
    kitchen: {
      QUEUED: 'W kolejce',
      PREPARING: 'W przygotowaniu',
      READY: 'Gotowe',
      SERVED: 'Podane',
    },
    quickAction: {
      callCustomer: 'Zadzwoń do klienta',
      messageCustomer: 'Napisz do klienta',
      call: 'Zadzwoń',
      message: 'Wiadomość',
      printTicket: 'Drukuj bon',
      printTicketAria: 'Wydrukuj bon kuchenny dla tego zamówienia',
      printQueued: 'Bon kuchenny w kolejce',
      printQueuedMany: (n: number) => `${n} bonów kuchennych w kolejce`,
      printFailed: 'Nie udało się dodać bonu do kolejki',
    },
    pause: {
      live: 'Aktywne',
      paused: 'Wstrzymane',
      pausedUntilClose: 'Wstrzymane · zamknięcie',
      pausedUntilTime: (time) => `Wstrzymane · ${time}`,
      action: {
        label: (label) => `Zamawianie ${label}`,
        pause30: 'Wstrzymaj 30 minut',
        pause1hour: 'Wstrzymaj 1 godzinę',
        pauseHours: (n) => `Wstrzymaj na ${n} godziny`,
        pauseUntilClose: 'Wstrzymaj do zamknięcia',
        resumeNow: 'Wznów teraz',
      },
      toast: {
        paused: (label) => `${label} wstrzymane`,
        pausedFor: (label, minutes) => `${label} wstrzymane na ${minutes} minut`,
        pausedUntilClose: (label) => `${label} wstrzymane do zamknięcia`,
        resumed: (label) => `${label} wznowione`,
      },
    },
    summary: {
      total: 'Razem',
      pending: 'Oczekujące',
      confirmed: 'Potwierdzone',
    },
    page: {
      title: 'Zamówienia',
    },
    detail: {
      title: 'Zamówienie',
    },
    list: {
      section: {
        pending: 'Oczekujące',
        confirmed: 'Potwierdzone',
        completed: 'Zakończone',
        cancelled: 'Anulowane',
      },
    },
    stages: {
      NEEDS_REVIEW: 'Płatność do sprawdzenia',
      NEEDS_ACCEPTANCE: 'Nowe zamówienia',
      IN_KITCHEN: 'W kuchni',
      READY: 'Gotowe',
      AWAITING_PAYMENT: 'Oczekiwanie na płatność klienta',
      COMPLETED: 'Zakończone',
      CANCELLED: 'Anulowane',
    },
    summaryBar: {
      pending: 'Wymaga działania',
      active: 'Aktywne',
      overdue: 'Zaległe',
    },
    all: 'Wszystkie',
    filter: 'Filtr',
    now: 'Teraz',
    copy: 'Kopiuj',
    addressCopied: 'Skopiowano adres',
    phoneCopied: 'Skopiowano numer telefonu',
    tel: 'Tel.:',
    openInMaps: 'Otwórz w Mapach Google',
    mapRoute: 'Trasa',
    mapDestination: 'Cel',
    deliveryDistance: (distance: string) => `${distance} od restauracji`,
    expired: 'Wygasło',
    autoCancelsIn: 'Automatyczne anulowanie za',
    pickupLocation: 'Miejsce odbioru',
    paymentProof: 'Dowód płatności',
    zoneMethod: {
      STRAIGHT_LINE: 'odległość w linii prostej',
      ROUTE_DISTANCE: 'odległość drogowa (MapBox)',
      POLYGON: 'strefa na mapie',
    },
    zoneLabel: (label, method) => `Strefa: ${label} · ${method}`,
    ordersCount: (n) => `${n} ${n === 1 ? 'zamówienie' : 'zamówień'}`,
    ordersByHour: (n) => `${n} ${n === 1 ? 'zamówienie' : 'zamówień'} na godzinę`,
    ordersByHourLabel: 'Zamówienia na godzinę',
    chartBusiest: (label, count) => `. Szczyt ${label} · ${count}`,
    capacityPerHour: (cap, label) => `${cap}/godz ${label}`,
    nextTwoHours: (n) => `Najbliższe 2 godz · ${n} ${n === 1 ? 'zamówienie' : 'zamówień'}`,
    sectionCount: (label, count) => `${label} · ${count}`,
    proof: {
      openPdf: 'Otwórz przesłany dowód PDF',
      alt: 'Dowód płatności klienta',
      openFullSize: 'Otwórz w pełnym rozmiarze',
      customerStated: (amount) => `Klient podał: ${amount}`,
      uploaded: (when) => `Przesłano ${when}`,
      rejectHint:
        'Zamówienie pozostaje otwarte - klient może przesłać ponownie do terminu płatności.',
      rejectSuccess: 'Dowód odrzucony - zamówienie pozostaje otwarte do ponownego przesłania',
    },
    paymentStatusLabels: {
      PENDING_COLLECTION: 'Oczekuje na pobranie',
      AWAITING_PROOF: 'Oczekuje na dowód',
      PROOF_SUBMITTED: 'Dowód przesłany',
      PROCESSING: 'Przetwarzanie',
      ON_HOLD: 'W trakcie weryfikacji',
      PAID: 'Opłacone',
      REJECTED: 'Odrzucone',
      VOID: 'Unieważnione',
      REFUNDED: 'Zwrócone',
      PARTIALLY_REFUNDED: 'Częściowo zwrócone',
      awaitingCardPayment: 'Oczekuje na płatność kartą',
      underReviewByProvider: 'W weryfikacji przez dostawcę',
      awaitingCardCollection: 'Oczekuje na pobranie kartą',
    },
    methodKind: {
      CASH: 'Gotówka',
      CARD_ON_HANDOFF: 'Karta przy odbiorze',
      MANUAL: 'Przelew bankowy',
      ONLINE: 'Karta',
      GIFT_CARD: 'Karta podarunkowa',
    },
    pill: {
      paid: 'Opłacone',
      refunded: 'Zwrócone',
      awaiting: 'Oczekuje na płatność',
      failed: 'Płatność nieudana',
      refundNeeded: 'Wymagany zwrot',
    },
    refundExtra: {
      max: (amount, currency) => `Maks ${amount} (${currency})`,
      confirmSettled: 'Potwierdź rozliczenie',
      settled: '✓ Rozliczone',
      failed: 'Zwrot nie powiódł się',
      settlePrompt: 'Potwierdź, że wypłaciłeś ten zwrot klientowi poza aplikacją?',
      settleTitle: 'Potwierdź rozliczenie zwrotu',
      settledToast: 'Zwrot rozliczony',
      pending: (amount) => `+${amount} oczekuje`,
      pendingShort: 'Zwrot w toku',
    },
    channelStatus: {
      open: 'Otwarte',
      closed: 'Zamknięte',
      paused: 'Wstrzymane',
      close: 'zamknięcie',
    },
    timing: {
      asap: 'Jak najszybciej',
      labelScheduled: 'Zaplanowane',
      labelReadyBy: 'Gotowe do',
      labelDeliveredBy: 'Dostawa do',
      labelPlaced: 'Złożone',
      dueNow: 'termin teraz',
      inMin: (m) => `za ${m} min`,
      inHrMin: (h, m) => (m ? `za ${h} godz ${m} min` : `za ${h} godz`),
      minOverdue: (m) => `${m} min po terminie`,
      hrMinOverdue: (h, m) => (m ? `${h} godz ${m} min po terminie` : `${h} godz po terminie`),
      placedAgo: (ago) => `złożone ${ago}`,
      justNow: 'przed chwilą',
      minAgo: (m) => `${m} min temu`,
      hrMinAgo: (h, m) => (m ? `${h} godz ${m} min temu` : `${h} godz temu`),
      chipScheduled: 'zaplanowane',
      chipReady: 'gotowe',
      chipOverdue: 'po terminie',
      shortNow: 'teraz',
      shortMin: (m) => `${m}m`,
      shortHr: (h) => `${h}godz`,
    },
    awaitingPayment: {
      title: 'Czeka na płatność gościa',
      tooltip: 'Czeka na płatność gościa',
      refresh: 'Odśwież',
      loadError: 'Nie udało się wczytać zamówień oczekujących na płatność.',
      empty: 'Brak zamówień oczekujących na płatność',
      emptyDescription:
        'Tutaj pojawiają się zamówienia czekające na potwierdzenie przelewu lub płatność online.',
      footer:
        'Te zamówienia nie trafiły jeszcze do kolejki kuchni. Przejdą do Zamówień po potwierdzeniu płatności, a po upływie terminu zostaną automatycznie anulowane.',
      expiresIn: 'Termin płatności:',
      noDeadline: 'brak terminu',
      call: (name: string) => `Zadzwoń do ${name}`,
    },
    history: {
      title: 'Historia zamówień',
      tooltip: 'Historia zamówień',
      refresh: 'Odśwież',
      loading: 'Ładowanie zamówień…',
      loadError: 'Nie udało się załadować historii.',
      tryAgain: 'Spróbuj ponownie',
      empty: 'Brak zamówień w tym zakresie.',
      today: 'Dziś',
      yesterday: 'Wczoraj',
      filters: 'Filtry',
      reset: 'Resetuj',
      showOrders: 'Pokaż zamówienia',
      prevMonth: 'Poprzedni miesiąc',
      nextMonth: 'Następny miesiąc',
      weekdayInitials: ['N', 'P', 'W', 'Ś', 'C', 'P', 'S'],
      tabs: {
        all: 'Wszystkie',
        pending: 'Oczekujące',
        active: 'Aktywne',
        done: 'Gotowe',
        void: 'Unieważnione',
      },
      statusLabel: {
        PENDING: 'Oczekujące',
        CONFIRMED: 'W trakcie',
        COMPLETED: 'Zakończone',
        CANCELLED: 'Anulowane',
      },
    },
  },

  print: {
    // Server Direct Print (shared: Printers list + Printer add/edit form)
    serverDirectTitle: 'Bezpośredni druk z serwera',
    serverDirectFooter:
      'Wprowadź te dwa adresy URL w ustawieniach bezpośredniego druku z serwera każdej drukarki Epson, razem z jej własnym ID drukarki (widocznym po otwarciu drukarki).',
    printUrlLabel: 'URL druku',
    notificationUrlLabel: 'URL powiadomień',
    printerIdLabel: 'ID drukarki',
    copyButton: 'Kopiuj',
    copied: (label) => `Skopiowano ${label}`,
    okButton: 'OK',

    // Printer status (shared: printer badges + status-history events)
    statusOnline: 'Online',
    statusOffline: 'Offline',
    statusError: 'Błąd',
    defaultBadge: 'Domyślna',

    // Printers list page
    couldntLoadPrinters: 'Nie udało się załadować drukarek',
    noPrintersTitle: 'Brak drukarek',
    noPrintersDesc:
      'Dodaj drukarkę kuchenną, aby wywoływane zamówienia były drukowane. Dotknij +, aby rozpocząć.',
    printersTitle: 'Drukarki',
    printersFooter:
      'Status aktualizuje się, gdy każda drukarka się zgłasza. Drukarka, która nie zgłaszała się ostatnio, pokazuje Offline; zlecenia w kolejce czekają i drukują się, gdy wróci.',
    queued: (n) => `${n} w kolejce`,
    noJobsQueued: 'Brak zleceń w kolejce',
    routingAndHistoryTitle: 'Kierowanie i historia',
    routingTitle: 'Kierowanie zleceń',
    historyTitle: 'Historia druku',
    behaviourTitle: 'Co drukować',

    // What-to-print settings page
    behaviourPageTitle: 'Co drukować',
    behaviourPageFooter:
      'Wybierz, które potwierdzenia automatycznie drukują bilet. Bilety trafiają na drukarkę domyślną.',
    printOnlineOrdersLabel: 'Zamówienia online',
    printOnlineOrdersFooter:
      'Drukuje bilet kuchenny w chwili przyjęcia zamówienia na odbiór lub dostawę.',
    printReservationsLabel: 'Potwierdzone rezerwacje',
    printReservationsFooter:
      'Drukuje bilet dla obsługi po potwierdzeniu rezerwacji. Domyślnie wyłączone.',
    onlineOrdersUpdated: 'Zaktualizowano druk zamówień online',
    reservationsUpdated: 'Zaktualizowano druk rezerwacji',

    // Ticket text size
    textSizeTitle: 'Tekst biletu',
    textSizeLabel: 'Wielkość tekstu',
    textSizeMedium: 'Średni',
    textSizeLarge: 'Duży',
    textSizeFooter:
      'Duży tekst jest czytelniejszy z drugiego końca kuchni, ale mieści mniej w wierszu i zużywa około dwa razy więcej papieru. Sprawdź go wydrukiem testowym na drukarce.',
    textSizeUpdated: 'Zaktualizowano wielkość tekstu biletu',
    itemCategoryLabel: 'Pokaż kategorię pod każdą pozycją',
    itemCategoryFooter:
      'Drukuje kategorię menu w nawiasach pod każdą pozycją, np. [Napoje]. Przydatne, gdy jedna drukarka obsługuje kilka stanowisk; wyłącz, aby skrócić wydruk.',
    itemCategoryUpdated: 'Zaktualizowano wiersz kategorii',
    itemLabelTitle: 'Oznaczenie pozycji',
    itemLabelName: 'Tylko nazwa',
    itemLabelCodeAndName: 'Kod i nazwa',
    itemLabelCodeOnly: 'Tylko kod',
    itemLabelFooter:
      'Kody menu skracają wydruk, co ma największe znaczenie przy dużym tekście. Danie bez kodu zawsze drukuje swoją nazwę, niezależnie od wybranej opcji.',
    itemLabelUpdated: 'Zaktualizowano oznaczenie pozycji',
    dateTimeFormatLabel: 'Format daty',
    dateTimeFormatFooter:
      'Tak data jest drukowana na każdym wydruku. Godzina zawsze w formacie 24-godzinnym, np. 19:30.',
    dateTimeFormatUpdated: 'Zaktualizowano format daty',
    // Podgląd wydruku
    previewTitle: 'Podgląd wydruku',
    previewFooter:
      'Przykładowy wydruk z powyższymi ustawieniami – tak wydrukuje go drukarka. Rozmiar tekstu, kategorie i oznaczenie pozycji aktualizują go na bieżąco.',
    previewError: 'Nie udało się wygenerować podglądu.',

    // Printer add/edit form
    editPrinterTitle: 'Edytuj drukarkę',
    addPrinterTitle: 'Dodaj drukarkę',
    printerGone: 'Ta drukarka już nie istnieje.',
    nameLabel: 'Nazwa',
    namePlaceholder: 'np. Kuchnia, Bar, Lada',
    activeLabel: 'Aktywna',
    defaultPrinterLabel: 'Drukarka domyślna',
    defaultPrinterFooter:
      'Zlecenia dla kategorii menu bez określonej drukarki - oraz każde zamówienie online - są drukowane na drukarce domyślnej.',
    migratingTitle: 'Migrujesz drukarkę?',
    migratingFooter:
      'Masz już skonfigurowaną drukarkę Epson w starym systemie? Wklej tutaj jej ID drukarki, aby dalej drukowała bez ponownego parowania. Zostaw puste, aby wygenerować nowe.',
    existingIdLabel: 'Istniejące ID drukarki',
    existingIdPlaceholder: 'Zostaw puste, aby wygenerować nowe',
    printerSetupTitle: 'Konfiguracja drukarki',
    printerSetupFooter:
      'Otwórz ustawienia bezpośredniego druku z serwera drukarki i wprowadź URL druku, URL powiadomień oraz to ID drukarki, aby sparować ją z In-House.',
    // Wydruk testowy
    testPrintButton: 'Wydrukuj paragon testowy',
    testPrintSending: 'Wysyłanie…',
    testPrintFooter:
      'Wysyła wydruk testowy do tej drukarki. Pojawi się w ciągu kilku sekund od kolejnego zgłoszenia drukarki.',
    testPrintQueued: 'Wysłano wydruk testowy — sprawdź drukarkę',
    testPrintFailed: 'Nie udało się wysłać wydruku testowego.',

    statusHistoryTitle: 'Historia statusu',
    eventConnected: 'Połączono',
    noStatusEvents: 'Nie zarejestrowano jeszcze żadnych zmian statusu',
    noStatusEventsFooter: 'Stan połączenia i błędy pojawiają się tutaj na bieżąco.',
    nameRequired: 'Nadaj drukarce nazwę.',
    saveFailed: 'Nie udało się zapisać.',
    idFormatInvalid: 'ID drukarki musi mieć 8–16 liter i cyfr.',
    printerUpdated: 'Drukarka zaktualizowana',
    printerAdded: 'Drukarka dodana',

    // Ticket routing page (stations / pages)
    routingNoPrintersDesc:
      'Najpierw dodaj drukarkę, a następnie ustaw, gdzie drukuje się każde zamówienie.',
    noneSet: 'Nie ustawiono',
    noMenuCategories: 'Brak kategorii menu.',
    mainPrinterLabel: 'Drukarka główna',
    mainPrinterFooter:
      'Całe zamówienie drukuje się tutaj - a pozycje nieprzypisane do żadnej stacji poniżej również drukują się tutaj.',
    splitTitle: 'Podział na stacje',
    splitToggleLabel: 'Dziel bony kuchenne',
    splitFooter:
      'Wł.: każde zamówienie jest dzielone na drukarki stacji według stacji poniżej. Wył.: całe zamówienie drukuje się jako jeden bon na drukarce głównej.',
    splitUpdated: 'Zaktualizowano podział bonów',
    stationsTitle: 'Stacje',
    stationsFooter:
      'Każda stacja drukuje przypisane jej kategorie menu. Kategorie bez stacji drukują się na drukarce głównej.',
    addStationLabel: 'Dodaj stację',
    stationCategoriesCount: (n) => (n === 1 ? '1 kategoria' : `${n} kategorii`),
    stationSelectionSummary: (categories: number, products: number) => {
      const cat = categories === 1 ? '1 kategoria' : `${categories} kategorii`;
      if (products === 0) return cat;
      const prod = products === 1 ? '1 produkt' : `${products} produktów`;
      return `${cat} · ${prod}`;
    },
    expoTitle: 'Kopia zbiorcza',
    expoToggleLabel: 'Drukuj też pełny bon na drukarce głównej',
    expoFooter:
      'Drukuje jeden bon ze wszystkimi pozycjami na drukarce głównej - kopia dla wydawki. Stacje nadal otrzymują własne bony.',
    expoUpdated: 'Zaktualizowano kopię zbiorczą',

    // Station (page) edit form
    editStationTitle: 'Edytuj stację',
    addStationTitle: 'Dodaj stację',
    stationNameLabel: 'Nazwa',
    stationNamePlaceholder: 'np. Kuchnia gorąca, Bar, Grill',
    stationPrinterTitle: 'Drukarka',
    noActivePrinters: 'Brak aktywnych drukarek. Najpierw dodaj lub aktywuj jedną.',
    stationCategoriesTitle: 'Kategorie menu',
    stationCategoriesFooter: 'Zaznacz kategorie, które drukuje ta stacja.',
    stationMenuTitle: 'Menu — dotknij kategorię, aby rozwinąć',
    stationMenuFooter:
      'Zaznacz kategorię, aby drukować całą. Rozwiń i zaznacz pojedyncze produkty, aby przenieść je na tę stację.',
    viaCategory: 'przez kategorię',
    legendAll: 'Cała kategoria drukuje na tej stacji',
    legendPartial: 'Częściowo — niektóre produkty przypisane innej stacji',
    legendOther: 'Inna stacja obsługuje ten element',
    stationProductsTitle: 'Konkretne produkty',
    stationProductsFooter:
      'Produkty zaznaczone tutaj mają pierwszeństwo przed swoją kategorią — użyj, gdy jedna kategoria trafia na wiele stacji.',
    noMenuProducts: 'Brak produktów w menu.',
    claimedByStation: (station: string) => `Na ${station}`,
    stationDeleteButton: 'Usuń stację',
    stationGone: 'Ta stacja już nie istnieje.',
    stationSaved: 'Zapisano stację',
    stationDeleted: 'Usunięto stację',
    stationNameRequired: 'Nadaj stacji nazwę.',
    stationPrinterRequired: 'Wybierz drukarkę.',

    // Print history (jobs) page
    jobStatusAll: 'Wszystkie',
    jobStatusQueued: 'W kolejce',
    jobStatusPrinting: 'Drukowanie',
    jobStatusPrinted: 'Wydrukowane',
    jobStatusFailed: 'Nieudane',
    couldntLoadJobs: 'Nie udało się załadować historii druku',
    noJobsTitle: 'Brak zleceń druku',
    noJobsDesc: 'Zlecenia pojawią się tutaj, gdy zamówienia je wywołają.',
    receiptLabel: 'Paragon',
    kitchenTicketLabel: 'Zlecenie kuchenne',
    reprintButton: 'Drukuj ponownie',
    reprintQueued: 'Ponowny druk w kolejce',
    copyContent: 'Kopiuj treść wydruku',
    contentCopied: 'Skopiowano treść wydruku',
    reprintFooter:
      'Dotknij zlecenia, aby wydrukować je ponownie - nowe zlecenie trafia do kolejki; oryginał pozostaje w historii.',
  },

  promotions: {
    title: 'Promocje',
    newPromotion: 'Nowa promocja',
    editPromotion: 'Edytuj promocję',
    details: 'Szczegóły',
    name: 'Nazwa',
    namePlaceholder: 'Weekendowe -10%',
    description: 'Opis',
    descriptionPlaceholder: 'Wyświetlane klientom na stronie sklepu',
    discount: 'Rabat',
    discountType: {
      percentage: 'Rabat procentowy',
      fixedAmount: 'Rabat kwotowy',
      freeDelivery: 'Darmowa dostawa',
    },
    percentOff: 'Rabat procentowy',
    percentOffHint: 'np. 10 dla 10% rabatu',
    maxDiscount: (currency) => `Maksymalny rabat (${currency}, opcjonalnie)`,
    maxDiscountPlaceholder: 'Bez limitu',
    amountOff: (currency) => `Kwota rabatu (${currency})`,
    amountOffPlaceholder: '5,00',
    appliesto: 'Dotyczy',
    scope: {
      wholeOrder: 'Całe zamówienie',
      selectedItems: 'Wybrane pozycje',
    },
    conditions: 'Warunki',
    orderType: {
      dineIn: 'Na miejscu',
      pickup: 'Odbiór',
      delivery: 'Dostawa',
    },
    paymentMethodsTitle: 'Metody płatności',
    paymentMethodsFooter: 'Brak wyboru = dotyczy każdej metody płatności',
    paymentMethod: {
      cash: 'Gotówka',
      cardOnHandoff: 'Karta przy odbiorze/dostawie',
      online: 'Płatność online',
      manual: 'Przelew',
    },
    minimumOrder: (currency) => `Minimalne zamówienie (${currency}, opcjonalnie)`,
    minimumOrderPlaceholder: 'Bez minimum',
    dateWindow: 'Okres czasu',
    starts: 'Rozpoczyna się',
    startDate: 'Data rozpoczęcia',
    ends: 'Kończy się',
    endDate: 'Data zakończenia',
    howUnlocked: 'Jak jest odblokowywana',
    trigger: {
      automatic: 'Automatycznie (bez kodu)',
      codeRequired: 'Wymaga kodu',
    },
    codeType: {
      shared: 'Kod współdzielony (jeden kod, dla wszystkich)',
      personal: 'Kupony osobiste (wydawane dla klienta)',
    },
    code: 'Kod',
    codePlaceholder: 'SAVE10',
    maxRedemptions: 'Maksymalna liczba wykorzystań (opcjonalnie)',
    maxRedemptionsPlaceholder: 'Bez limitu',
    oncePerCustomer: 'Raz na klienta',
    visibilityStacking: 'Widoczność i łączenie',
    showOnStorefront: 'Pokaż na stronie sklepu',
    showOnStorefrontFooter: 'Baner + odznaki przy produktach dla gości',
    stackable: 'Łączona',
    stackableFooter: 'Może być łączona z innymi łączonymi promocjami',
    priority: 'Priorytet',
    priorityHint: 'Niższy jest stosowany jako pierwszy',
    savePromotion: 'Zapisz promocję',
    giveNameError: 'Nadaj promocji nazwę.',
    pickOrderTypeError: 'Wybierz przynajmniej jeden typ zamówienia.',
    chooseDiscountError: 'Wybierz, czego dotyczy rabat.',
    saved: 'Promocja zapisana',
    issuePersonalCoupon: 'Wydaj kupon osobisty',
    customer: 'Klient',
    customerSearchPlaceholder: 'Szukaj po imieniu lub telefonie',
    change: 'Zmień',
    couponCode: 'Kod kuponu',
    couponCodePlaceholder: 'VIP-JANE',
    sharable: 'Do udostępniania',
    sharableFooter: 'Każdy, kto ma kod, może go wykorzystać, nie tylko ten klient',
    issuing: 'Wydawanie…',
    issueCoupon: 'Wydaj kupon',
    pickCustomerError: 'Najpierw wybierz klienta.',
    enterCouponError: 'Wprowadź kod kuponu.',
    couponIssuedTo: (customerName) => `Kupon wydany dla ${customerName}`,
    active: 'Aktywne',
    all: 'Wszystkie',
    couldNotLoadError: 'Nie udało się załadować promocji',
    noneRunning: 'Nic nie jest teraz aktywne',
    noneRunningDescription: 'Zakończone i zaplanowane oferty znajdziesz w zakładce Wszystkie.',
    noneYet: 'Brak promocji',
    noneYetDescription:
      'Utwórz rabat - procentowy lub kwotowy, odblokowywany automatycznie lub kodem. Dotknij +.',
    codeDisplay: (code) => `Kod: ${code}`,
    archivedBadge: 'Zarchiwizowana',
    scheduledBadge: 'Zaplanowana',
    expiredBadge: 'Wygasła',
    codeBadge: 'Kod',
    archive: 'Archiwizuj',
    archiveConfirm: (name) =>
      `Zarchiwizować "${name}"? Zostanie natychmiast dezaktywowana; historia wykorzystań jest zachowywana.`,
    archiveTitle: 'Archiwizuj promocję',
    archived: 'Promocja zarchiwizowana',
    howWorks: 'Jak działają promocje',
    howWorksDescription:
      'Promocje automatyczne są stosowane przy płatności bez kodu. Promocje z kodem wymagają kodu współdzielonego (dla wszystkich) lub kuponu osobistego, który wydajesz dla klienta. Rabaty są widoczne na stronie sklepu i obniżają sumę zamówienia.',
    // Zwięzłe etykiety na liście promocji.
    summaryPercent: (pct) => `${pct}% zniżki`,
    summaryAmount: (amount) => `${amount} zniżki`,
    summaryWholeOrder: 'całe zamówienie',
    summaryCategories: (n) => `${n} kategorie`,
    summaryProducts: (n) => `${n} produkty`,
    summaryCashOnly: 'Tylko gotówka',
    // Stany i dodatkowa walidacja na stronie edycji.
    endBeforeStartError: 'Data zakończenia nie może być wcześniejsza niż data rozpoczęcia.',
    scheduleWindowError:
      'Sprawdź okna dni i godzin - każda godzina zakończenia musi być po godzinie rozpoczęcia.',
    loadingMenu: 'Ładowanie menu…',
    menuLoadError: 'Nie udało się załadować menu. Pociągnij, aby spróbować ponownie.',
    noCategoriesYet: 'Brak kategorii - najpierw dodaj je w sekcji Menu.',
    noProductsYet: 'Brak produktów - najpierw dodaj je w sekcji Menu.',
    // Tygodniowy harmonogram dni/godzin.
    daysAndHours: 'Dni i godziny',
    limitToDays: 'Ogranicz do wybranych dni i godzin',
    limitToDaysFooter: 'Wyłączone = obowiązuje każdego dnia w powyższym zakresie dat',
    windowLabel: (n) => `Okno ${n}`,
    hours: 'Godziny',
    addWindow: 'Dodaj okno',
    startAria: (day) => `${day} początek`,
    endAria: (day) => `${day} koniec`,
    removeWindow: 'Usuń okno',
    customerFallback: 'Klient',
    // Historia wydanych kuponów (szczegóły) + kupony osobiste klienta.
    issuedCoupons: 'Wydane kupony',
    noCouponsIssued: 'Nie wydano jeszcze kuponów',
    customerCoupons: 'Kupony osobiste',
    noCustomerCoupons: 'Brak kuponów osobistych',
    couponUnused: 'Niewykorzystany',
    couponRedeemed: 'Wykorzystany',
    couponIssuedOn: (date) => `Wydano ${date}`,
    couponRedeemedOn: (date) => `Użyto ${date}`,
    loadingCoupons: 'Ładowanie kuponów…',
    couldNotLoadCoupons: 'Nie udało się załadować kuponów',
    // Tryb Prosty / Zaawansowany.
    simpleMode: 'Prosty',
    advancedMode: 'Zaawansowany',
    advancedValuesHint:
      'Ten rabat używa opcji zaawansowanych - przełącz na Zaawansowany, aby je zobaczyć i edytować.',
    // Etykiety pól wyboru.
    discountTypeLabel: 'Typ',
    triggerLabel: 'Wyzwalacz',
    codeTypeLabel: 'Typ kodu',
  },

  reports: {
    overview: {
      netSales: 'Sprzedaż netto',
      onlineOrders: 'Zamówienia online',
      dineInTabs: 'Rachunki na miejscu',
      tips: 'Napiwki',
      refunds: 'Zwroty',
      discounts: 'Rabaty',
      vsPrevious: (baseline) => `wzgl. ${baseline}`,
      couldntLoad: 'Nie udało się wczytać raportów',
      noSales: 'Brak sprzedaży w tym okresie',
      noSalesHint: 'Wybierz inny okres lub wróć, gdy pojawią się zamówienia.',
      seeAllItems: 'Zobacz wszystkie',
      detailedReports: 'Raporty szczegółowe',
      tabSales: 'Sprzedaż',
      tabOperations: 'Obsługa',
      trendNeedsMoreDays: 'Wybierz dłuższy okres, aby zobaczyć trend.',
      byHour: 'Wg godziny',
      tablesUsed: 'Użyte stoliki',
      turnsPerTable: (turns) => `${turns} obłożeń na stolik`,
      avgDwell: 'Śr. czas pobytu',
      minutes: (count) => `${count} min`,
      busiestTables: 'Najbardziej obłożone stoliki',
      turns: (count) => `${count} obłożeń`,
    },
    periodSelector: {
      current: 'Okres',
      compare: 'Porównanie z',
      basis: {
        previousPeriod: 'Poprzedni okres',
        samePeriodLastYear: 'Rok wcześniej',
      },
    },
    salesOverview: {
      title: 'Przegląd sprzedaży',
      netSales: 'Sprzedaż netto',
      gross: 'Sprzedaż brutto',
      covers: 'Liczba gości',
      avgTab: 'Śr. rachunek',
      revenueTrend: 'Trend przychodów',
      byChannel: 'Według kanału',
      online: 'Online',
      dineIn: 'Na miejscu',
      byTimeOfDay: 'Według pory dnia',
    },
    dayParts: {
      breakfast: 'Śniadanie',
      lunch: 'Obiad',
      afternoon: 'Popołudnie',
      dinner: 'Kolacja',
      late: 'Późny wieczór',
    },
    dayEnd: {
      title: 'Zamknięcie dnia',
      day: 'Dzień',
      couldntLoad: 'Nie udało się załadować zamknięcia dnia',
      netReceived: 'Otrzymane netto',
      takings: 'Utarg',
      refunds: 'Zwroty',
      serviceCharge: 'Opłata serwisowa',
      tipsPayout: 'Napiwki (wypłata)',
      vat: 'VAT',
      openTabsWarning: (count, plural) =>
        `${count} ${plural} nadal otwarte - to dotychczasowy utarg, nie kwota końcowa.`,
      tabPlural: 'rachunek jest',
      tabsPluralForm: 'rachunki są',
      reconciliation: 'Od sprzedaży netto do utargu',
      netSales: 'Sprzedaż netto',
      deliveryFees: 'Opłaty za dostawę',
      refundsAddedBack: 'Zwroty (już odjęte powyżej)',
      otherDifference: 'Rozliczone innego dnia',
      byPaymentMethod: 'Według metody płatności',
      cashUp: 'Rozliczenie gotówki',
      expectedInDrawer: 'Oczekiwane w kasie',
      counted: 'Policzone',
      countedPlaceholder: 'Wprowadź policzoną kwotę',
      balanced: 'Zbilansowane',
      over: 'Nadwyżka',
      short: 'Niedobór',
    },
    paymentReconciliation: {
      title: 'Uzgodnienie płatności',
      couldntLoad: 'Nie udało się załadować raportu',
      paymentCount: (count, plural) => `${count} ${plural}`,
      paymentSingular: 'płatność',
      paymentPlural: 'płatności',
      grossTaken: 'Pobrane brutto',
      refunds: 'Zwroty',
      net: 'Netto',
      tips: 'Napiwki',
    },
    topItems: {
      title: 'Najlepiej sprzedające się',
      byQuantity: 'Według ilości',
      byRevenue: 'Według przychodu',
      couldntLoad: 'Nie udało się załadować raportu',
      noSalesYet: 'Brak sprzedaży',
      noItemsSoldInRange: 'W tym okresie nie sprzedano żadnych pozycji.',
      sold: (quantity) => `sprzedano ${quantity}`,
    },
    rangePresets: {
      today: 'Dziś',
      yesterday: 'Wczoraj',
      thisWeek: 'Ten tydzień',
      last7: 'Ostatnie 7',
      thisMonth: 'Ten miesiąc',
    },
  },

  reservationSetup: {
    title: 'Konfiguracja rezerwacji',
    bookings: 'Rezerwacje',
    bookingsFooter:
      'Włącz lub wyłącz rezerwacje online, automatycznie potwierdzaj prośby albo wstrzymaj je do końca dzisiejszego dnia.',
    acceptingReservations: 'Przyjmowanie rezerwacji',
    on: 'Wł.',
    off: 'Wył.',
    stopAcceptingOnline:
      'Przestać przyjmować rezerwacje online? Strona rezerwacji zostanie ukryta przed gośćmi, a nowe prośby będą odrzucane, dopóki nie włączysz tego ponownie.',
    turnReservationsOff: 'Wyłącz rezerwacje',
    startAcceptingOnline: 'Ponownie zacząć przyjmować rezerwacje online?',
    turnReservationsOn: 'Włącz rezerwacje',
    reservationsTurnedOff: 'Rezerwacje wyłączone',
    reservationsTurnedOn: 'Rezerwacje włączone',
    confirmation: 'Potwierdzanie',
    howBookingsConfirmed: 'Jak potwierdzane są rezerwacje',
    automaticConfirm: 'Automatyczne - potwierdzaj natychmiast',
    bookingsAutoConfirmed: 'Rezerwacje potwierdzane automatycznie',
    manualConfirm: 'Ręczne - personel sprawdza każdą prośbę',
    bookingsManualReview: 'Rezerwacje wymagają ręcznego sprawdzenia',
    confirmationAutomatic: 'Automatyczne',
    confirmationManual: 'Sprawdzanie ręczne',
    confirmationFooter:
      'Gdy wyłączone, strona rezerwacji jest ukryta przed gośćmi, a nowe rezerwacje online są odrzucane. Przy automatycznym potwierdzaniu prośba jest rezerwowana natychmiast; sprawdzanie ręczne utrzymuje ją jako oczekującą, dopóki personel jej nie zaakceptuje.',
    partySize: 'Liczba osób',
    partySizeFooter:
      'Największa grupa, jaką goście mogą zarezerwować online, oraz komunikat wyświetlany po przekroczeniu tej liczby.',
    largestParty: 'Największa grupa',
    maxGuestsPerBooking: 'Maksymalna liczba gości na rezerwację',
    partySizeUpdated: 'Liczba osób zaktualizowana',
    guestsCount: (count) => `${count} gości`,
    largePartyMessage: 'Komunikat dla dużych grup',
    largePartyMessageHidden: 'Ukryty',
    shownToGuestsAboveMax:
      'Wyświetlany gościom, których grupa przekracza maksimum (pozostaw puste, aby ukryć)',
    messageUpdated: 'Komunikat zaktualizowany',
    partySizeRange:
      'Zakres liczebności grup, jaki goście mogą wybrać przy rezerwacji online. Większe grupy widzą komunikat dla dużych grup zamiast formularza rezerwacji.',
    bookingWindow: 'Okno rezerwacji',
    bookingWindowFooter:
      'Z jakim wyprzedzeniem goście mogą rezerwować, próg ostatniej chwili oraz odstęp między godzinami możliwymi do rezerwacji.',
    guestsCanBookUpTo: 'Goście mogą rezerwować do',
    bookingHorizon: 'Horyzont rezerwacji',
    daysAheadGuests: 'Z ilu dni wyprzedzeniem goście mogą rezerwować',
    bookingWindowUpdated: 'Okno rezerwacji zaktualizowane',
    daysAhead: (count) => `${count} dni naprzód`,
    lastMinuteCutoff: 'Próg ostatniej chwili',
    hoursBeforeSlot:
      'Godziny przed przedziałem, w których zatrzymuje się rezerwacje (0 = do rozpoczęcia)',
    cutoffUpdated: 'Próg zaktualizowany',
    untilStart: 'Do rozpoczęcia',
    hoursBefore: (hours) => `${hours} godz. przed`,
    slotSpacing: 'Odstęp przedziałów',
    minutesBetweenBookableTimes: 'Minuty między godzinami możliwymi do rezerwacji',
    slotSpacingUpdated: 'Odstęp przedziałów zaktualizowany',
    lastBookingBeforeClose: 'Ostatnia rezerwacja przed zamknięciem',
    stopBookingsBeforeClose: 'Zakończ przyjmowanie rezerwacji przed zamknięciem',
    upToClose: 'Do zamknięcia',
    lastBookingBeforeCloseUpdated: 'Zaktualizowano ostatnią rezerwację przed zamknięciem',
    everyMinutes: (minutes) => `Co ${minutes} minut`,
    bookingWindowControls:
      'Steruje tym, jak daleko otwiera się kalendarz, jak blisko obsługi goście mogą jeszcze rezerwować oraz odstępem między godzinami do wyboru.',
    tableTiming: 'Czas stolika',
    tableTimingFooter:
      'Jak długo stolik jest zarezerwowany na jedną rezerwację, aby zwolnić się dla kolejnego gościa.',
    defaultTableTime: 'Domyślny czas stolika',
    tableHeldPerBooking:
      'Jak długo stolik jest zarezerwowany na rezerwację, w minutach (minimum 15)',
    tableTimeUpdated: 'Czas stolika zaktualizowany',
    tableTimingHint:
      'Jak długo każda rezerwacja domyślnie zajmuje stolik. Nadpisanie dla zmiany znajduje się w sekcji Pojemność; tam też ustawia się bufor obrotu między grupami (tryb zaawansowany).',
    noShows: 'Niestawienia się',
    noShowsFooter:
      'Ile czasu po godzinie rezerwacji nieobecny gość jest liczony jako niestawienie się.',
    noShowGracePeriod: 'Okres tolerancji niestawienia się',
    minutesPastBooking:
      'Minuty po godzinie rezerwacji, zanim gość zostanie uznany za niestawiającego się',
    gracePeriodUpdated: 'Okres tolerancji zaktualizowany',
    noShowsHint:
      'Okres tolerancji steruje alertami o niestawieniu się - personel jest powiadamiany, gdy rezerwacja jest spóźniona o tyle minut.',
    enterWholeNumber: (min) => `Wprowadź liczbę całkowitą ${min} lub większą`,
    enterWholeNumberBetween: (min, max) => `Wprowadź liczbę całkowitą od ${min} do ${max}`,
    saveFailed: 'Nie udało się zapisać',
    invalidValue: 'Nieprawidłowa wartość',
    couldntLoadSettings: 'Nie udało się załadować ustawień rezerwacji',
    checkConnection: 'Sprawdź połączenie i spróbuj ponownie.',
    capacity: 'Pojemność',
    capacityMode: 'Tryb pojemności',
    capacityModeFooter:
      'Wybierz, jak zarządzane są stoliki i miejsca - jeden wspólny limit, albo stoliki według stref z tempem.',
    simpleMode: 'Prosty',
    simpleModeDesc: 'Limity na przedział dla rezerwacji / gości. Bez przypisywania do stolików.',
    simpleModeConfirm: 'Przełączyć pojemność na tryb prosty?',
    simpleModeDetails:
      'Przedział to okno rezerwacji 60-minutowe - np. przedział o 19:00 liczy każdą rezerwację od 19:00 do 19:59.\n\nDomyślne limity obowiązują, gdy żadna zmiana specyficzna dla danego czasu nie obejmuje rezerwacji. Bez wartości domyślnej rezerwacje są przyjmowane tylko w ramach zmian specyficznych dla danego czasu.',
    advancedMode: 'Zaawansowany',
    advancedModeDesc: 'Limity tempa (goście / grupy na 15 minut) i przypisywanie do stolików.',
    advancedModeConfirm: 'Przełączyć pojemność na tryb zaawansowany?',
    advancedModeDetails:
      'Limity tempa obowiązują w każdym przesuwnym oknie 15-minutowym - bardziej szczegółowo niż prosty model przedziałów i lepiej dostosowane do ruchliwej obsługi.\n\nKażda rezerwacja jest również przypisywana do konkretnego stolika z planu sali, więc pojemność jest ograniczona zarówno limitami tempa, jak i fizycznymi miejscami.',
    capacityModeColon: (mode) => `Tryb pojemności: ${mode}`,
    failedSwitchMode: 'Nie udało się przełączyć trybu pojemności',
    // Capacity page - mode tile feature bullets
    simpleFeature1: 'Limity na przedział dla rezerwacji i gości',
    simpleFeature2: 'Jedno okno rezerwacji 60-minutowe na przedział',
    simpleFeature3: 'Bez przypisywania do stolików',
    advancedFeature1: 'Limity tempa na przesuwne 15 min',
    advancedFeature2: 'Limity jednoczesne (aktywnych naraz)',
    advancedFeature3: 'Przypisywanie do stolików z planu sali',
    // Capacity page - load error state
    couldntLoadCapacity: 'Nie udało się załadować ustawień pojemności',
    serverNoResponse: 'Serwer nie odpowiedział. Spróbuj ponownie.',
    retrying: 'Ponawianie…',
    tryAgain: 'Spróbuj ponownie',
    // Capacity page - inline labels / placeholders / footers (noLimitation reused from below)
    capacityAndLimit: 'Pojemność i limit',
    pacingTitle: 'Tempo',
    concurrentTitle: 'Jednoczesne',
    concurrentFooter:
      'Pozostaw puste dla braku ograniczeń. Zwykle ustawia się poniżej liczby stolików.',
    unassignedZone: 'Nieprzypisane',
    aboutSection: (title) => `O sekcji ${title}`,
    topGroup: (count, seats) => `${count}× na ${seats}`,
    tblShortSeats: (count, seats) => `${count} stol. · ${seats} miejsc`,
    noBookableTablesPrefix: 'Nie skonfigurowano jeszcze stolików do rezerwacji.',
    noBookableTablesSuffix: 'aby zaplanować pojemność ZAAWANSOWANĄ.',
    // Capacity page - shift list formatters
    everyDay: 'Codziennie',
    dayNamesShort: ['Nd', 'Pn', 'Wt', 'Śr', 'Cz', 'Pt', 'So'],
    dayNamesLong: ['Niedziela', 'Poniedziałek', 'Wtorek', 'Środa', 'Czwartek', 'Piątek', 'Sobota'],
    coversPer15: (n) => `${n} gości/15min`,
    partiesPer15: (n) => `${n} grup/15min`,
    windowSubtitle: (start, end, days) => `${start}–${end} · ${days}`,
    // Capacity page - preview timeline tooltips (resSlot/coversSlot/pacingCovers reused from below)
    capResCoversPerSlot: (res, covers) => `${res} rezerwacji / ${covers} gości na przedział`,
    tablesAvailable: 'Dostępne stoliki',
    manage: 'Zarządzaj',
    noBookableTables:
      'Nie skonfigurowano jeszcze stolików do rezerwacji. Dodaj stoliki, aby zaplanować pojemność ZAAWANSOWANĄ.',
    addTables: 'Dodaj stoliki',
    tblSeats: (count, seats) => `${count} stolików · ${seats} miejsc`,
    bookableTablesInfo: (tables, seats, zones, plural) =>
      `${tables} stolików do rezerwacji · ${seats} miejsc w ${zones} ${plural === '' ? 'strefie' : 'strefach'}. Pojemność ZAAWANSOWANA przypisuje każdą rezerwację do konkretnego stolika, więc pojemność miejsc jest ograniczona tym, co jest na sali.`,
    tableturnaround: 'Obrót stolika',
    tableturnaroundInfo:
      'Minuty, przez które stolik pozostaje zablokowany po zakończeniu rezerwacji, zanim będzie można posadzić przy nim kolejną grupę - sprzątanie, resetowanie, rozliczenie.\n\nStosowane dodatkowo do czasu trwania każdej rezerwacji przy przypisywaniu stolików. Używane tylko w trybie zaawansowanym (tryb prosty liczy przedziały, a nie zajętość stolików).',
    bufferMin: 'Bufor (min)',
    bufferUpdated: 'Bufor zaktualizowany',
    bufferMustBePositive: 'Bufor musi wynosić 0 lub więcej minut',
    bufferInfo:
      'Przerwa między dwiema grupami przy tym samym stoliku. 0 = jedna po drugiej. Dotyczy każdej zmiany zaawansowanej.',
    defaultPacing: 'Domyślne tempo (na 15 minut)',
    pacingInfo:
      'Tempo ogranicza częstotliwość przybyć - ile nowych rezerwacji może ROZPOCZĄĆ się w dowolnym przesuwnym oknie 15-minutowym.\n\n"Maks. gości" ogranicza łączną liczbę gości; "maks. grup" ogranicza łączną liczbę rezerwacji. Dwie grupy odległe o 20 minut nigdy nie trafią do tego samego okna tempa, nawet jeśli nakładają się na sali - do tego użyj limitów jednoczesnych poniżej.\n\nChroni moment przybycia gości: rozkręcanie kuchni, przepustowość witania / sadzania.',
    maxCovers: 'Maks. gości',
    maxParties: 'Maks. grup',
    defaultConcurrent: 'Domyślna jednoczesność (aktywnych naraz)',
    concurrentInfo:
      'Limity jednoczesności ograniczają liczbę rezerwacji, które mogą być AKTYWNE w danej chwili - tych, których przedział [początek, początek + czas trwania) obejmuje żądany czas.\n\nPrzydatne jako miękki limit poniżej liczby fizycznych miejsc: np. masz 12 stolików, ale wystarczająco personelu, by komfortowo obsłużyć 8 grup naraz.\n\nNiezależne od tempa: dwie grupy odległe o godzinę nigdy nie dzielą okna tempa, ale obie mogą zostać posadzone.',
    leaveBlankNoLimitation: 'Pozostaw puste dla braku limitu.',
    shiftOverrideWarning:
      'Zmiany czasowe poniżej ZASTĘPUJĄ te domyślne limity w swoich godzinach - ustaw limit również dla każdej zmiany, inaczej nie zadziała.',
    detailOverrideWarning:
      'Ta zmiana ZASTĘPUJE domyślne limity w swoich godzinach. Ustaw tutaj własne limity.',
    preview: 'Podgląd',
    defaultCoverage: 'Domyślnie · cały dzień',
    maxReservationsSlot: 'Maks. rezerwacji / przedział',
    capsLimit:
      'Ogranicza liczbę rezerwacji (grup), które mogą rozpocząć się w tym samym przedziale 60-minutowym - chroni obciążenie operacyjne, niezależnie od liczebności każdej grupy. Pozostaw puste dla braku limitu.',
    maxCoversSlot: 'Maks. gości / przedział',
    coversCapLimit:
      'Ogranicza łączną liczbę gości rozpoczynających w tym samym przedziale - suma liczebności wszystkich grup. Chroni pojemność miejsc. Pozostaw puste dla braku limitu.',
    clearDefault: 'Wyczyść wartość domyślną',
    removeDefaultCapacity:
      'Usunąć domyślną pojemność? Rezerwacje poza zmianą specyficzną dla danego czasu będą odrzucane.',
    timeSpecificShifts: 'Zmiany specyficzne dla czasu',
    noTimeSpecificShifts:
      'Brak zmian specyficznych dla czasu. Dodaj jedną, aby zacieśnić pojemność (lub otworzyć godziny rezerwacji dla określonego okna).',
    addAShift: 'Dodaj zmianę',
    newTimeSpecificShift: 'Nowa zmiana specyficzna dla czasu',
    name: 'Nazwa',
    lunchDinner: 'Obiad / Kolacja …',
    startTime: 'Godzina rozpoczęcia',
    endTime: 'Godzina zakończenia',
    shiftFooter:
      'Aktywna w każdy dzień tygodnia, z limitami odziedziczonymi z wartości domyślnej. Dotknij nowej zmiany, aby dopracować dni i zacieśnić jej limity.',
    shift: 'Zmiana',
    shiftNotFound: 'Nie znaleziono zmiany.',
    baselineEditedInline: 'Ta zmiana jest bazowa. Edytuj ją na stronie Pojemność.',
    timeSpecificShiftTitle: 'Zmiana specyficzna dla czasu',
    daysActive: 'Dni aktywne',
    capsSimple: 'Limity (Prosty)',
    maxReservationsSlotLabel: 'Maks. rezerwacji / przedział',
    maxReservationsInfo:
      'Ogranicza liczbę rezerwacji (grup), które mogą rozpocząć się w tym samym przedziale 60-minutowym - chroni obciążenie operacyjne, niezależnie od liczebności każdej grupy.',
    maxCoversSlotLabel: 'Maks. gości / przedział',
    maxCoversInfo:
      'Ogranicza łączną liczbę gości rozpoczynających w tym samym przedziale - suma liczebności wszystkich grup. Chroni pojemność miejsc.',
    leaveBlankStricter:
      'Pozostaw puste dla braku limitu. Surowsze niż wartość bazowa → ma pierwszeństwo w tym oknie.',
    pacingSimple: 'Tempo (na 15 minut)',
    concurrentSimple: 'Jednoczesne (aktywnych naraz)',
    partySizePacing:
      'Koszyki tempa według liczebności grup są zachowane bez zmian - nie ma tu jeszcze dla nich interfejsu.',
    deleteShift: 'Usuń zmianę',
    deleteShiftConfirm: (label) => `Usunąć zmianę "${label}"?`,
    shiftSaved: 'Zmiana zapisana',
    failedSaveShift: 'Nie udało się zapisać zmiany',
    failedDeleteShift: 'Nie udało się usunąć zmiany',
    nameRequired: 'Nazwa jest wymagana',
    timesMustBeHHmm: 'Godziny muszą być w formacie HH:mm',
    startBeforeEnd: 'Początek musi być przed końcem',
    pickAtLeastOneDay: 'Wybierz przynajmniej jeden dzień',
    capsPositiveWhole:
      'Limity muszą być dodatnimi liczbami całkowitymi (lub puste dla braku limitu)',
    tables: 'Stoliki',
    tableManagement: 'Zarządzanie stolikami',
    noZones: 'Brak stref. Najpierw dodaj strefę, a następnie dodaj stoliki.',
    addAZone: 'Dodaj strefę',
    noTablesYet: 'Brak stolików',
    addTablesLink: '+ Dodaj stoliki',
    seatTables: (seats) => `Stoliki na ${seats}`,
    seatsTotal: (seats, count) => `${seats * count} miejsc łącznie`,
    tablesCount: (count) => `${count} stolików`,
    addZone: '+ Dodaj strefę',
    newZone: 'Nowa strefa',
    zoneName: 'Nazwa strefy',
    zoneNameExample: 'np. Sala główna, Taras, Bar',
    zoneAdded: 'Strefa dodana',
    renameZone: 'Zmień nazwę strefy',
    zoneRenamed: 'Nazwa strefy zmieniona',
    deleteZone: 'Usuń strefę',
    addTableZone: (zone) => `Dodaj stoliki - ${zone}`,
    seatsPerTable: 'Miejsc na stolik',
    numberOfTables: 'Liczba stolików',
    addedTables: (count) => `Dodano ${count} stolików`,
    editSeatTables: (seats, zone) => `Stoliki na ${seats} - ${zone}`,
    setToDeactivateAll: 'Ustaw na 0, aby dezaktywować wszystkie',
    tableUpdated: 'Stolik zaktualizowany',
    removeAllTables: (count, seats, zone) =>
      `Usunąć wszystkie ${count} × stoliki na ${seats} z ${zone}?`,
    removeTables: 'Usuń stoliki',
    tablePlan: 'Plan stolików',
    advancedTables: 'Zaawansowane stoliki',
    simplesMode: 'Prosty',
    simpleModeTableDesc:
      'Zarządzaj stolikami według liczby i liczby miejsc. Plan sali nie jest wymagany.',
    switchSimple: 'Przełączyć na tryb prosty?',
    advancedModeTable: 'Zaawansowany',
    advancedModeTableDesc:
      'Umieść stoliki na planie sali 2D dla precyzyjnego układu i automatycznego przypisywania.',
    switchAdvanced: 'Przełączyć na tryb zaawansowany?',
    tableModeColon: (mode) => `Tryb stolików: ${mode}`,
    failedSwitchTableMode: 'Nie udało się przełączyć trybu stolików',
    tablesFloorPlan: 'Stoliki i plan sali',
    manageTables: 'Zarządzaj stolikami',
    batchAddTables: 'Dodaj stoliki zbiorczo',
    labelPrefix: 'Prefiks etykiety',
    labelPrefixExample:
      'Stoliki zostaną oznaczone S1, S2 … (kontynuując od najwyższego istniejącego)',
    seatCategories: 'Kategorie miejsc',
    seats: 'Miejsca',
    qty: '× Liczba',
    addSeatCategory: '+ Dodaj kategorię miejsc',
    createdTables: (count) => `Utworzono ${count} stolików`,
    editTable: 'Edytuj stolik',
    labelOverride: 'Nadpisanie etykiety',
    useAutoGenerated: 'Pozostaw puste, aby użyć automatycznie wygenerowanej etykiety',
    active: 'Aktywny',
    countsForCapacity: 'Liczy się do pojemności',
    bookableOnline: 'Możliwy do rezerwacji online',
    tableGone: 'Ten stolik już nie istnieje.',
    decrease: 'Zmniejsz',
    increase: 'Zwiększ',
    noTablesConfigured: 'Brak stolików. Użyj „Dodaj zbiorczo”, aby utworzyć stoliki.',
    floorPlan: 'Plan sali',
    dragDropEditor:
      'Edytor planu sali metodą przeciągnij i upuść jest już wkrótce. Zaplecze jest gotowe - ten ekran wyświetli płótno, na którym będzie można umieszczać stoliki, zmieniać ich rozmiar i obracać je, rysować ściany i ustawiać obraz tła.',
    floorPlanVersion: (version, placed, total) =>
      `Wersja ${version} · umieszczono ${placed} z ${total} stolików.`,
    editorLargerScreen:
      'Edytor planu sali wymaga większego ekranu z myszą - otwórz panel na komputerze, aby edytować. Oto podsumowanie tylko do odczytu:',
    placed: (count) => `Umieszczone (${count})`,
    noTablesPlaced: 'Na płótnie nie umieszczono jeszcze żadnych stolików.',
    notPlaced: (count) => `Nieumieszczone (${count})`,
    zones: 'Strefy',
    noZonesYet:
      'Brak stref. Strefy grupują stoliki, które są fizycznie blisko siebie - ograniczają, które stoliki można połączyć na potrzeby rezerwacji.',
    deleteZoneConfirm: (label) =>
      `Usunąć strefę "${label}"? Stoliki są zachowywane, ale stają się bez strefy.`,
    failedCreateZone: 'Nie udało się utworzyć strefy',
    failedDeleteZone: 'Nie udało się usunąć strefy',
    zoneNamePrompt: 'Nazwa strefy (np. „Taras”, „Wnętrze”)',
    largePartyMessagePrompt:
      'Wyświetlany gościom, których grupa przekracza maksimum (pozostaw puste, aby ukryć)',
    tablesToPlace: (count, plural) =>
      `${count} ${plural === '' ? 'stolik' : 'stolików'} do umieszczenia`,
    autoPlace: 'Umieść automatycznie',
    removeTable: 'Usuń stolik',
    zoomIn: 'Przybliż',
    zoomOut: 'Oddal',
    fitToTables: 'Dopasuj do stolików',
    fitToPlan: 'Dopasuj do planu',
    seater: (seats) => `na ${seats}`,
    seatersCount: (count) => `· ${count}`,
    // --- AdvancedTablesPage (page-specific copy) ---
    noZoneLabel: 'Brak strefy',
    inactiveBadge: 'Nieaktywny',
    noCapacityBadge: 'Nie liczy się do pojemności',
    notOnlineBadge: 'Niedostępny online',
    seatsCount: (n) => `${n} miejsc`,
    deleteTablesTitle: 'Usuń stoliki',
    deleteTablesConfirm: (count, plural) =>
      `Usunąć ${count} ${plural === '' ? 'stolik' : 'stolików'}? Tego nie można cofnąć.`,
    tablesDeleted: (count) => `Usunięto ${count} stolików`,
    deleteCount: (count) => `Usuń (${count})`,
    addCount: (count) => `Dodaj (${count})`,
    floorPlanSaved: 'Zapisano plan sali',
    failedSaveFloorPlan: 'Nie udało się zapisać',
    failedBatchCreate: 'Niepowodzenie',
    done: 'Gotowe',
    aboutMode: (mode) => `O trybie ${mode}`,
    noPacingLimit: 'Brak limitu tempa - przybycia nie są ograniczane częstotliwościowo.',
    coversPaceTrips: (max, parties, covers) =>
      `Tempo gości (${max}) zadziała pierwsze: ${parties} grup = ${covers} gości rozpoczyna w ciągu 15 minut, następna jest przesuwana później.`,
    partyPaceTrips: (max, covers) =>
      `Tempo grup (${max}) zadziała pierwsze: tylko ${max} rezerwacji może rozpocząć się na 15 minut (${covers} gości do tej pory).`,
    bothPacingHit: (parties, covers) =>
      `Osiągnięto oba limity tempa - ${parties} grup / ${covers} gości w ciągu 15 minut.`,
    noConcurrentLimit: 'Brak limitu jednoczesności - ograniczone tylko liczbą stolików.',
    concurrentCoversTrips: (max, covers) =>
      `Jednoczesna liczba gości (${max}) zadziała pierwsza: ${covers} gości jest aktywnych w szczycie.`,
    concurrentPartiesTrips: (max, covers) =>
      `Jednoczesna liczba grup (${max}) zadziała pierwsza: ${max} rezerwacji aktywnych naraz (${covers} gości).`,
    bothConcurrentHit: (parties, covers) =>
      `Osiągnięto oba limity jednoczesności - ${parties} grup / ${covers} gości naraz.`,
    slotFitsTypical:
      'Typowy zestaw się mieści - przedział pozostaje otwarty na kolejne rezerwacje.',
    coversCapsFirst: (max, parties, covers, size) =>
      `Limit gości (${max}) zostaje osiągnięty jako pierwszy: ${parties} grup = ${covers} gości, a kolejna grupa licząca ${size} by go przekroczyła.`,
    reservationsCapsFirst: (max, parties, covers) =>
      `Limit rezerwacji (${max}) zostaje osiągnięty jako pierwszy: przedział jest pełny przy ${parties} rezerwacjach, niezależnie od liczebności grupy (${covers} gości do tej pory).`,
    bothCapsHit: (parties, covers) =>
      `Oba limity zostają osiągnięte jednocześnie - ${parties} grup / ${covers} gości.`,
    slotClosesWhenHit: 'Przedział zamyka się, gdy tylko zostanie osiągnięty którykolwiek limit.',
    noLimitsSlot:
      'Brak limitów - przedział nigdy nie zapełnia się sam (inne zmiany nadal obowiązują).',
    onlyOneSlot: 'Jeden przedział 60-minutowy · przybywające grupy',
    typicalOverlapFits:
      'Typowe nakładanie się mieści - nie osiągnięto miękkiego limitu poniżej liczby stolików.',
    turnedAway: (size) => `${size} odprawionych`,
    weeklyCompileCoverage: 'Pokrycie tygodniowe',
    noLimitation: 'bez limitu',
    resSlot: (count) => `${count} rezerwacji/przedział`,
    coversSlot: (count) => `${count} gości/przedział`,
    pacingCovers: (count) => `${count} gości tempa`,
    advCapCompact: (pacing, concurrent) => `${pacing} · ${concurrent}`,
    advCap: (pacing, concurrent) => `${pacing}/15' · ${concurrent} równocześnie`,
    // --- ReservationSetupPage (page-specific copy) ---
    bookingForm: 'Formularz rezerwacji',
    bookingFormFooter:
      'Opcjonalne pola, które goście mogą wypełnić przy rezerwacji - okazja i preferencje dotyczące miejsca.',
    enableBookings: 'Włącz rezerwacje',
    enableBookingsAria: 'O włączaniu rezerwacji',
    enableBookingsTooltip:
      'Gdy wyłączone, strona rezerwacji jest ukryta przed gośćmi, a nowe rezerwacje online są odrzucane.',
    autoConfirmBookings: 'Automatycznie potwierdzaj rezerwacje',
    autoConfirmAria: 'O potwierdzaniu',
    autoConfirmTooltip:
      'Włączone potwierdza prośbę natychmiast. Wyłączone utrzymuje ją jako oczekującą, dopóki personel jej nie sprawdzi i nie zaakceptuje.',
    bookingsAutoConfirmedToast: 'Rezerwacje potwierdzane automatycznie',
    bookingsNeedReview: 'Rezerwacje wymagają ręcznego sprawdzenia',
    pauseToday: 'Wstrzymaj nowe rezerwacje na dziś',
    pauseTodayAria: 'O wstrzymywaniu nowych rezerwacji',
    pauseTodayTooltip:
      'Zatrzymuje nowe rezerwacje online tylko do końca dzisiejszego dnia - przyszłe daty pozostają otwarte.',
    bookingsPausedToday: 'Nowe rezerwacje wstrzymane na dziś',
    bookingsResumed: 'Rezerwacje wznowione',
    occasionField: 'Pole okazji',
    occasionFieldAria: 'O polu okazji',
    occasionFieldTooltip: 'Pokaż lub ukryj selektor „Okazja” w formularzu rezerwacji.',
    occasionFieldShown: 'Pole okazji widoczne',
    occasionFieldHidden: 'Pole okazji ukryte',
    seatingAccessField: 'Pole miejsca i dostępu',
    seatingAccessAria: 'O polu miejsca i dostępu',
    seatingAccessTooltip:
      'Pokaż lub ukryj selektor „Miejsce i dostęp” (miejsce + dostępność, np. krzesełko dla niemowlęcia) w formularzu rezerwacji.',
    seatingAccessShown: 'Pole miejsca i dostępu widoczne',
    seatingAccessHidden: 'Pole miejsca i dostępu ukryte',
    largestPartyAria: 'O największej grupie',
    largestPartyTooltip: 'Maksymalna liczba gości dozwolona na jedną rezerwację online.',
    largePartyMessageAria: 'O komunikacie dla dużych grup',
    largePartyMessageTooltip:
      'Wyświetlany zamiast formularza rezerwacji grupom przekraczającym maksymalną liczebność.',
    bookingHorizonAria: 'O horyzoncie rezerwacji',
    bookingHorizonTooltip: 'Z ilu dni wyprzedzeniem otwiera się kalendarz rezerwacji.',
    lastMinuteCutoffMinutes: 'Próg ostatniej chwili (minuty)',
    lastMinuteCutoffAria: 'O progu ostatniej chwili',
    lastMinuteCutoffMsg:
      'Minuty przed przedziałem, w których zatrzymuje się przyjmowanie rezerwacji (0 = do rozpoczęcia)',
    lastMinuteCutoffTooltip:
      'Minuty przed przedziałem, w których zatrzymuje się przyjmowanie rezerwacji (0 = do rozpoczęcia).',
    minBefore: (minutes) => `${minutes} min przed`,
    slotSpacingAria: 'O odstępie przedziałów',
    slotSpacingTooltip: 'Minuty między godzinami do rezerwacji, które goście mogą wybrać.',
    lastBookingBeforeCloseAria: 'O ostatniej rezerwacji przed zamknięciem',
    lastBookingBeforeCloseTooltip:
      'Ile czasu przed końcem każdego serwisu przestajemy oferować godziny rezerwacji. Zespół może nadal pracować po zamknięciu — to ustawienie określa tylko, jak późno goście mogą rezerwować online. Np. 60 min oznacza, że przy zamknięciu o 22:00 ostatnia godzina to 21:00.',
    everyMinShort: (minutes) => `Co ${minutes} min`,
    defaultTableTimeMsg: 'Jak długo stolik jest zarezerwowany na rezerwację, w minutach (min 15)',
    defaultTableTimeAria: 'O domyślnym czasie stolika',
    defaultTableTimeTooltip:
      'Jak długo stolik jest domyślnie zarezerwowany na rezerwację. Nadpisanie dla zmiany znajduje się w sekcji Pojemność.',
    shareBookingLink: 'Udostępnij link do rezerwacji',
    shareBookingLinkAria: 'O udostępnianiu linku do rezerwacji',
    shareBookingLinkTooltip:
      'Skopiuj swój publiczny link do rezerwacji, aby udostępnić go gościom.',
    copy: 'Kopiuj',
    noShowGracePeriodMsg:
      'Minuty po godzinie rezerwacji, zanim gość zostanie uznany za niestawiającego się',
    noShowGracePeriodAria: 'O okresie tolerancji niestawienia się',
    noShowGracePeriodTooltip:
      'Minuty, przez które rezerwacja może być spóźniona, zanim personel otrzyma alert o niestawieniu się.',
    minCount: (minutes) => `${minutes} min`,
    fmtNone: 'Brak',
    fmtHoursMinutes: (hours, minutes) => `${hours} godz. ${minutes} min`,
    fmtHours: (hours) => `${hours} godz.`,
    fmtMinutes: (minutes) => `${minutes} min`,
    bookingLinkCopied: 'Link do rezerwacji skopiowany',
    bookingLink: 'Link do rezerwacji',
    // --- Zones/Tables/Floor-plan pages (simple mode) ---
    add: 'Dodaj',
    failed: 'Niepowodzenie',
    rename: 'Zmień nazwę',
    zonesFooter:
      'Stoliki odwołują się do strefy poprzez jej id - usunięcie strefy sprawia, że te stoliki tracą przypisaną strefę.',
    deleteZoneNoZoneConfirm: (label) =>
      `Usunąć "${label}"? Stoliki nie zostaną usunięte - przejdą do "Brak strefy" i pozostaną dostępne do rezerwacji.`,
    orphanTablesNote:
      'Te stoliki należały do strefy, która została usunięta. Nadal są aktywne i dostępne do rezerwacji. Przypisz je do strefy, edytując każdy stolik.',
    floorPlanAriaLabel: 'Plan sali restauracji',
  },

  reservationsFeature: {
    edit: {
      title: 'Edytuj rezerwację',
      updated: 'Rezerwacja zaktualizowana',
      updateFailed: 'Nie udało się zaktualizować rezerwacji.',
      guestNamePlaceholder: 'Imię i nazwisko gościa',
      durationPlaceholder: '60',
      notesPlaceholder: 'Notatki personelu…',
    },
    actions: {
      confirmReservation: 'Potwierdź rezerwację',
      declineReservation: 'Odrzuć rezerwację',
      cancelReservation: 'Anuluj rezerwację',
      markArrived: 'Oznacz jako przybyłego',
      markNoShow: 'Oznacz jako niestawienie się',
      markCompleted: 'Oznacz jako zakończoną',
    },
    card: {
      guestLabel: (_count) => 'Gość',
      guestLabelPlural: 'Goście',
      swipeAccept: 'Akceptuj',
      swipeDecline: 'Odrzuć',
    },
    inspector: {
      closeButton: 'Zamknij',
      noReservationTitle: 'Nie wybrano rezerwacji',
      noReservationDesc: 'Wybierz rezerwację z listy, aby zobaczyć jej szczegóły tutaj.',
      notFoundTitle: 'Nie znaleziono rezerwacji',
      durationUnit: 'min',
      callGuest: 'Zadzwoń',
      messageGuest: 'Wiadomość',
      emailGuest: 'E-mail',
      editGuest: 'Edytuj',
      statusLabel: 'Status',
      specialRequests: 'Prośby specjalne',
      occasion: 'Okazja',
      seating: 'Miejsce',
      notes: 'Notatki',
      guestInfo: 'Informacje o gościu',
      phone: 'Telefon',
      source: 'Źródło',
      internalNote: 'Notatka wewnętrzna',
      cancellationReason: 'Powód anulowania',
      timeline: 'Oś czasu',
      created: 'Utworzono',
      confirmed: 'Potwierdzono',
      arrived: 'Przybył',
      completed: 'Zakończono',
      cancelled: 'Anulowano',
      noShow: 'Niestawienie się',
      markedArrived: 'Oznaczono jako przybyłego',
      markedCompleted: 'Oznaczono jako zakończoną',
      markedNoShow: 'Oznaczono jako niestawienie się',
    },
    summary: {
      total: 'Razem',
      pending: 'Oczekujące',
      confirmed: 'Potwierdzone',
      arrived: 'Przybyli',
      completed: 'Zakończone',
      noShow: 'Niestawienie się',
    },
    create: {
      title: 'Nowa rezerwacja',
      guestSection: 'Gość',
      nameLabel: 'Imię i nazwisko',
      namePlaceholder: 'np. Jan Kowalski',
      phoneLabel: 'Telefon',
      phonePlaceholder: '+48 555 123 456',
      emailLabel: 'E-mail',
      emailPlaceholder: 'jan@example.com',
      existingGuests: 'Istniejący goście - dotknij, aby użyć ponownie',
      bookingSection: 'Rezerwacja',
      dateLabel: 'Data',
      timeLabel: 'Godzina',
      partySizeLabel: 'Liczba osób',
      sourceSection: 'Źródło',
      sourcePhone: 'Telefon',
      sourceWalkIn: 'Bez rezerwacji',
      notesSection: 'Notatki',
      notesLabel: 'Notatka wewnętrzna',
      notesPlaceholder: 'Tylko dla personelu...',
      button: 'Utwórz rezerwację',
      success: 'Rezerwacja utworzona',
      nameRequired: 'Imię i nazwisko gościa jest wymagane.',
      emailRequired: 'E-mail gościa jest wymagany.',
      phoneRequired: 'Telefon gościa jest wymagany.',
      noRestaurant: 'Nie wybrano restauracji.',
      error: 'Nie udało się utworzyć rezerwacji. Spróbuj ponownie.',
    },
    pending: {
      title: 'Oczekujące',
      confirmed: 'Rezerwacja potwierdzona',
      confirmFailed: 'Nie udało się potwierdzić rezerwacji.',
      rejectPrompt: 'Powód odrzucenia:',
      rejectTitle: 'Odrzuć rezerwację',
      rejected: 'Rezerwacja odrzucona',
      rejectFailed: 'Nie udało się odrzucić rezerwacji.',
      empty: 'Wszystko gotowe!',
      emptyDesc: 'Brak oczekujących rezerwacji do przejrzenia.',
    },
    detail: {
      title: 'Rezerwacja',
    },
    list: {
      emptyError: 'Nie udało się załadować rezerwacji',
      emptyRetry: 'Spróbuj ponownie.',
      noReservations: 'Brak rezerwacji',
      noReservationsDesc: 'Brak rezerwacji na ten dzień.',
      today: 'Dziś',
      countLabel: (_count) => 'rezerwacja',
      countLabelPlural: 'rezerwacji',
      cancelConfirm: 'Anulować tę rezerwację?',
      cancelTitle: 'Anuluj rezerwację',
      cancelled: 'Rezerwacja anulowana',
      cancelFailed: 'Nie udało się anulować rezerwacji.',
    },
    plan: {
      noZone: 'Brak strefy',
      seatSingular: 'miejsce',
      seatPlural: 'miejsc',
      tableAriaLabel: (name, seats) =>
        `Stolik ${name}, ${seats} ${seats === 1 ? 'miejsce' : 'miejsc'}`,
      empty: 'Brak stolików',
      emptyDesc: 'Dodaj stoliki w Ustawienia → Konfiguracja rezerwacji, aby zobaczyć plan sali.',
    },
    timeline: {
      unassignedCount: (count) => `${count} ${count === 1 ? 'rezerwacja' : 'rezerwacji'}`,
      empty: 'Nic do pokazania',
      emptyDesc:
        'Dodaj stoliki w konfiguracji pojemności, a rezerwacje pojawią się tutaj jako paski.',
      seatTopLabel: (seats) => `Stolik na ${seats}`,
    },
    calendar: {
      error: 'Nie udało się załadować rezerwacji',
      errorRetry: 'Spróbuj ponownie.',
    },
  },

  restaurantSetupFeature: {
    branding: {
      title: 'Wygląd strony sklepu',
      storefrontTheme: 'Motyw strony sklepu',
      storefrontThemeDescription:
        'Wybierz motyw swojej publicznej strony sklepu. Każdy podgląd używa dokładnie tych kolorów i kształtów, które zobaczą Twoi klienci.',
      orderButtonPreview: 'Zamów',
      themeSavedMessage:
        'Motyw zapisany - Twoja strona sklepu zaktualizuje się przy następnym wczytaniu',
      couldNotSaveTheme: 'Nie udało się zapisać motywu.',
      saveTheme: 'Zapisz motyw',
      brandingImages: 'Grafiki marki',
      brandingImagesDescription:
        'Logo i zdjęcie w tle dla publicznej strony sklepu. Zdjęcie w tle pojawia się też przy udostępnianiu linku w komunikatorach.',
      logoLabel: 'Logo',
      logoHint:
        'Kwadratowy obraz, wyświetlany obok nazwy restauracji. Przeciągnij plik tutaj, aby przesłać.',
      coverLabel: 'Zdjęcie w tle',
      coverHint:
        'Szeroki obraz, zalecane 1200×630 - widoczny u góry strony i w podglądzie linku. Przeciągnij plik tutaj, aby przesłać.',
      uploadImage: 'Prześlij',
      replaceImage: 'Zamień',
      removeImage: 'Usuń',
      imageSavedMessage:
        'Obraz zapisany - Twoja strona sklepu zaktualizuje się przy następnym wczytaniu',
      imageRemovedMessage: 'Usunięto obraz',
      imageUploadFailed: 'Nie udało się przesłać obrazu.',
      imageTooLarge: 'Obraz jest za duży (maks. 10 MB).',
      imageWrongType: 'Nieobsługiwany format. Użyj JPG, PNG lub WebP.',
      galleryLabel: 'Galeria zdjęć',
      galleryHint:
        'Do 9 zdjęć, wyświetlanych jako siatka na stronie sklepu. Kwadratowe (1:1) wyglądają najlepiej. Przeciągnij, aby zmienić kolejność.',
      addPhotos: 'Dodaj zdjęcia',
      dropFilesHint: 'lub przeciągnij pliki tutaj',
      galleryFull: 'Galeria mieści najwyżej 9 zdjęć.',
    },
  },

  profile: {
    title: 'Mój profil',
    personalInfo: 'Dane osobowe',
    firstName: 'Imię',
    lastName: 'Nazwisko',
    email: 'E-mail',
    notAvailableYet: 'Jeszcze niedostępne',
    contactAdminNote:
      'Aby zaktualizować imię lub dane osobowe, skontaktuj się z administratorem - edycja nie jest tu jeszcze dostępna.',
    currentRestaurantRole: 'Bieżąca rola w restauracji',
    nameInRestaurant: 'Imię w restauracji',
    restaurant: 'Restauracja',
    role: 'Rola',
  },

  settingsHealth: {
    title: 'Dokończ konfigurację',
    location: {
      title: 'Ustaw lokalizację restauracji',
      description: 'Dostawa nie może zmierzyć odległości, dopóki nie ustawisz pinezki na mapie.',
    },
    openingHours: {
      title: 'Dodaj godziny otwarcia',
      description: 'Twój sklep jest widoczny jako zamknięty, dopóki ich nie ustawisz.',
    },
    deliveryPricing: {
      title: 'Skonfiguruj cennik dostawy',
      description:
        'Dodaj strefę dostawy, w przeciwnym razie każdy adres zostanie odrzucony jako poza obszarem.',
    },
    deliveryTime: {
      title: 'Ustaw czasy dostawy',
      description: 'Obszar dostawy bez czasu podaje gościom godzinę, która nie uwzględnia dojazdu.',
    },
    paymentMethod: {
      title: 'Włącz metodę płatności',
      description: 'Goście skompletują koszyk, ale nie złożą zamówienia.',
    },
    menu: {
      title: 'Dodaj pozycje do menu',
      description: 'Zamówienia online nie mają czego pokazać, dopóki menu nie ma produktów.',
    },
    menuNotLive: {
      title: 'Włącz menu dla zamówień online',
      description:
        'Żadne menu nie jest aktywne dla odbioru ani dostawy, goście widzą „nie przyjmuje zamówień online".',
    },
  },

  settingsFeature: {
    features: 'Funkcje',
    privacy: 'Prywatność',
    shareUsageData: 'Udostępniaj dane o użyciu',
    shareUsageDataHint:
      'Pomaga nam zobaczyć, których funkcji naprawdę używasz. Nigdy nie zawiera danych gości ani zamówień.',
    assistant: 'Asystent',
    aiAssistant: 'Asystent AI',
    notifications: 'Powiadomienia',
    inbox: 'Skrzynka odbiorcza',
    inboxNewCount: (count) => `${count} nowych`,
    reports: 'Raporty',
    salesOverview: 'Przegląd sprzedaży',
    dayEnd: 'Zamknięcie dnia',
    topItems: 'Najlepsze pozycje',
    paymentReconciliation: 'Uzgodnienie płatności',
    reservationSetup: 'Konfiguracja rezerwacji',
    onlineOrders: 'Zamówienia online',
    orderSetup: 'Konfiguracja zamówień',
    orderShifts: 'Pojemność zamówień',
    labels: 'Etykiety',
    tidyUp: 'Uporządkuj listy',
    promotions: 'Promocje',
    loyalty: 'Lojalność',
    giftCards: 'Karty podarunkowe',
    staff: 'Personel',
    tableOrdering: 'Zamawianie przy stoliku',
    dineInSetup: 'Konfiguracja na miejscu',
    printing: 'Drukowanie',
    printers: 'Drukarki',
    customers: 'Klienci',
    allCustomers: 'Wszyscy klienci',
    branding: 'Wygląd strony sklepu',
    storefrontLink: 'Link do strony sklepu',
    openingHours: 'Godziny otwarcia',
    holidays: 'Święta i zamknięcia',
    reservationHours: 'Godziny rezerwacji',
    orderHours: 'Godziny zamówień',
    pickupHours: 'Godziny odbioru',
    deliveryHours: 'Godziny dostawy',
    orderHistory: 'Historia zamówień',
    payments: 'Płatności',
    myProfile: 'Mój profil',
  },

  storefrontLink: {
    title: 'Link do strony sklepu',
    language: 'Język',
    default: 'Domyślny',
    linkLabel: 'Link',
    linksTitle: 'Linki',
    homepage: 'Strona główna',
    reservation: 'Rezerwacja',
    onlineOrder: 'Zamówienie online',
    linkUnavailable: 'Link niedostępny',
    copy: 'Kopiuj',
    copied: 'Skopiowano',
    open: 'Otwórz',
    linkCopied: 'Skopiowano link do strony sklepu',
    okButton: 'OK',
  },

  settingHistory: {
    title: 'Historia zmian ustawień',
    navTitle: 'Dziennik ustawień',
    empty: 'Brak zapisanych zmian ustawień.',
    columnActor: 'Zmienione przez',
    columnWhen: 'Kiedy',
    columnWhat: 'Co zmieniono',
    columnAction: 'Akcja',
    details: 'Szczegóły',
    detailsTitle: 'Szczegóły zmiany',
    totalEntries: (total: number) => `${total} wpisów`,
    actions: {
      CREATED: 'Dodano',
      UPDATED: 'Zmieniono',
      DELETED: 'Usunięto',
    },
    valueHidden: 'zmienione (wartość niezapisana)',
    on: 'Włączone',
    off: 'Wyłączone',
    unitMinutes: (n: string) => `${n} min`,
    unitHours: (n: string) => `${n} godz.`,
    unitDays: (n: string) => `${n} dni`,
    unitPeople: (n: string) => `${n} osób`,
    unitKm: (n: string) => `${n} km`,
    photoCount: (n: number) => `${n} zdj.`,
    partySizePacingRule: (minPartySize: number, maxParties: number) =>
      `od ${minPartySize} gości: maks. ${maxParties} grup`,
    ruleFields: {
      slotMinutes: 'Długość przedziału',
      maxReservationsPerSlot: 'Maks. rezerwacji / przedział',
      maxCoversPerSlot: 'Maks. gości / przedział',
      pacingMaxCovers: 'Tempo, maks. gości',
      pacingMaxParties: 'Tempo, maks. grup',
      maxConcurrentCovers: 'Jednoczesne, maks. gości',
      maxConcurrentParties: 'Jednoczesne, maks. grup',
      partySizePacing: 'Tempo według wielkości grupy',
      maxOrdersPerSlot: 'Zamówienia na slot',
      capacityWindowMinutes: 'Okno pojemności',
    },
    detailBefore: 'Przed',
    detailAfter: 'Po',
    showRaw: 'Pokaż surowe dane',
    hideRaw: 'Ukryj surowe dane',
    tableAttributes: {
      WINDOW: 'Przy oknie',
      BOOTH: 'Loża',
      OUTDOOR: 'Na zewnątrz',
      BAR: 'Bar',
      HIGH_TOP: 'Wysoki stolik',
      PRIVATE_ROOM: 'Sala prywatna',
      QUIET: 'Cichy kącik',
      WHEELCHAIR: 'Dostęp dla wózków',
      NEAR_FIREPLACE: 'Przy kominku',
      KIDS_FRIENDLY: 'Przyjazny dzieciom',
    },
    fields: {
      name: 'Nazwa',
      address: 'Adres',
      city: 'Miasto',
      postalCode: 'Kod pocztowy',
      phone: 'Telefon',
      email: 'E-mail',
      timezone: 'Strefa czasowa',
      latitude: 'Szerokość geograficzna',
      longitude: 'Długość geograficzna',
      isActive: 'Aktywne',
      slug: 'Adres internetowy',
      websiteUrl: 'Strona internetowa',
      facebookUrl: 'Facebook',
      instagramUrl: 'Instagram',
      tiktokUrl: 'TikTok',
      logoKey: 'Logo',
      coverImageKey: 'Zdjęcie w tle',
      galleryKeys: 'Galeria zdjęć',
      themeId: 'Motyw',
      shifts: 'Godziny otwarcia',
      dayOfWeek: 'Dzień tygodnia',
      startDate: 'Data początkowa',
      endDate: 'Data końcowa',
      type: 'Typ',
      services: 'Dotyczy',
      reason: 'Powód',
      label: 'Nazwa',
      sortOrder: 'Kolejność',
      zoneId: 'Strefa',
      seats: 'Miejsca',
      attributes: 'Atrybuty',
      customTags: 'Tagi',
      countsForCapacity: 'Liczy się do pojemności',
      isBookableOnline: 'Rezerwacja online',
      isMergeable: 'Można łączyć',
      tableMode: 'Zarządzanie stolikami',
      enabled: 'Rezerwacje online',
      occasionEnabled: 'Pytaj o okazję',
      seatingPreferenceEnabled: 'Pytaj o preferencje miejsca',
      duration: 'Czas pobytu',
      bufferTime: 'Bufor między rezerwacjami',
      autoConfirmMode: 'Potwierdzanie',
      maxPartySize: 'Maksymalna liczba osób',
      largePartyMsg: 'Komunikat dla dużych grup',
      advanceWindow: 'Jak wcześnie można rezerwować',
      cutoffTime: 'Zamknięcie rezerwacji przed terminem',
      slotInterval: 'Odstęp między terminami',
      closingBufferMinutes: 'Ostatnia rezerwacja przed zamknięciem',
      gracePeriod: 'Czas oczekiwania na gościa',
      pausedUntil: 'Rezerwacje wstrzymane do',
      shiftMode: 'Zarządzanie pojemnością',
      scope: 'Zakres',
      startTime: 'Godzina rozpoczęcia',
      endTime: 'Godzina zakończenia',
      daysOfWeek: 'Dni',
      defaultDurationMinutes: 'Domyślny czas',
      mode: 'Tryb',
      rules: 'Reguły pojemności',
      minOrderCents: 'Minimalna wartość zamówienia',
      cashEnabled: 'Płatność gotówką',
      onlineEnabled: 'Płatność online',
      cardOnHandoffEnabled: 'Karta przy odbiorze',
      autoConfirmHandoff: 'Automatyczne przyjmowanie zamówień',
      deliveryPriceMode: 'Sposób naliczania dostawy',
      distanceCalculation: 'Pomiar odległości',
      deliveryBufferMinutes: 'Bufor dostawy',
      autoCompleteEnabled: 'Automatyczne kończenie',
      completeStaleAfterMinutesFromReadyAt: 'Automatyczne zakończenie po',
      cancelPendingAfterHours: 'Anuluj nieprzyjęte zamówienia po',
      expireUnpaidAfterMinutes: 'Anuluj nieopłacone zamówienia po',
      prepTimeMinutes: 'Czas przygotowania',
      schedulingLeadMinutes: 'Czas wyprzedzenia zamówień',
      openingBufferMinutes: 'Najwcześniejszy przedział po otwarciu',
      credentials: 'Dane dostępowe API',
      instructions: 'Instrukcja płatności',
      defaultLanguage: 'Język lokalu',
      feeCents: 'Opłata za dostawę',
      maxDistanceKm: 'Maksymalna odległość',
      deliveryMinutes: 'Czas dostawy',
      polygon: 'Obszar dostawy',
      displayOrder: 'Kolejność',
      accountFields: 'Dane konta',
      qrImageBlobKey: 'Obraz QR',
      color: 'Kolor',
      connection: 'Połączenie',
      isDefault: 'Drukarka domyślna',
      printOnlineOrders: 'Drukuj zamówienia online',
      printReservations: 'Drukuj rezerwacje',
      textSize: 'Rozmiar tekstu',
      splitKitchenTickets: 'Dziel bony kuchenne',
      printExpoTicket: 'Drukuj bon zbiorczy',
      printItemCategory: 'Pokaż kategorię na bonie',
      dateTimeFormat: 'Format daty na wydruku',
      ownerNotifyEnabled: 'Powiadomienia o zamówieniach',
      ownerNotifyCashEnabled: 'Powiadomienia — gotówka',
      ownerNotifyManualEnabled: 'Powiadomienia — przelew',
      ownerNotifyOnlineEnabled: 'Powiadomienia — płatność online',
      ownerNotifyCancellationEnabled: 'Powiadomienia o anulowaniu',
      ownerNotifyNoShowEnabled: 'Powiadomienia o nieprzybyciu',
      prepReminderEnabled: 'Przypomnienie o rozpoczęciu przygotowania',
      customerEmailEnabled: 'E-maile do gości',
      customerEmailCashEnabled: 'E-maile do gości — gotówka',
      customerEmailManualEnabled: 'E-maile do gości — przelew',
      customerEmailOnlineEnabled: 'E-maile do gości — płatność online',
      ownerEmailEnabled: 'E-maile do właściciela',
      reminderEnabled: 'E-maile z przypomnieniem',
      reminderOffsetsMinutes: 'Czas przypomnienia',
    } as Record<string, string>,
    values: {
      STRAIGHT_LINE: 'Próg odległości',
      POLYGON: 'Narysowany obszar',
      ROUTE_DISTANCE: 'Odległość trasy',
      AUTO: 'Automatycznie',
      MANUAL: 'Ręcznie',
      SIMPLE: 'Prosty',
      ADVANCED: 'Zaawansowany',
      BASELINE: 'Godziny domyślne',
      WINDOW: 'Okno czasowe',
      CLOSED: 'Zamknięte',
      MODIFIED: 'Zmienione godziny',
      DISTANCE: 'Według odległości',
      ZONE: 'Według strefy',
      DIRECT: 'W linii prostej',
      ROUTE: 'Trasa drogowa',
      MEDIUM: 'Średni',
      LARGE: 'Duży',
      DMY_SLASH: 'DD/MM/YYYY',
      DMY_DOT: 'DD.MM.YYYY',
      YMD_DASH: 'YYYY-MM-DD',
      MDY_SLASH: 'MM/DD/YYYY',
      PICKUP: 'Odbiór osobisty',
      DELIVERY: 'Dostawa',
      DINE_IN: 'Na miejscu',
    } as Record<string, string>,
  },

  staff: {
    title: 'Personel',
    inviteTitle: 'Zaproś członka zespołu',
    nameLabel: 'Imię i nazwisko',
    namePlaceholder: 'Anna Nowak',
    emailLabel: 'E-mail',
    emailPlaceholder: 'anna@example.com',
    roleLabel: 'Rola',
    roles: {
      MANAGER: 'Kierownik',
      STAFF: 'Kelner',
      KITCHEN: 'Kuchnia',
      CASHIER: 'Kasjer',
    },
    inviting: 'Zapraszanie…',
    sendInvite: 'Wyślij zaproszenie',
    couldNotLoadTitle: 'Nie udało się załadować personelu',
    noStaffTitle: 'Brak personelu',
    noStaffDescription:
      'Zaproś swój zespół - kelnerów, kuchnię, kasjera - i ustal, co każdy może robić. Dotknij +.',
    inactive: 'Nieaktywny',
    roleAriaLabel: (name) => `Rola dla ${name}`,
    remove: 'Usuń',
    validation: {
      nameAndEmail: 'Wprowadź imię i adres e-mail.',
    },
    toast: {
      invitationSent: 'Zaproszenie wysłane',
      couldNotInvite: 'Nie udało się zaprosić tej osoby.',
      couldNotChangeRole: 'Nie udało się zmienić roli.',
      couldNotUpdate: 'Nie udało się zaktualizować.',
      removed: (name) => `${name} usunięty`,
      couldNotRemove: 'Nie udało się usunąć.',
    },
    removeConfirm: (name) => `Usunąć ${name} z tej restauracji?`,
    removeConfirmTitle: 'Usuń członka personelu',
  },

  tableOrdering: {
    attachReservation: {
      title: 'Dołącz rezerwację',
      noAttachable: 'Brak rezerwacji dostępnych do dołączenia.',
      confirmAttach: (name: string) =>
        `Dołączyć rezerwację gościa ${name} i oznaczyć jako przybyły?`,
      partyOf: (n: number) => `Grupa ${n} osób`,
      onThisTable: ' · ten stolik',
    },
    inspector: {
      selectTable: 'Wybierz stolik',
      selectTableDesc:
        'Wybierz stolik na planie sali, aby zobaczyć rachunek, przyjąć zamówienia i pobrać płatność.',
      addRound: 'Dodaj rundę',
      bill: 'Rachunek',
      attach: 'Dołącz',
      guest: 'Gość',
      addGuest: 'Dodaj gościa',
      activity: 'Aktywność',
      needsAttention: 'Wymaga uwagi',
      guestCalledServer: 'Gość wezwał kelnera',
      guestRequestedBill: 'Gość poprosił o rachunek',
      resolve: 'Rozwiąż',
      rounds: 'Rundy',
      noRounds: 'Brak rund - „Dodaj rundę”, aby przyjąć zamówienie.',
      total: 'Razem',
      paid: 'Opłacone',
      billRequestedStatus: 'Poproszono o rachunek',
      openStatus: 'Otwarty',
      closedStatus: 'Zamknięty',
      walkIn: 'Bez rezerwacji',
      openedTime: 'otwarto',
      visit: 'wizyta',
      visits: 'wizyt',
      visitsCount: (n: number) => `${n} ${n === 1 ? 'wizyta' : 'wizyt'}`,
      roundStatus: {
        placed: 'Oczekuje na potwierdzenie',
        fired: 'W kuchni',
        ready: 'Gotowe',
        served: 'Podane',
        cancelled: 'Anulowane',
      },
      roundNum: (seq: number) => `Runda ${seq}`,
      roundFired: (seq: number) => `Runda ${seq} przekazana do kuchni`,
      roundAccepted: (seq: number) => `Runda ${seq} zaakceptowana`,
      roundReadyToast: (seq: number) => `Runda ${seq} gotowa`,
      roundServedToast: (seq: number) => `Runda ${seq} podana`,
      roundReopened: (seq: number) => `Runda ${seq} z powrotem w kuchni`,
      cancelRoundPrompt: 'Powód anulowania tej rundy',
      roundCancelledToast: (seq: number) => `Runda ${seq} anulowana`,
      voidItemPrompt: (name: string) => `Anulować "${name}"? Dodaj powód (opcjonalnie)`,
      voidItemTitle: 'Anuluj pozycję',
      restoreAria: (name: string) => `Przywróć ${name}`,
      voidAria: (name: string) => `Anuluj ${name}`,
    },
    roundActions: {
      acceptFire: 'Akceptuj i przekaż',
      cancelRound: 'Anuluj rundę',
      markReady: 'Oznacz jako gotowe',
      markServed: 'Oznacz jako podane',
      sendBackKitchen: 'Odeślij do kuchni',
    },
    zonePicker: {
      open: 'otwartych',
      noOpenTabs: 'Brak otwartych rachunków',
      openCount: (n: number) => `${n} otwartych`,
    },
    assignCustomer: {
      title: 'Przypisz gościa',
      change: 'Zmień gościa',
      currentGuest: 'Bieżący gość',
      unlinkGuest: 'Odłącz gościa',
      findAddGuest: 'Znajdź lub dodaj gościa',
      linkDifferent: 'Powiąż innego gościa',
      nameLabel: 'Imię i nazwisko',
      guestNamePlaceholder: 'Imię i nazwisko gościa',
      phoneLabel: 'Telefon',
      phoneNumberPlaceholder: 'Numer telefonu',
      existingGuests: 'Istniejący goście - dotknij, aby powiązać',
      linkNewGuest: 'Powiąż nowego gościa',
      linkGuest: 'Powiąż gościa',
      guestLinked: 'Gość powiązany',
      guestUnlinked: 'Gość odłączony',
      enterNamePhone: 'Wprowadź imię i numer telefonu.',
      linkedName: (name: string) => `Powiązano ${name}`,
      visitsFooter: (n: number) => `${n} ${n === 1 ? 'wizyta' : 'wizyt'}`,
    },
    floorPlan: {
      noFloorPlanAdvanced:
        'Nie narysowano jeszcze planu sali - stoliki są wyświetlane pogrupowane według strefy. Narysuj plan sali w Ustawienia → Stoliki (Zaawansowane), a pojawi się tutaj.',
      simpleMode:
        'Stoliki są w trybie prostym - wyświetlane pogrupowane według strefy. Przełącz na „Zaawansowany” w Ustawienia → Plan sali, aby utworzyć plan sali.',
    },
    tableGrid: {
      couldntLoadTables: 'Nie udało się załadować stolików',
      noTables: 'Brak stolików',
      noTablesDesc: 'Dodaj stoliki w Ustawienia → Stoliki, aby zacząć przyjmować zamówienia.',
      noTablesZone: 'Brak stolików w tej strefie',
      noTablesZoneDesc: 'Wybierz inną strefę lub dodaj stoliki w Ustawienia → Stoliki.',
      other: 'Inne',
      reserved: 'Zarezerwowany',
      free: 'Wolny',
      openTab: 'Otwarty rachunek',
      tryAgain: 'Spróbuj ponownie.',
      zoneCount: (label: string, n: number) => `${label} · ${n}`,
      occupiedSub: (rounds: number, money: string, calls: number) =>
        `${rounds} rund · ${money}${calls > 0 ? ` · ${calls} wezwanie` : ''}`,
      reservedAt: (time: string) => `Zarezerwowany · ${time}`,
      seatsCount: (n: number) => `${n} miejsc`,
      roundsAbbrev: (n: number) => `${n}r`,
    },
    billCollect: {
      collectPayments: 'Pobierz płatności',
      noSplit: 'Brak podziału',
      noSplitDesc: 'Najpierw skonfiguruj podział - wtedy każda część pojawi się tutaj do pobrania.',
      splitBill: 'Podziel rachunek',
      collectedFull: 'W pełni pobrane',
      shares: 'Części',
      awaiting: 'Oczekuje · dotknij, aby pobrać',
      done: 'Gotowe',
      tapNote:
        'Dotknij każdej oczekującej części, aby pobrać płatność. Rachunek zamyka się sam, gdy ostatnia część zostanie pobrana.',
      collectedCountOf: (count: number, total: number) => `Pobrano ${count} z ${total}`,
      shareNum: (i: number) => `Część ${i}`,
      methodTipFooter: (method: string, tip: string) => `${method} · +${tip} napiwku`,
      methodCollectedFooter: (method: string) => `${method} · pobrane`,
    },
    addRound: {
      title: 'Dodaj rundę',
      send: 'Wyślij',
      menu: 'Menu',
      order: 'Zamówienie',
      searchMenu: 'Przeszukaj menu',
      noMenu: 'Brak dostępnego aktywnego menu. Najpierw opublikuj menu.',
      chooseOptions: 'Wybierz opcje',
      noItems: 'Brak pozycji - przejdź do menu i dotknij dań, aby zbudować rundę.',
      roundSentKitchen: 'Runda wysłana do kuchni',
      failedSend: 'Nie udało się wysłać rundy',
      assignTo: 'Przypisz tę pozycję do',
      shared: 'Wspólne',
      addSeat: '+ Dodaj miejsce',
      seatAdded: 'Miejsce dodane',
      edit: 'Edytuj',
      noteName: 'Notatka dla kuchni (opcjonalnie)',
      orderTab: (count: number) => `Zamówienie${count > 0 ? ` · ${count}` : ''}`,
      seatOrdinal: (n: number) => `Miejsce ${n}`,
      addedItem: (name: string) => `Dodano ${name}`,
      tapDishes: 'Dotknij dań, aby zbudować rundę.',
      summaryLine: (count: number, total: string) =>
        `${count} pozycji · ${total} - dotknij „Wyślij”, aby przekazać rundę`,
    },
    configureItem: {
      title: 'Konfiguruj',
      dishUnavailable: 'Danie niedostępne',
      dishUnavailableDesc: 'Tego dania nie ma już w menu. Wróć i wybierz inne.',
      updateItem: (money: string) => `Aktualizuj · ${money}`,
      addItem: (money: string) => `Dodaj · ${money}`,
      chooseOne: 'Wybierz 1',
      chooseAny: 'Wybierz dowolnie',
      chooseExact: (n: number, picked: number) => `Wybierz ${n} · ${picked}/${n}`,
      upTo: (n: number, picked: number) => `Do ${n} · ${picked}/${n}`,
      chooseRange: (min: number, max: number, picked: number) =>
        `Wybierz ${min}-${max} · ${picked}/${max}`,
      atLeast: (n: number, picked: number) => `Co najmniej ${n} · ${picked}`,
      pickMore: (count: number, name: string) => `Wybierz jeszcze ${count}: ${name}`,
      maxReached: (max: number) => `Osiągnięto maksimum ${max} - usuń jeden wybór, aby zmienić`,
      optionShortage: (name: string, available: number, total: number, min: number) =>
        `${name}: dostępne tylko ${available} z ${total}, wymagane ${min}`,
      temporarilyUnavailable: 'Chwilowo niedostępne',
      required: 'Wymagane',
      optional: 'Opcjonalne',
    },
    settings: {
      title: 'Zamawianie przy stoliku',
      dineInOrdering: 'Zamawianie na miejscu',
      enabled: 'Włączone',
      tableOrderingOn: 'Zamawianie przy stoliku włączone',
      tableOrderingOff: 'Zamawianie przy stoliku wyłączone',
      friendlyMessage:
        'Gdy wyłączone, zeskanowanie kodu QR stolika wyświetla przyjazny komunikat „Zapytaj personel” i brak menu.',
      howItWorks: 'Jak to działa',
      orderingMode: 'Tryb zamawiania',
      modeGuest: 'Gość',
      modeStaff: 'Personel',
      modeHybrid: 'Hybrydowy',
      roundHandling: 'Obsługa rund',
      autoPrintKitchen: 'Automatycznie drukuj zlecenia kuchenne',
      charges: 'Opłaty',
      serviceCharge: 'Opłata serwisowa',
      tipSuggestions: 'Sugestie napiwków',
      tableQRCodes: 'Kody QR stolików',
      printableQR: 'Arkusz kodów QR do druku',
      printQRDesc:
        'Jeden kod QR na stolik. Wydrukuj, wytnij i umieść na stolikach - goście skanują, aby otworzyć swój rachunek.',
      whoPlacesOrders: 'Kto składa zamówienia?',
      guestOrderThemselves: 'Goście zamawiają samodzielnie',
      staffTakeOrders: 'Personel przyjmuje wszystkie zamówienia',
      guestOrderStaffConfirm: 'Goście zamawiają, personel potwierdza pierwszą rundę',
      orderingModeUpdated: 'Tryb zamawiania zaktualizowany',
      whenRoundPlaced: 'Gdy runda zostanie złożona',
      sendKitchenImmediately: 'Wyślij do kuchni natychmiast',
      holdStaffAccept: 'Wstrzymaj do akceptacji personelu',
      roundHandlingUpdated: 'Obsługa rund zaktualizowana',
      serviceChargePrompt:
        'Opłata serwisowa dodawana do każdego rachunku (procent, np. 12,5). 0, aby wyłączyć.',
      enter0100: 'Wprowadź 0–100',
      serviceChargeUpdated: 'Opłata serwisowa zaktualizowana',
      tipPresetsPrompt:
        'Sugerowane przyciski napiwków wyświetlane gościom - procenty oddzielone przecinkiem (np. 5, 10, 15). Puste dla braku.',
      tipPresetsUpdated: 'Sugestie napiwków zaktualizowane',
      firingAuto: 'Automatycznie',
      firingConfirm: 'Potwierdzenie',
      kitchenTicketUpdated: 'Zaktualizowano ustawienie zleceń kuchennych',
      chargeOff: 'Wyłączone',
      tipsNone: 'Brak',
    },
    billSplit: {
      title: 'Podziel rachunek',
      billTotal: 'Suma rachunku',
      even: 'Po równo',
      byAmount: 'Według kwoty',
      bySeat: 'Według miejsca',
      noSeats:
        'Brak miejsc. Dodaj miejsca (lub przypisz dania do miejsca na pulpicie zamówień), a wtedy każde miejsce płaci za swoje - dania wspólne dzielone są po równo.',
      noItems: 'Brak pozycji',
      nothingShared: 'Nic wspólnego',
      moveItem: 'Przenieś pozycję do',
      seatAdded: 'Miejsce dodane',
      atLeastOneSeat: 'Najpierw dodaj przynajmniej jedno miejsce',
      atleastTwoAmounts: 'Wprowadź przynajmniej dwie kwoty',
      splitCreated: 'Podział utworzony',
      createSplit: 'Utwórz podział',
      seatFallback: (ordinal: number) => `Miejsce ${ordinal}`,
      movedToSeat: (label: string) => `Przeniesiono do ${label}`,
      splitNote: (n: number) =>
        `Dotknij pozycji, aby ją przenieść. Dania wspólne są dzielone po równo na ${n} miejsc.`,
      perPersonWays: (ways: number) => `na osobę · podział na ${ways}`,
      partyLabel: (n: number) => `Grupa ${n}`,
      addParty: 'Dodaj grupę',
    },
    history: {
      title: 'Historia',
      couldntLoadHistory: 'Nie udało się załadować historii',
      noClosedTabs: 'Brak zamkniętych rachunków',
      noClosedTabsDesc:
        'Rachunki rozliczone w tym dniu pojawią się tutaj. Wybierz inny dzień powyżej.',
      splitEven: 'Podział · po równo',
      splitByAmount: 'Podział · według kwoty',
      splitBySeat: 'Podział · według miejsca',
      single: 'Pojedynczy',
      forceClosed: 'Zamknięty wymuszenie',
      tryAgain: 'Spróbuj ponownie.',
      tabsSummary: (n: number, money: string) => `${n} rachunków · ${money} pobrane`,
      closedAt: (time: string) => `Zamknięto ${time}`,
      roundsCount: (n: number) => `${n} rund`,
      mixed: 'Mieszane',
      card: 'Karta',
      giftCard: 'Karta podarunkowa',
    },
    bill: {
      title: 'Rachunek',
      paidInFull: 'Opłacone w całości',
      balanceDue: 'Do zapłaty',
      subtotal: 'Suma częściowa',
      serviceCharge: 'Opłata serwisowa',
      finishMeal: 'Zakończ posiłek przed wystawieniem rachunku',
      backToTab: 'Wróć do rachunku',
      settle: 'Rozlicz',
      collectPayments: 'Pobierz płatności',
      takePayment: 'Przyjmij płatność',
      splitBill: 'Podziel rachunek',
      splitOptions: 'Po równo, według kwoty lub według miejsca',
      takeFullPayment: 'Przyjmij pełną płatność',
      paymentsTaken: 'Płatności przyjęte',
      manage: 'Zarządzaj rachunkiem',
      viewActivity: 'Zobacz aktywność',
      markBillRequested: 'Oznacz jako poproszony',
      moveTabAnother: 'Przenieś rachunek do innego stolika',
      mergeAnother: 'Połącz inny rachunek',
      forceCloseWalkout: 'Zamknij wymuszenie (wyjście bez zapłaty / gratis)…',
      tabClosed: 'Rachunek zamknięty',
      tabClosedDesc:
        'Ten rachunek jest rozliczony i zamknięty. Powyższe podsumowanie jest tylko do odczytu.',
      closeConfirm: 'Zamknąć ten w pełni opłacony rachunek?',
      closeTitle: 'Zamknij rachunek',
      forceClosePrompt: 'Powód (wyjście bez zapłaty, gratis, błąd…) - odnotowany na osi czasu',
      forceCloseTitle: 'Wymuś zamknięcie rachunku',
      forceCloseDone: 'Rachunek zamknięty wymuszenie',
      noFreeTable: 'Brak wolnego stolika do przeniesienia',
      moveTitle: 'Przenieś rachunek do',
      noOtherTab: 'Brak innego otwartego rachunku do połączenia',
      mergeTitle: 'Połącz inny rachunek z tym',
      mergeDesc:
        'Rundy drugiego rachunku są przenoszone tutaj; zostaje on zamknięty jako połączony.',
      markedBillRequested: 'Oznaczono jako poproszony',
      roundsNotServed: (count: number, seqs: string) =>
        count !== 1
          ? `Rundy ${seqs} nie zostały jeszcze podane`
          : `Runda ${seqs} nie została jeszcze podana`,
      finishMealDesc: (roundsText: string) =>
        `${roundsText}. Podaj lub anuluj każdą rundę na rachunku, a następnie wróć, aby rozliczyć.`,
      collectPaymentsFooter: (collected: number, total: number, amount: string) =>
        `Pobrano ${collected} z ${total} · pozostało ${amount}`,
      takePaymentFooter: (amount: string) => `Pozostało ${amount} · gotówka lub karta`,
      guestSuggested: (mode: string) => `Zaproponowano przez gościa: ${mode}`,
      bySeatFooter: (n: number) => `Według miejsca (${n}), po równo lub według kwoty`,
      takeFullPaymentFooter: (amount: string) => `${amount} · jedna płatność`,
      paymentTipFooter: (status: string, tip: string) => `${status} · +${tip} napiwku`,
      payStatus: {
        pendingCollection: 'Oczekuje na płatność',
        awaitingProof: 'Oczekuje na potwierdzenie',
        proofSubmitted: 'Potwierdzenie przesłane',
        processing: 'Przetwarzanie',
        paid: 'Opłacone',
        rejected: 'Odrzucone',
        void: 'Anulowane',
        refunded: 'Zwrócone',
        partiallyRefunded: 'Częściowo zwrócone',
      },
      movedTo: (label: string) => `Przeniesiono do ${label}`,
      mergedWith: (label: string) => `Połączono ${label}`,
      billTitleFor: (label: string) => `Rachunek · ${label}`,
    },
    payment: {
      collect: 'Pobierz część',
      takePayment: 'Przyjmij płatność',
      method: 'Metoda',
      cash: 'Gotówka',
      cardTerminal: 'Karta / Terminal',
      amount: 'Kwota',
      tip: 'Napiwek',
      enterAmount: 'Wprowadź kwotę płatności',
      shareCollected: 'Część pobrana',
      paymentRecorded: 'Płatność zarejestrowana',
      shareOf: (i: number, total: number) => `Część ${i} z ${total}`,
      collectAmount: (amount: string) => `Pobierz ${amount}`,
      recordAmountPayment: (amount: string) => `Zarejestruj płatność ${amount}`,
    },
    workspace: {
      tables: 'Stoliki',
      floor: 'Plan sali',
      list: 'Lista',
      openTabTitle: 'Otwarty rachunek',
      noZone: 'Brak strefy',
      zoneFallback: 'Strefa',
      openTabConfirm: (label: string) => `Otworzyć nowy rachunek dla ${label}?`,
      tabOpened: (label: string) => `Rachunek otwarty · ${label}`,
      tabFallback: 'Stolik',
    },
    qrSheet: {
      title: 'Arkusz kodów QR',
      print: 'Drukuj',
      noQR: 'Brak kodów QR stolików',
      noQRDesc: 'Dodaj stoliki w Ustawienia → Stoliki; każdy automatycznie otrzyma kod QR.',
      hint: 'Wydrukuj tę stronę, wytnij wzdłuż kart i umieść po jednej na każdym stoliku.',
      noQRYet: 'Brak kodu QR:',
      reseeding:
        'Te stoliki potrzebują tokenu QR - ponowne wczytanie lub zapisanie stolika przypisze go.',
      tryAgain: 'Spróbuj ponownie.',
      qrAlt: (label: string) => `Kod QR dla ${label}`,
    },
    timeline: {
      activity: 'Aktywność',
      noActivity: 'Brak aktywności',
      noActivityDesc:
        'Każda akcja na tym rachunku - zamówienia, kuchnia, płatności - pojawia się tutaj.',
      tabOpened: 'Rachunek otwarty',
      roundPlaced: 'Runda złożona',
      sentKitchen: 'Wysłano do kuchni',
      roundReady: 'Runda gotowa',
      roundServed: 'Runda podana',
      roundCancelled: 'Runda anulowana',
      itemVoided: 'Pozycja unieważniona',
      itemRestored: 'Pozycja przywrócona',
      reservationAttached: 'Rezerwacja dołączona',
      serviceRequested: 'Poproszono o obsługę',
      serviceResolved: 'Obsługa zrealizowana',
      billRequested: 'Poproszono o rachunek',
      paymentTaken: 'Płatność przyjęta',
      forceClosedTimeline: 'Zamknięty wymuszenie',
      movedTable: 'Stolik przeniesiony',
      mergedAnother: 'Połączony z innym rachunkiem',
      tabClosed3: 'Rachunek zamknięty',
      seatedReservation: 'Posadzono z rezerwacji',
      guest: 'Gość',
      staff: 'Personel',
      system: 'System',
    },
    arrivals: {
      title: 'Oczekiwane przybycia',
      noArrivals: 'Brak oczekiwanych przybyć',
      noArrivalsDesc:
        'Dzisiejsze nadchodzące rezerwacje pojawią się tutaj, aby posadzić gości jednym dotknięciem.',
      overdue: 'Spóźnione',
      seatTitle: 'Posadź gościa',
      seatConfirm: (name: string, n: number) => `Posadzić ${name} (grupa ${n} osób)?`,
      seatedToast: (name: string) => `Posadzono ${name}`,
    },
  },

  waitlist: {
    title: 'Lista oczekujących',
    partyOf: (partySize) => `Grupa ${partySize} osób`,
    addForm: {
      title: 'Dodaj bez rezerwacji',
      partySize: 'Liczba osób',
      guestName: 'Imię gościa',
      guestNamePlaceholder: 'np. Sara',
      phone: 'Telefon (opcjonalnie)',
      phonePlaceholder: 'Aby zadzwonić, gdy stolik się zwolni',
      adding: 'Dodawanie…',
      addButton: 'Dodaj do listy oczekujących',
    },
    validation: {
      nameRequired: 'Wprowadź imię gościa.',
    },
    toasts: {
      added: (guestName, quotedWaitMinutes) =>
        `${guestName} dodany - szacowany czas oczekiwania ${quotedWaitMinutes} minut`,
      marked_notified: (guestName) => `${guestName} został powiadomiony`,
      could_not_update: 'Aktualizacja nie powiodła się.',
      no_free_tables: 'Brak wolnych stolików w tej chwili.',
      seated: (guestName) => `${guestName} posadzony`,
      could_not_seat: 'Nie udało się posadzić tej grupy.',
      removed: (guestName) => `${guestName} usunięty`,
      could_not_remove: 'Usunięcie nie powiodło się.',
      marked_noshow: (guestName) => `${guestName} oznaczony jako niestawienie się`,
      could_not_add: 'Nie udało się dodać tej grupy.',
    },
    actions: {
      seat: {
        label: (guestName, partySize) => `Posadź ${guestName} (${partySize} gości)`,
        tableOption: (tableLabel, zoneLabelFormatted, seats) =>
          `${tableLabel}${zoneLabelFormatted} - ${seats} miejsc`,
      },
      seatButton: 'Posadź',
      cancel: {
        confirm: (guestName) => `Usunąć ${guestName} z listy oczekujących?`,
        title: 'Usuń grupę',
      },
      noShow: {
        confirm: (guestName) => `Oznaczyć ${guestName} jako niestawienie się?`,
        title: 'Niestawienie się',
      },
      notify: 'Powiadom',
      noshow: 'Niestawienie się',
      remove: 'Usuń',
    },
    error: {
      loading: 'Nie udało się załadować listy oczekujących',
    },
    empty: {
      title: 'Nikt nie czeka',
      description:
        'Gdy przyjdzie grupa, a żaden stolik nie jest wolny, dodaj ją tutaj i podaj szacowany czas oczekiwania. Naciśnij +.',
    },
    status: {
      notified: 'Powiadomiony',
    },
  },

  shared: {
    restaurantNotFound: 'Ta restauracja już nie istnieje - wybierz inną.',
    failedLoadRestaurantConfig: 'Nie udało się załadować konfiguracji restauracji.',
    unableToConnect: 'Nie można się połączyć. Sprawdź swoje połączenie.',
    retry: 'Ponów',
    chooseAnotherRestaurant: 'Wybierz inną restaurację',
    language: 'Język',
    empty: 'puste',
    noRestaurantsAvailable: 'Brak dostępnych restauracji.',
    restaurant: 'Restauracja',
  },

  forms: {
    required: 'To pole jest wymagane.',
    tooLong: (max) => `Maksymalnie ${max} znaków.`,
    invalidEmail: 'Podaj prawidłowy e-mail, np. kontakt@restauracja.pl.',
    invalid: 'Sprawdź tę wartość.',
    invalidUrl: 'Podaj prawidłowy adres strony.',
  },

  // Order label settings (create / rename / recolor the triage tag set).
  purge: {
    history: {
      pageTitle: 'Historia ukrywania',
      couldntLoad: 'Nie udało się wczytać historii',
      empty: 'Jeszcze nic nie uporządkowano',
      emptyWhy: 'Gdy coś zostanie ukryte — przez Ciebie lub w nocy — pojawi się tutaj.',
      footer: 'Zachowane, abyś zawsze widział, co zostało ukryte i dlaczego.',
      hidSummary: (what: string) => `Ukryto ${what}`,
      orders: (n: number) => `${n.toLocaleString()} zam.`,
      reservations: (n: number) => `${n.toLocaleString()} rez.`,
      statusLabel: {
        RUNNING: 'W toku',
        COMPLETED: 'Gotowe',
        PARTIAL: 'Tylko częściowo',
        FAILED: 'Nie zakończono',
      },
      sourceLabel: {
        SCHEDULED: 'W nocy',
        MANUAL_RULE: 'Ręcznie',
        MANUAL_CRITERIA: 'Ręcznie',
        MANUAL_SELECTION: 'Ręcznie',
      },
      detailTitle: 'Szczegóły porządkowania',
      when: 'Kiedy',
      outcome: 'Wynik',
      hiddenCount: 'Ukryte pozycje',
      startedBy: 'Uruchomiono',
      criteriaTitle: 'Czego szukano',
      whatKind: 'Rodzaj',
      fromRule: 'Reguła',
      olderThan: 'Starsze niż',
      tags: 'Tagi',
      pickedByHand: 'Wybrane ręcznie',
      criteriaFrozen:
        'Zapisane w postaci z tamtej chwili — późniejsza zmiana nazwy tego nie zmieni.',
      skippedTitle: 'Pominięte',
      skippedFooter: 'Pasowały, ale były chronione. Nic z tego nie zostało ukryte.',
      skipReason: {
        STILL_LIVE: 'Wciąż aktywne',
        CARRIES_MONEY: 'Dotyczy płatności',
        CONCURRENT_CHANGE: 'Zmienione w trakcie',
        CAP_REACHED: 'Za dużo naraz',
      },
      errorTitle: 'Co poszło nie tak',
    },
    cleanupTitle: 'Uporządkuj teraz',
    cleanupIntro:
      'Ukryj naraz wiele starych, zakończonych pozycji. Nic nie jest usuwane, ale ukryte zamówienia przestają być liczone w raportach sprzedaży.',
    cleanupTagsTitle: 'Ogranicz do tagów',
    pickATagToCount: 'Wybierz co najmniej jeden tag, aby zobaczyć, ile pozycji zostałoby ukrytych.',
    cleanupSomeTags: 'Obejmuje tylko pozycje z jednym z powyższych tagów.',
    cleanupReassurance:
      'Tylko zrealizowane i anulowane zamówienia kwalifikują się. Zamówienie jest uwzględniane, gdy: brak zapisu płatności, płatność została odrzucona lub unieważniona, zostało zrealizowane i opłacone gotówką, lub zostało anulowane z pełnym zwrotem.',
    working: 'Pracuję…',
    confirmTitle: 'Ukryć te pozycje?',
    zeroDayAutoTitle: 'Porządkować od dziś?',
    zeroDayAutoBody:
      'Przy „Przed dziś" i włączonej automatyzacji każde dopasowane pozycje starsze niż północ są usuwane przy każdym zaplanowanym uruchomieniu, także dzisiejsze. Tego nie można cofnąć. Kontynuować?',
    autoTitle: 'Automatyczne ukrywanie',
    autoOnFooter:
      'Działa według harmonogramu w ustawieniach zaawansowanych. Nadal możesz porządkować ręcznie w każdej chwili.',
    pageTitle: 'Uporządkuj listy',
    intro:
      'Stare zakończone wpisy są ukrywane na listach, a nie usuwane. Ukryte zamówienia przestają być liczone w raportach sprzedaży, a każde porządkowanie, które uruchomisz, jest w Historii ukrywania.',
    couldntLoad: 'Nie udało się wczytać ustawień porządkowania',
    noAccess: 'Nie masz dostępu do tej strony',
    couldNotSave: 'Nie udało się zapisać. Spróbuj ponownie.',
    noLabels: 'Nie ma jeszcze żadnych tagów.',
    pickATagFirst: 'Wybierz co najmniej jeden tag przed włączeniem.',
    dayRequired: 'Zostaw zaznaczony co najmniej jeden dzień.',
    counting: 'Liczenie…',
    couldntCount: 'Nie udało się teraz policzyć. Sprawdź połączenie i spróbuj ponownie.',
    seeThem: 'Zobacz',
    close: 'Zamknij',
    loadMore: 'Wczytaj więcej',
    nothingToShow: 'Nie ma nic do pokazania.',
    showingOf: (a: number, b: number) => `Pokazano ${a} z ${b.toLocaleString()}.`,
    olderThanOption: (days: number) =>
      days === 0
        ? 'Przed dzisiaj'
        : days === 1
          ? '1 dzień'
          : days === 30
            ? '1 miesiąc'
            : days === 90
              ? '3 miesiące'
              : days === 180
                ? '6 miesięcy'
                : '1 rok',
    advancedTitle: 'Ustawienia zaawansowane',
    advancedFooter: 'Dostrój sposób liczenia wieku i porę nocnego porządkowania.',
    advanced: {
      ageBasisLabel: 'Wiek liczony od',
      ageBasisCreated: 'Momentu utworzenia',
      ageBasisService: 'Czasu obsługi',
      matchLabel: 'Musi mieć',
      matchAny: 'Dowolny z tych tagów',
      matchAll: 'Wszystkie te tagi',
      kindLabel: 'Uruchamia się',
      kindDaily: 'Codziennie',
      kindWeekly: 'Co tydzień',
      kindMonthly: 'Co miesiąc',
      weekdayLabel: 'W',
      monthDayLabel: 'W dniu',
      hourLabel: 'O',
      hourOption: (h: number) => `${String(h).padStart(2, '0')}:00`,
      scheduleFooter:
        'Nocne porządkowanie uruchamia się o tej godzinie, w czasie lokalnym Twojej restauracji.',
    },
    managedInAdvanced: 'Zarządzane przez reguły własne',
    managedInAdvancedFooter: (n: number) =>
      `Ta lista ma ${n} ${n === 1 ? 'regułę własną' : 'reguł własnych'} utworzonych poza tym ekranem. Kontrolki są ukryte, aby nie zmieniły po cichu tylko jednej z nich.`,
    orders: {
      confirmBody: (n: number) =>
        `${n.toLocaleString()} ${n === 1 ? 'zamówienie zostanie ukryte' : 'zamówień zostanie ukrytych'} na tej liście i nie będzie już liczone w raportach sprzedaży.`,
      hideAction: (n: number) => `Ukryj ${n.toLocaleString()}`,
      hidden: (done: number, asked: number) =>
        done === asked
          ? `Ukryto ${done.toLocaleString()}.`
          : `Ukryto ${done.toLocaleString()} z ${asked.toLocaleString()}. Reszta zmieniła się w trakcie wyboru.`,
      title: 'Zamówienia',
      previewTitle: 'Zamówienia, które zostaną ukryte',
      switchTitle: 'Automatycznie porządkuj listę zamówień',
      olderThanLabel: 'Ukryj zrealizowane i anulowane zamówienia starsze niż',
      wouldHide: (n: number) =>
        n === 0
          ? 'Na razie nie ma czego ukryć.'
          : `Teraz ukryłoby to ${n.toLocaleString()} zamówień.`,
    },
    reservations: {
      confirmBody: (n: number) =>
        `${n.toLocaleString()} ${n === 1 ? 'rezerwacja zostanie ukryta' : 'rezerwacji zostanie ukrytych'} na tej liście. Raporty pozostaną bez zmian.`,
      hideAction: (n: number) => `Ukryj ${n.toLocaleString()}`,
      hidden: (done: number, asked: number) =>
        done === asked
          ? `Ukryto ${done.toLocaleString()}.`
          : `Ukryto ${done.toLocaleString()} z ${asked.toLocaleString()}. Reszta zmieniła się w trakcie wyboru.`,
      title: 'Rezerwacje',
      previewTitle: 'Rezerwacje, które zostaną ukryte',
      switchTitle: 'Automatycznie porządkuj listę rezerwacji',
      olderThanLabel: 'Ukryj zakończone rezerwacje starsze niż',
      wouldHide: (n: number) =>
        n === 0
          ? 'Na razie nie ma czego ukryć.'
          : `Teraz ukryłoby to ${n.toLocaleString()} rezerwacji.`,
    },
  },
  labels: {
    none: 'Brak etykiet.',
    setUp: 'Skonfiguruj etykiety',
    couldNotAssign: 'Nie udało się zapisać etykiet. Spróbuj ponownie.',
    more: (n: number) => `+${n}`,
    systemOwnedNote:
      'To wbudowana etykieta. Możesz zmienić jej nazwę lub kolor, ale nie możesz jej usunąć.',
    pageTitle: 'Etykiety',
    addLabel: 'Nowa etykieta',
    editLabel: 'Edytuj etykietę',
    nameLabel: 'Nazwa',
    namePlaceholder: 'np. VIP',
    nameRequired: 'Podaj nazwę etykiety.',
    colorLabel: 'Kolor',
    customColor: 'Własny kolor',
    preview: 'Podgląd',
    labelAdded: 'Dodano etykietę',
    labelUpdated: 'Zaktualizowano etykietę',
    labelDeleted: 'Usunięto etykietę',
    deleteTitle: 'Usuń etykietę',
    deleteConfirmation: (name: string) =>
      `Usunąć „${name}”? Zostanie zdjęta ze wszystkich zamówień.`,
    couldNotSave: 'Nie udało się zapisać etykiety.',
    couldNotDelete: 'Nie udało się usunąć etykiety.',
    couldntLoadLabels: 'Nie udało się wczytać etykiet',
    noLabelsTitle: 'Brak etykiet',
    noLabelsDescription:
      'Utwórz etykiety takie jak „VIP” czy „Reklamacja”, a potem dotknij, by oznaczyć zamówienie dla zespołu.',
    listFooter:
      'Personel może przypiąć je do dowolnego zamówienia online. Usunięcie etykiety zdejmuje ją ze wszystkich zamówień.',
    cancel: 'Anuluj',
  },
  suspension: {
    heading: 'Ta restauracja została zawieszona',
    body: 'Dostęp do aplikacji jest tymczasowo wstrzymany. Skontaktuj się z pomocą techniczną, aby go przywrócić.',
    reasonLabel: 'Powód',
    contactLabel: 'Pomoc techniczna',
    whatsApp: 'Napisz na WhatsAppie',
    checkAgain: 'Sprawdź ponownie',
  },
  voiceInput: {
    start: 'Dyktuj',
    stop: 'Zakończ dyktowanie',
    recordingOnly: 'Nagrywanie — tekst pojawi się po zatrzymaniu.',
    permissionDenied:
      'Dostęp do mikrofonu jest wyłączony. Zezwól na niego w ustawieniach urządzenia lub przeglądarki, aby dyktować.',
    noMicrophone: 'Na tym urządzeniu nie znaleziono mikrofonu.',
    unsupported: 'Dyktowanie nie jest dostępne na tym urządzeniu.',
    failed: 'Nie udało się zamienić mowy na tekst. Spróbuj ponownie.',
  },
};
